export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  E164: { input: unknown; output: unknown };
  Email: { input: string; output: string };
  FieldSet: { input: unknown; output: unknown };
  Map: { input: unknown; output: unknown };
  Password: { input: unknown; output: unknown };
  Time: { input: string; output: string };
  UUID: { input: string; output: string };
  _Any: { input: unknown; output: unknown };
  federation__Policy: { input: unknown; output: unknown };
  federation__Scope: { input: unknown; output: unknown };
};

export type AbandonedPaymentOption = {
  __typename?: "AbandonedPaymentOption";
  label: Scalars["String"]["output"];
  reason: AbandonedPaymentReason;
};

export enum AbandonedPaymentReason {
  ContactSupport = "CONTACT_SUPPORT",
  JustBrowsing = "JUST_BROWSING",
  NeedAssistance = "NEED_ASSISTANCE",
  NeedMoreInformation = "NEED_MORE_INFORMATION",
  NotNow = "NOT_NOW",
  Others = "OTHERS",
  Unsure = "UNSURE",
}

export type AcceptEventTeam = {
  __typename?: "AcceptEventTeam";
  event_id: Scalars["Int"]["output"];
  event_name: Scalars["String"]["output"];
  event_type: Scalars["String"]["output"];
  event_uuid: Scalars["UUID"]["output"];
  event_wallet?: Maybe<Array<Wallet>>;
  first_name: Scalars["String"]["output"];
  last_name: Scalars["String"]["output"];
  role: EventOwnerRole;
};

export type Account = {
  __typename?: "Account";
  accountName?: Maybe<Scalars["String"]["output"]>;
  accountNumber?: Maybe<Scalars["String"]["output"]>;
};

export type AccountDetails = {
  __typename?: "AccountDetails";
  account_number: Scalars["String"]["output"];
  bank_address?: Maybe<Scalars["String"]["output"]>;
  bank_name: Scalars["String"]["output"];
  beneficiary_name: Scalars["String"]["output"];
  city: Scalars["String"]["output"];
  country: Scalars["String"]["output"];
  currency: Currency;
  custom_fields?: Maybe<Array<AccountDetailsCustomField>>;
  event_id: Scalars["Int"]["output"];
  id: Scalars["UUID"]["output"];
  post_code: Scalars["String"]["output"];
  sort_code: Scalars["String"]["output"];
  swift_code: Scalars["String"]["output"];
};

export type AccountDetailsCustomField = {
  __typename?: "AccountDetailsCustomField";
  field_name: Scalars["String"]["output"];
  field_value: Scalars["String"]["output"];
};

export type AccountDetailsCustomFieldInput = {
  field_name: Scalars["String"]["input"];
  field_value: Scalars["String"]["input"];
};

export type ActionCount = {
  __typename?: "ActionCount";
  action: AuditAction;
  count: Scalars["Int"]["output"];
};

export type AddEventPartRequest = {
  address: Scalars["String"]["input"];
  address_description?: InputMaybe<Scalars["String"]["input"]>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  eventPartTimezone?: InputMaybe<Scalars["String"]["input"]>;
  event_id: Scalars["Int"]["input"];
  geo_position?: InputMaybe<GeoPositionInput>;
  image?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  part: Scalars["String"]["input"];
  programs?: InputMaybe<Array<InputMaybe<EventPartProgramInput>>>;
  state?: InputMaybe<Scalars["String"]["input"]>;
  time: Scalars["String"]["input"];
  welcome_msg?: InputMaybe<Scalars["String"]["input"]>;
};

export type AddEventVendorRequest = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  event_id: Scalars["Int"]["input"];
  facebook?: InputMaybe<Scalars["String"]["input"]>;
  image?: InputMaybe<Scalars["String"]["input"]>;
  instagram_handle?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  phone_number: Scalars["String"]["input"];
  role: Scalars["String"]["input"];
  twitter?: InputMaybe<Scalars["String"]["input"]>;
};

export type AddOwnerRequest = {
  admin?: InputMaybe<Scalars["Boolean"]["input"]>;
  event_id: Scalars["Int"]["input"];
  user_id: Scalars["Int"]["input"];
};

export type AddToInviteListReq = {
  admits?: InputMaybe<Scalars["Int"]["input"]>;
  category_id?: InputMaybe<Scalars["Int"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  first_name: Scalars["String"]["input"];
  invitation_id?: InputMaybe<Scalars["UUID"]["input"]>;
  last_name: Scalars["String"]["input"];
  other_name?: InputMaybe<Scalars["String"]["input"]>;
  phone: Scalars["String"]["input"];
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type Album = {
  __typename?: "Album";
  Media: PaginatedAlbumMedia;
  created_at: Scalars["Time"]["output"];
  created_by?: Maybe<Scalars["UUID"]["output"]>;
  creator?: Maybe<Creator>;
  description?: Maybe<Scalars["String"]["output"]>;
  event_id: Scalars["UUID"]["output"];
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Time"]["output"]>;
};

export type AlbumMediaArgs = {
  page?: InputMaybe<Scalars["Int"]["input"]>;
  page_size?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AlbumMedia = {
  __typename?: "AlbumMedia";
  album?: Maybe<Album>;
  album_id?: Maybe<Scalars["UUID"]["output"]>;
  cloudfront_url?: Maybe<Scalars["String"]["output"]>;
  created_at?: Maybe<Scalars["Time"]["output"]>;
  event_id?: Maybe<Scalars["UUID"]["output"]>;
  id: Scalars["String"]["output"];
  likes?: Maybe<Scalars["Int"]["output"]>;
  meta?: Maybe<MediaMeta>;
  name?: Maybe<Scalars["String"]["output"]>;
  order_index?: Maybe<Scalars["Float"]["output"]>;
  private?: Maybe<Scalars["Boolean"]["output"]>;
  tags: Array<Maybe<AlbumMediaTag>>;
  type?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Time"]["output"]>;
  url?: Maybe<Scalars["String"]["output"]>;
  user_id?: Maybe<Scalars["UUID"]["output"]>;
  user_type?: Maybe<UserTypeEnum>;
};

export enum AlbumMediaTag {
  BestMan = "best_man",
  Bride = "bride",
  Bridesmaid = "bridesmaid",
  Couple = "couple",
  Family = "family",
  Friends = "friends",
  Groom = "groom",
  HeroPage = "hero_page",
  Others = "others",
  Showcase = "showcase",
}

export type Aseobi = {
  __typename?: "Aseobi";
  aseobi_orders?: Maybe<Array<Maybe<AseobiOrder>>>;
  asoebi_packages_enabled: Scalars["Boolean"]["output"];
  category_id?: Maybe<Scalars["UUID"]["output"]>;
  contacts?: Maybe<Array<Maybe<AseobiContact>>>;
  created_at: Scalars["Time"]["output"];
  currency_iso?: Maybe<Currency>;
  deadline: Scalars["Time"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  event_id: Scalars["UUID"]["output"];
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  payment_provider?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<AsoebiStatusEnum>;
  sub_account_code?: Maybe<Scalars["String"]["output"]>;
  sub_account_id?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Time"]["output"]>;
};

export type AseobiAttire = {
  __typename?: "AseobiAttire";
  active: Scalars["Boolean"]["output"];
  aseobi: Aseobi;
  aseobi_id: Scalars["UUID"]["output"];
  aseobi_orders?: Maybe<Array<Maybe<AseobiOrder>>>;
  created_at: Scalars["Time"]["output"];
  currency_iso: Scalars["String"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  event_id: Scalars["UUID"]["output"];
  fee_percentage: Scalars["Float"]["output"];
  id: Scalars["UUID"]["output"];
  images?: Maybe<Array<Scalars["String"]["output"]>>;
  markup_percentage: Scalars["Float"]["output"];
  minimum_purchase_quantity?: Maybe<Scalars["Int"]["output"]>;
  minimum_yards: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
  price_per_yard: Scalars["Float"]["output"];
  size_unit: Scalars["String"]["output"];
  total_price_per_yard: Scalars["Float"]["output"];
  updated_at?: Maybe<Scalars["Time"]["output"]>;
  vendor: AseobiVendorEnum;
  vendor_product_id?: Maybe<Scalars["Int"]["output"]>;
  yards_available: Scalars["Int"]["output"];
  yards_sold: Scalars["Int"]["output"];
};

export type AseobiAttireInput = {
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  aseobi_id: Scalars["UUID"]["input"];
  currency_iso: Currency;
  description?: InputMaybe<Scalars["String"]["input"]>;
  images?: InputMaybe<Array<Scalars["String"]["input"]>>;
  minimum_yards?: InputMaybe<Scalars["Int"]["input"]>;
  name: Scalars["String"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
  price_per_yard: Scalars["Float"]["input"];
  yards_available: Scalars["Int"]["input"];
};

export type AseobiAttirePresignUrlResponse = {
  __typename?: "AseobiAttirePresignURLResponse";
  attire_id: Scalars["UUID"]["output"];
  event_id: Scalars["UUID"]["output"];
  expiry_time: Scalars["Time"]["output"];
  expiry_time_in_seconds: Scalars["Int"]["output"];
  file_uri: Scalars["String"]["output"];
  upload_url: Scalars["String"]["output"];
};

export enum AseobiCheckoutStatus {
  Cancelled = "CANCELLED",
  Expired = "EXPIRED",
  Paid = "PAID",
  Pending = "PENDING",
}

export type AseobiContact = {
  __typename?: "AseobiContact";
  default?: Maybe<Scalars["Boolean"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  first_name?: Maybe<Scalars["String"]["output"]>;
  last_name?: Maybe<Scalars["String"]["output"]>;
  note?: Maybe<Scalars["String"]["output"]>;
  phone_number: Scalars["String"]["output"];
};

export enum AseobiLineType {
  Attire = "ATTIRE",
  Package = "PACKAGE",
}

export type AseobiOrder = {
  __typename?: "AseobiOrder";
  aseobi_attire_id: Scalars["UUID"]["output"];
  aseobi_id: Scalars["UUID"]["output"];
  contact_email: Scalars["String"]["output"];
  contact_phone_number: Scalars["String"]["output"];
  created_at?: Maybe<Scalars["Time"]["output"]>;
  delivery_address?: Maybe<Scalars["String"]["output"]>;
  event_id: Scalars["UUID"]["output"];
  fee_percentage: Scalars["Float"]["output"];
  id: Scalars["UUID"]["output"];
  line_type: AseobiLineType;
  note?: Maybe<Scalars["String"]["output"]>;
  package?: Maybe<AseobiOrderPackageLine>;
  package_id?: Maybe<Scalars["UUID"]["output"]>;
  package_version?: Maybe<Scalars["Int"]["output"]>;
  price_per_yard: Scalars["Float"]["output"];
  provider: Scalars["String"]["output"];
  provider_reference: Scalars["String"]["output"];
  quantity: Scalars["Int"]["output"];
  size_unit: Scalars["String"]["output"];
  status: AseobiOrderStatusEnum;
  total_price: Scalars["Float"]["output"];
  user: User;
  user_id: Scalars["UUID"]["output"];
  vendor: AseobiVendorEnum;
  yards: Scalars["Int"]["output"];
};

export type AseobiOrderAttireLine = {
  __typename?: "AseobiOrderAttireLine";
  attire_id: Scalars["UUID"]["output"];
  fee_percentage: Scalars["Float"]["output"];
  price_per_yard: Scalars["Float"]["output"];
  size_unit: Scalars["String"]["output"];
  yards: Scalars["Int"]["output"];
};

export type AseobiOrderPackageLine = {
  __typename?: "AseobiOrderPackageLine";
  component_totals: Array<AseobiPackingTotal>;
  components: Array<AseobiPackageItem>;
  cover_image?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  fee_amount: Scalars["Float"]["output"];
  fee_percentage: Scalars["Float"]["output"];
  images: Array<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  package_id: Scalars["UUID"]["output"];
  package_version: Scalars["Int"]["output"];
  subtotal: Scalars["Float"]["output"];
  total: Scalars["Float"]["output"];
  unit_fee: Scalars["Float"]["output"];
  unit_price: Scalars["Float"]["output"];
};

export enum AseobiOrderStatusEnum {
  Delivered = "DELIVERED",
  Disputed = "DISPUTED",
  Processing = "PROCESSING",
  Rejected = "REJECTED",
}

export type AseobiOrderV2 = {
  __typename?: "AseobiOrderV2";
  aseobi_id: Scalars["UUID"]["output"];
  checkout_id?: Maybe<Scalars["UUID"]["output"]>;
  contact_email: Scalars["String"]["output"];
  contact_phone_number: Scalars["String"]["output"];
  created_at: Scalars["Time"]["output"];
  currency?: Maybe<Scalars["String"]["output"]>;
  delivery_address?: Maybe<Scalars["String"]["output"]>;
  delivery_city?: Maybe<Scalars["String"]["output"]>;
  delivery_fee: Scalars["Float"]["output"];
  delivery_zip_code?: Maybe<Scalars["String"]["output"]>;
  event_id: Scalars["UUID"]["output"];
  fulfilment_status: AseobiOrderStatusEnum;
  late_fee: Scalars["Float"]["output"];
  lines: Array<AseobiOrderV2Line>;
  note?: Maybe<Scalars["String"]["output"]>;
  packing_totals: Array<AseobiPackingTotal>;
  paid_amount?: Maybe<Scalars["Float"]["output"]>;
  paid_currency?: Maybe<Scalars["String"]["output"]>;
  payment_provider: Scalars["String"]["output"];
  payment_reference?: Maybe<Scalars["String"]["output"]>;
  payment_status: AseobiPaymentStatus;
  payment_total: Scalars["Float"]["output"];
  purchaser_id: Scalars["UUID"]["output"];
  reference: Scalars["String"]["output"];
  service_fee: Scalars["Float"]["output"];
  subtotal: Scalars["Float"]["output"];
  transaction_charge: Scalars["Float"]["output"];
  vat: Scalars["Float"]["output"];
};

export type AseobiOrderV2Line = {
  __typename?: "AseobiOrderV2Line";
  attire?: Maybe<AseobiOrderAttireLine>;
  currency?: Maybe<Scalars["String"]["output"]>;
  fulfilment_status: AseobiOrderStatusEnum;
  id: Scalars["UUID"]["output"];
  line_total: Scalars["Float"]["output"];
  line_type: AseobiLineType;
  package?: Maybe<AseobiOrderPackageLine>;
  quantity: Scalars["Int"]["output"];
  service_fee: Scalars["Float"]["output"];
  subtotal: Scalars["Float"]["output"];
  unit_price: Scalars["Float"]["output"];
  vendor: Scalars["String"]["output"];
};

export type AseobiPackage = {
  __typename?: "AseobiPackage";
  archived_at?: Maybe<Scalars["Time"]["output"]>;
  aseobi_id: Scalars["UUID"]["output"];
  available_quantity: Scalars["Int"]["output"];
  cover_image?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Time"]["output"];
  currency_iso: Scalars["String"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  event_id: Scalars["UUID"]["output"];
  id: Scalars["UUID"]["output"];
  images: Array<Scalars["String"]["output"]>;
  items: Array<AseobiPackageItem>;
  name: Scalars["String"]["output"];
  price?: Maybe<Scalars["Float"]["output"]>;
  published_at?: Maybe<Scalars["Time"]["output"]>;
  reserved_quantity?: Maybe<Scalars["Int"]["output"]>;
  sold_out: Scalars["Boolean"]["output"];
  sold_quantity?: Maybe<Scalars["Int"]["output"]>;
  status: AseobiPackageStatus;
  stock_quantity?: Maybe<Scalars["Int"]["output"]>;
  updated_at: Scalars["Time"]["output"];
  version: Scalars["Int"]["output"];
};

export type AseobiPackageItem = {
  __typename?: "AseobiPackageItem";
  description?: Maybe<Scalars["String"]["output"]>;
  display_order: Scalars["Int"]["output"];
  id: Scalars["UUID"]["output"];
  images: Array<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  quantity: Scalars["Float"]["output"];
  unit: AseobiPackageItemUnit;
};

export type AseobiPackageItemInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  images?: InputMaybe<Array<Scalars["String"]["input"]>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  quantity?: InputMaybe<Scalars["Float"]["input"]>;
  unit?: InputMaybe<AseobiPackageItemUnit>;
};

export enum AseobiPackageItemUnit {
  Metre = "METRE",
  Pair = "PAIR",
  Piece = "PIECE",
  Set = "SET",
  Yard = "YARD",
}

export type AseobiPackageMediaUploadResponse = {
  __typename?: "AseobiPackageMediaUploadResponse";
  event_id: Scalars["UUID"]["output"];
  expiry_time: Scalars["Time"]["output"];
  expiry_time_in_seconds: Scalars["Int"]["output"];
  file_uri: Scalars["String"]["output"];
  item_id?: Maybe<Scalars["UUID"]["output"]>;
  package_id: Scalars["UUID"]["output"];
  upload_url: Scalars["String"]["output"];
};

export enum AseobiPackageStatus {
  Archived = "ARCHIVED",
  Draft = "DRAFT",
  Published = "PUBLISHED",
}

export type AseobiPackingTotal = {
  __typename?: "AseobiPackingTotal";
  component_id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  package_count: Scalars["Int"]["output"];
  package_id: Scalars["UUID"]["output"];
  quantity: Scalars["Float"]["output"];
  unit: AseobiPackageItemUnit;
};

export type AseobiPaymentMetadataRequest = {
  aseobi_id: Scalars["UUID"]["input"];
  attires?: Array<AseobiPaymentMetadataRequestAttire>;
  contact_email: Scalars["String"]["input"];
  contact_phone: Scalars["String"]["input"];
  currency: Currency;
  delivery_address?: InputMaybe<Scalars["String"]["input"]>;
  delivery_city?: InputMaybe<Scalars["String"]["input"]>;
  delivery_state?: InputMaybe<Scalars["String"]["input"]>;
  delivery_zip_code?: InputMaybe<Scalars["String"]["input"]>;
  idempotency_key?: InputMaybe<Scalars["String"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
  packages?: Array<AseobiPaymentMetadataRequestPackage>;
  payment_provider: PaymentProcessor;
  user_id: Scalars["UUID"]["input"];
};

export type AseobiPaymentMetadataRequestAttire = {
  aseobi_id: Scalars["UUID"]["input"];
  attire_id: Scalars["UUID"]["input"];
  quantity: Scalars["Int"]["input"];
  yards: Scalars["Int"]["input"];
};

export type AseobiPaymentMetadataRequestPackage = {
  package_id: Scalars["UUID"]["input"];
  package_version: Scalars["Int"]["input"];
  quantity: Scalars["Int"]["input"];
};

export enum AseobiPaymentStatus {
  Paid = "PAID",
}

export enum AseobiVendorEnum {
  Couple = "COUPLE",
  Oyple = "OYPLE",
}

export type AsoebiCheckoutSummary = {
  __typename?: "AsoebiCheckoutSummary";
  checkout_id: Scalars["UUID"]["output"];
  currency: Scalars["String"]["output"];
  expires_at: Scalars["Time"]["output"];
  payment_reference: Scalars["String"]["output"];
  status: AseobiCheckoutStatus;
  total_amount: Scalars["Float"]["output"];
};

export type AsoebiPaymentMetaData = {
  __typename?: "AsoebiPaymentMetaData";
  aseobi_asset: AsoebiPaymentMetadataAsset;
  aseobi_id: Scalars["UUID"]["output"];
  attires: Array<AsoebiPaymentMetadataAttire>;
  checkout_id?: Maybe<Scalars["UUID"]["output"]>;
  contact_email: Scalars["String"]["output"];
  contact_phone_number: Scalars["String"]["output"];
  currency: Currency;
  custom_fields: Array<PaymentMetaDataCustomField>;
  delivery_address?: Maybe<Scalars["String"]["output"]>;
  delivery_city?: Maybe<Scalars["String"]["output"]>;
  delivery_fee: Scalars["Float"]["output"];
  delivery_zip_code?: Maybe<Scalars["String"]["output"]>;
  event_id: Scalars["UUID"]["output"];
  expires_at?: Maybe<Scalars["Time"]["output"]>;
  hash: Scalars["String"]["output"];
  inawo_product: Scalars["String"]["output"];
  late_fee: Scalars["Float"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
  packages: Array<AsoebiPaymentMetadataPackage>;
  payment_provider: Scalars["String"]["output"];
  payment_reference: Scalars["String"]["output"];
  split_payments: Array<SplitPayments>;
  timestamp: Scalars["Time"]["output"];
  total_amount: Scalars["Float"]["output"];
  total_payment_intent_amount: Scalars["Float"]["output"];
  transaction_charge: Scalars["Float"]["output"];
  user_id: Scalars["UUID"]["output"];
  vat: Scalars["Float"]["output"];
  vendors: Array<AsoebiPaymentMetaDataVendor>;
};

export enum AsoebiPaymentMetaDataVendor {
  Couple = "COUPLE",
  Oyple = "OYPLE",
}

export type AsoebiPaymentMetadataAsset = {
  __typename?: "AsoebiPaymentMetadataAsset";
  category_id?: Maybe<Scalars["UUID"]["output"]>;
  created_by: Scalars["UUID"]["output"];
  currency_iso: Scalars["String"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  oyple_event_id?: Maybe<Scalars["Int"]["output"]>;
  oyple_group_id?: Maybe<Scalars["Int"]["output"]>;
  oyple_user_id?: Maybe<Scalars["Int"]["output"]>;
  payment_provider: Scalars["String"]["output"];
  sub_account_code: Scalars["String"]["output"];
  sub_account_id: Scalars["String"]["output"];
};

export type AsoebiPaymentMetadataAttire = {
  __typename?: "AsoebiPaymentMetadataAttire";
  aseobi_id: Scalars["UUID"]["output"];
  attire_id: Scalars["UUID"]["output"];
  fee_percentage: Scalars["Float"]["output"];
  mark_up_percentage: Scalars["Float"]["output"];
  order_id: Scalars["UUID"]["output"];
  price_per_size_unit: Scalars["Float"]["output"];
  quantity: Scalars["Int"]["output"];
  size: Scalars["Int"]["output"];
  size_unit: Scalars["String"]["output"];
  total_price: Scalars["Float"]["output"];
  total_price_per_quantity: Scalars["Float"]["output"];
  vendor: AsoebiPaymentMetaDataVendor;
  vendor_order_id?: Maybe<Scalars["Int"]["output"]>;
  vendor_product_id?: Maybe<Scalars["Int"]["output"]>;
};

export type AsoebiPaymentMetadataPackage = {
  __typename?: "AsoebiPaymentMetadataPackage";
  components: Array<AseobiPackageItem>;
  cover_image?: Maybe<Scalars["String"]["output"]>;
  currency: Scalars["String"]["output"];
  fee_amount: Scalars["Float"]["output"];
  fee_percentage: Scalars["Float"]["output"];
  line_id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  package_id: Scalars["UUID"]["output"];
  package_version: Scalars["Int"]["output"];
  quantity: Scalars["Int"]["output"];
  subtotal: Scalars["Float"]["output"];
  total: Scalars["Float"]["output"];
  unit_fee: Scalars["Float"]["output"];
  unit_price: Scalars["Float"]["output"];
};

export enum AsoebiStatusEnum {
  AsoebiStatusActive = "AsoebiStatusActive",
  AsoebiStatusArchived = "AsoebiStatusArchived",
  AsoebiStatusDraft = "AsoebiStatusDraft",
}

export type AttachDomainInput = {
  domain_id: Scalars["UUID"]["input"];
  event_id: Scalars["UUID"]["input"];
};

export enum AuditAction {
  CheckIn = "CHECK_IN",
  Create = "CREATE",
  Delete = "DELETE",
  Export = "EXPORT",
  Invite = "INVITE",
  Login = "LOGIN",
  Logout = "LOGOUT",
  Message = "MESSAGE",
  Payment = "PAYMENT",
  Reserve = "RESERVE",
  Rsvp = "RSVP",
  Send = "SEND",
  Share = "SHARE",
  Update = "UPDATE",
  Upload = "UPLOAD",
  View = "VIEW",
}

export type AuditFilter = {
  action?: InputMaybe<AuditAction>;
  end_date?: InputMaybe<Scalars["Time"]["input"]>;
  event_id?: InputMaybe<Scalars["UUID"]["input"]>;
  resource?: InputMaybe<AuditResource>;
  resource_id?: InputMaybe<Scalars["String"]["input"]>;
  search_term?: InputMaybe<Scalars["String"]["input"]>;
  start_date?: InputMaybe<Scalars["Time"]["input"]>;
  success?: InputMaybe<Scalars["Boolean"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type AuditLog = {
  __typename?: "AuditLog";
  action: AuditAction;
  created_at: Scalars["Time"]["output"];
  details?: Maybe<Scalars["Map"]["output"]>;
  error_message?: Maybe<Scalars["String"]["output"]>;
  event_id: Scalars["UUID"]["output"];
  id: Scalars["UUID"]["output"];
  ip_address?: Maybe<Scalars["String"]["output"]>;
  resource: AuditResource;
  resource_id?: Maybe<Scalars["String"]["output"]>;
  resource_name?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
  summary: Scalars["String"]["output"];
  user_agent?: Maybe<Scalars["String"]["output"]>;
  user_email: Scalars["String"]["output"];
  user_id: Scalars["UUID"]["output"];
  user_name?: Maybe<Scalars["String"]["output"]>;
  user_role?: Maybe<Scalars["String"]["output"]>;
};

export enum AuditResource {
  Album = "ALBUM",
  Aseobi = "ASEOBI",
  BackStory = "BACK_STORY",
  Category = "CATEGORY",
  Domain = "DOMAIN",
  Event = "EVENT",
  EventPart = "EVENT_PART",
  Faq = "FAQ",
  Gallery = "GALLERY",
  Guest = "GUEST",
  Invitation = "INVITATION",
  Media = "MEDIA",
  Message = "MESSAGE",
  Payment = "PAYMENT",
  TableReservation = "TABLE_RESERVATION",
  TeamMember = "TEAM_MEMBER",
  User = "USER",
  Vendor = "VENDOR",
  WishList = "WISH_LIST",
}

export type AuditStats = {
  __typename?: "AuditStats";
  action_counts: Array<ActionCount>;
  recent_actions: Array<AuditLog>;
  resource_counts: Array<ResourceCount>;
  top_users: Array<UserActivity>;
  total_actions: Scalars["Int"]["output"];
  unique_users: Scalars["Int"]["output"];
};

export type AuthResponse = {
  __typename?: "AuthResponse";
  access_expiry?: Maybe<Scalars["Time"]["output"]>;
  access_token: Scalars["String"]["output"];
  refresh_expiry?: Maybe<Scalars["Time"]["output"]>;
  refresh_token: Scalars["String"]["output"];
  user?: Maybe<User>;
};

export type AvailableCurrency = {
  __typename?: "AvailableCurrency";
  /** e.g USD, NGN */
  currency: Currency;
  /** e.g Dollar, Naira */
  name: Scalars["String"]["output"];
  /** e.g $, ₦ */
  symbol?: Maybe<Scalars["String"]["output"]>;
};

export type AvailableGiftPaymentCurrency = {
  __typename?: "AvailableGiftPaymentCurrency";
  currency: Currency;
  provider: EventSupportCurrencyProvider;
  sub_account_code: Scalars["String"]["output"];
  sub_account_id: Scalars["String"]["output"];
};

export type BackStory = {
  __typename?: "BackStory";
  created_at?: Maybe<Scalars["Time"]["output"]>;
  event_id: Scalars["Int"]["output"];
  id: Scalars["Int"]["output"];
  image?: Maybe<Scalars["String"]["output"]>;
  role: BackStoryRole;
  story: Scalars["String"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Time"]["output"]>;
  uuid: Scalars["UUID"]["output"];
};

export type BackStoryPresignedUrlResponse = {
  __typename?: "BackStoryPresignedURLResponse";
  event_id: Scalars["UUID"]["output"];
  expiry_time: Scalars["Time"]["output"];
  expiry_time_in_seconds: Scalars["Int"]["output"];
  file_uri: Scalars["String"]["output"];
  upload_url: Scalars["String"]["output"];
};

export enum BackStoryRole {
  Both = "Both",
  Bride = "Bride",
  Groom = "Groom",
}

export type Bank = {
  __typename?: "Bank";
  code?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type BankDetail = {
  __typename?: "BankDetail";
  account_name: Scalars["String"]["output"];
  account_number: Scalars["String"]["output"];
  bank_name: Scalars["String"]["output"];
};

export type Banks = {
  __typename?: "Banks";
  active?: Maybe<Scalars["Boolean"]["output"]>;
  code?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["String"]["output"]>;
  gateway?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  is_deleted?: Maybe<Scalars["Boolean"]["output"]>;
  long_code?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  slug?: Maybe<Scalars["String"]["output"]>;
  updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type Beneficiary = {
  __typename?: "Beneficiary";
  account_name: Scalars["String"]["output"];
  account_number: Scalars["String"]["output"];
  bank_name: Scalars["String"]["output"];
  country: Scalars["String"]["output"];
  created_at: Scalars["Time"]["output"];
  currency: Currency;
  id: Scalars["UUID"]["output"];
  last_used_at?: Maybe<Scalars["Time"]["output"]>;
  meta_data: Scalars["Map"]["output"];
  payment_processor: Scalars["String"]["output"];
  personal: Scalars["Boolean"]["output"];
  updated_at?: Maybe<Scalars["Time"]["output"]>;
  user_id: Scalars["UUID"]["output"];
};

export type BirthdayBankAccount = {
  __typename?: "BirthdayBankAccount";
  account_name: Scalars["String"]["output"];
  account_number: Scalars["String"]["output"];
  bank_code: Scalars["String"]["output"];
  bank_name: Scalars["String"]["output"];
  currency?: Maybe<Currency>;
  provider: Scalars["String"]["output"];
  sub_account_code: Scalars["String"]["output"];
  sub_account_id: Scalars["String"]["output"];
};

export type BirthdayBankAccountInput = {
  account_name: Scalars["String"]["input"];
  account_number: Scalars["String"]["input"];
  bank_code: Scalars["String"]["input"];
  bank_name: Scalars["String"]["input"];
  currency?: InputMaybe<Currency>;
  provider: Scalars["String"]["input"];
  sub_account_code?: InputMaybe<Scalars["String"]["input"]>;
  sub_account_id?: InputMaybe<Scalars["String"]["input"]>;
};

export type BirthdayBankDetailsRequest = {
  account_name: Scalars["String"]["input"];
  account_number: Scalars["String"]["input"];
  bank_code: Scalars["String"]["input"];
  bvn?: InputMaybe<Scalars["String"]["input"]>;
  currency: Currency;
};

export enum BirthdayCardKind {
  Cashgift = "cashgift",
  Countdown = "countdown",
  Message = "message",
  Wishlist = "wishlist",
}

export type BirthdayCardTemplate = {
  __typename?: "BirthdayCardTemplate";
  birthday_id?: Maybe<Scalars["UUID"]["output"]>;
  created_at: Scalars["Time"]["output"];
  description: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  image_url: Scalars["String"]["output"];
  name: BirthdayCardKind;
  title: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Time"]["output"]>;
};

export type BirthdayCardTemplateInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  image_url?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type BirthdayGiftPaymentMetaData = {
  __typename?: "BirthdayGiftPaymentMetaData";
  birthday_id: Scalars["UUID"]["output"];
  contact_email?: Maybe<Scalars["String"]["output"]>;
  contact_phone_number?: Maybe<Scalars["String"]["output"]>;
  currency_iso: Scalars["String"]["output"];
  custom_fields: Array<BirthdayPaymentMetaDataCustomField>;
  full_name?: Maybe<Scalars["String"]["output"]>;
  gift_id: Scalars["UUID"]["output"];
  hash: Scalars["String"]["output"];
  inawo_product: Scalars["String"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
  payment_provider: Scalars["String"]["output"];
  payment_reference: Scalars["String"]["output"];
  split_payments?: Maybe<Array<BirthdaySplitPayments>>;
  split_percentage: Scalars["Float"]["output"];
  sub_account_code: Scalars["String"]["output"];
  sub_account_id: Scalars["String"]["output"];
  timestamp: Scalars["Time"]["output"];
  total_payment_intent_amount: Scalars["Float"]["output"];
  user_id?: Maybe<Scalars["UUID"]["output"]>;
  wish_list_item_id?: Maybe<Scalars["UUID"]["output"]>;
};

export type BirthdayGiftPaymentMetadataRequest = {
  amount: Scalars["Float"]["input"];
  birthday_id: Scalars["UUID"]["input"];
  contact_email?: InputMaybe<Scalars["String"]["input"]>;
  contact_phone?: InputMaybe<Scalars["String"]["input"]>;
  currency: Currency;
  full_name?: InputMaybe<Scalars["String"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
  payment_provider: PaymentProcessor;
  wish_list_item_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type BirthdayInitiatePaymentInput = {
  customer_email: Scalars["Email"]["input"];
  inawo_payment_reference: Scalars["String"]["input"];
};

export type BirthdayInput = {
  age?: InputMaybe<Scalars["Int"]["input"]>;
  bank_account?: InputMaybe<BirthdayBankAccountInput>;
  birth_date?: InputMaybe<Scalars["Time"]["input"]>;
  default_currency_iso?: InputMaybe<Currency>;
  event_date?: InputMaybe<Scalars["Time"]["input"]>;
  gifts_enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  hashtag?: InputMaybe<Scalars["String"]["input"]>;
  hero_image?: InputMaybe<Scalars["String"]["input"]>;
  main_photo?: InputMaybe<Scalars["String"]["input"]>;
  meta?: InputMaybe<Scalars["Map"]["input"]>;
  name: Scalars["String"]["input"];
  slug?: InputMaybe<Scalars["String"]["input"]>;
  timezone?: InputMaybe<Scalars["String"]["input"]>;
  venue?: InputMaybe<Scalars["String"]["input"]>;
  venue_address?: InputMaybe<Scalars["String"]["input"]>;
  vibe?: InputMaybe<Scalars["String"]["input"]>;
};

export enum BirthdayMediaKind {
  CashgiftCard = "cashgift_card",
  CountdownCard = "countdown_card",
  Hero = "hero",
  Main = "main",
  MessageCard = "message_card",
  WishlistCard = "wishlist_card",
}

export type BirthdayMediaPresignUrlResponse = {
  __typename?: "BirthdayMediaPresignURLResponse";
  birthday_id: Scalars["UUID"]["output"];
  expiry_time: Scalars["Time"]["output"];
  expiry_time_in_seconds: Scalars["Int"]["output"];
  file_uri: Scalars["String"]["output"];
  kind: BirthdayMediaKind;
  upload_url: Scalars["String"]["output"];
};

export type BirthdayPaymentMetaDataCustomField = {
  __typename?: "BirthdayPaymentMetaDataCustomField";
  display_name: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
  variable_name: Scalars["String"]["output"];
};

export type BirthdaySplitPayments = {
  __typename?: "BirthdaySplitPayments";
  couples_account: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  split_percentage: Scalars["Float"]["output"];
  sub_account_code: Scalars["String"]["output"];
  sub_account_id: Scalars["String"]["output"];
};

export enum BirthdayStatus {
  Archived = "archived",
  Draft = "draft",
  Published = "published",
}

export type BirthdayWishInput = {
  email?: InputMaybe<Scalars["Email"]["input"]>;
  message?: InputMaybe<Scalars["String"]["input"]>;
  phone: Scalars["String"]["input"];
  sender_name: Scalars["String"]["input"];
  video_url?: InputMaybe<Scalars["String"]["input"]>;
};

export type BirthdayWishVideo = {
  __typename?: "BirthdayWishVideo";
  content_type: Scalars["String"]["output"];
  size_bytes: Scalars["Int"]["output"];
  url: Scalars["String"]["output"];
};

export type BirthdayWishVideoPresignUrlResponse = {
  __typename?: "BirthdayWishVideoPresignURLResponse";
  birthday_id: Scalars["UUID"]["output"];
  expiry_time: Scalars["Time"]["output"];
  expiry_time_in_seconds: Scalars["Int"]["output"];
  file_uri: Scalars["String"]["output"];
  max_size_bytes: Scalars["Int"]["output"];
  upload_url: Scalars["String"]["output"];
};

export type BookingAccommodationAvailability = {
  __typename?: "BookingAccommodationAvailability";
  accommodation_id?: Maybe<Scalars["Int"]["output"]>;
  products?: Maybe<Array<BookingAccommodationProduct>>;
};

export type BookingAccommodationDetails = {
  __typename?: "BookingAccommodationDetails";
  address?: Maybe<Scalars["String"]["output"]>;
  amenities?: Maybe<Array<Scalars["String"]["output"]>>;
  city?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  image_urls?: Maybe<Array<Scalars["String"]["output"]>>;
  name?: Maybe<Scalars["String"]["output"]>;
  price?: Maybe<BookingMoney>;
  provider_metadata?: Maybe<Scalars["Map"]["output"]>;
  rooms?: Maybe<Array<BookingAccommodationRoom>>;
};

export type BookingAccommodationProduct = {
  __typename?: "BookingAccommodationProduct";
  price?: Maybe<BookingMoney>;
  rate_id?: Maybe<Scalars["String"]["output"]>;
  room_id?: Maybe<Scalars["String"]["output"]>;
};

export type BookingAccommodationRoom = {
  __typename?: "BookingAccommodationRoom";
  capacity?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  price?: Maybe<BookingMoney>;
  refundable?: Maybe<Scalars["Boolean"]["output"]>;
};

export type BookingAccommodationSummary = {
  __typename?: "BookingAccommodationSummary";
  address?: Maybe<Scalars["String"]["output"]>;
  city?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  image_urls?: Maybe<Array<Scalars["String"]["output"]>>;
  name?: Maybe<Scalars["String"]["output"]>;
  price?: Maybe<BookingMoney>;
  provider_metadata?: Maybe<Scalars["Map"]["output"]>;
};

export type BookingAccommodationsAvailabilityInput = {
  accommodation_ids: Array<Scalars["Int"]["input"]>;
  checkin: Scalars["Time"]["input"];
  checkout: Scalars["Time"]["input"];
  guests: BookingGuestAllocationInput;
  rooms?: InputMaybe<Scalars["Int"]["input"]>;
};

export type BookingAccommodationsAvailabilityResult = {
  __typename?: "BookingAccommodationsAvailabilityResult";
  accommodations?: Maybe<Array<BookingAccommodationAvailability>>;
};

export type BookingAccommodationsDetailsInput = {
  accommodation_ids: Array<Scalars["Int"]["input"]>;
  extras?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type BookingAccommodationsDetailsResult = {
  __typename?: "BookingAccommodationsDetailsResult";
  accommodations?: Maybe<Array<BookingAccommodationDetails>>;
};

export type BookingAccommodationsSearchInput = {
  checkin: Scalars["Time"]["input"];
  checkout: Scalars["Time"]["input"];
  destination: Scalars["String"]["input"];
  filters?: InputMaybe<Scalars["Map"]["input"]>;
  guests?: InputMaybe<BookingGuestAllocationInput>;
  pagination?: InputMaybe<BookingPaginationInput>;
  rooms?: InputMaybe<Scalars["Int"]["input"]>;
};

export type BookingAccommodationsSearchResult = {
  __typename?: "BookingAccommodationsSearchResult";
  next_page_token?: Maybe<Scalars["String"]["output"]>;
  results?: Maybe<Array<BookingAccommodationSummary>>;
};

export type BookingCarDetails = {
  __typename?: "BookingCarDetails";
  id?: Maybe<Scalars["String"]["output"]>;
  image_urls?: Maybe<Array<Scalars["String"]["output"]>>;
  name?: Maybe<Scalars["String"]["output"]>;
  price?: Maybe<BookingMoney>;
  specs?: Maybe<BookingCarSpecs>;
  supplier?: Maybe<Scalars["String"]["output"]>;
};

export type BookingCarSpecs = {
  __typename?: "BookingCarSpecs";
  bags?: Maybe<Scalars["Int"]["output"]>;
  doors?: Maybe<Scalars["Int"]["output"]>;
  seats?: Maybe<Scalars["Int"]["output"]>;
  transmission?: Maybe<Scalars["String"]["output"]>;
};

export type BookingCarSummary = {
  __typename?: "BookingCarSummary";
  id?: Maybe<Scalars["String"]["output"]>;
  image_urls?: Maybe<Array<Scalars["String"]["output"]>>;
  name?: Maybe<Scalars["String"]["output"]>;
  price?: Maybe<BookingMoney>;
  supplier?: Maybe<Scalars["String"]["output"]>;
};

export type BookingCarsDetailsInput = {
  car_ids: Array<Scalars["String"]["input"]>;
};

export type BookingCarsDetailsResult = {
  __typename?: "BookingCarsDetailsResult";
  cars?: Maybe<Array<BookingCarDetails>>;
};

export type BookingCarsSearchInput = {
  driver_age?: InputMaybe<Scalars["Int"]["input"]>;
  dropoff_date: Scalars["Time"]["input"];
  dropoff_location?: InputMaybe<Scalars["String"]["input"]>;
  pagination?: InputMaybe<BookingPaginationInput>;
  pickup_date: Scalars["Time"]["input"];
  pickup_location: Scalars["String"]["input"];
};

export type BookingCarsSearchResult = {
  __typename?: "BookingCarsSearchResult";
  results?: Maybe<Array<BookingCarSummary>>;
};

export type BookingGuestAllocationInput = {
  adults?: InputMaybe<Scalars["Int"]["input"]>;
  children_ages?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

export type BookingMoney = {
  __typename?: "BookingMoney";
  amount?: Maybe<Scalars["Float"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
};

export type BookingOrderCreateInput = {
  contact_phone?: InputMaybe<Scalars["String"]["input"]>;
  order_token: Scalars["String"]["input"];
  payment_method?: InputMaybe<Scalars["String"]["input"]>;
};

export type BookingOrderCreateResult = {
  __typename?: "BookingOrderCreateResult";
  order_id?: Maybe<Scalars["String"]["output"]>;
  payment_url?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
};

export type BookingOrderDetailsInput = {
  order_ids?: InputMaybe<Array<Scalars["String"]["input"]>>;
  order_tokens?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type BookingOrderDetailsResult = {
  __typename?: "BookingOrderDetailsResult";
  orders?: Maybe<Array<BookingOrderSummary>>;
};

export type BookingOrderPreviewInput = {
  booker_email?: InputMaybe<Scalars["String"]["input"]>;
  products: Array<BookingProductSelectionInput>;
  return_url?: InputMaybe<Scalars["String"]["input"]>;
};

export type BookingOrderPreviewResult = {
  __typename?: "BookingOrderPreviewResult";
  order_token?: Maybe<Scalars["String"]["output"]>;
  price?: Maybe<BookingMoney>;
};

export type BookingOrderSummary = {
  __typename?: "BookingOrderSummary";
  amount?: Maybe<BookingMoney>;
  order_id?: Maybe<Scalars["String"]["output"]>;
  order_token?: Maybe<Scalars["String"]["output"]>;
  payment_url?: Maybe<Scalars["String"]["output"]>;
  provider_metadata?: Maybe<Scalars["Map"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
};

export type BookingPaginationInput = {
  page_size?: InputMaybe<Scalars["Int"]["input"]>;
  page_token?: InputMaybe<Scalars["String"]["input"]>;
};

export type BookingProductSelectionInput = {
  accommodation_id?: InputMaybe<Scalars["Int"]["input"]>;
  checkin: Scalars["Time"]["input"];
  checkout: Scalars["Time"]["input"];
  guests?: InputMaybe<BookingGuestAllocationInput>;
  rate_id?: InputMaybe<Scalars["String"]["input"]>;
  room_id?: InputMaybe<Scalars["String"]["input"]>;
};

export type Bouncer = {
  __typename?: "Bouncer";
  created_at?: Maybe<Scalars["Time"]["output"]>;
  email: Scalars["String"]["output"];
  event_id: Scalars["UUID"]["output"];
  first_name: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  last_name: Scalars["String"]["output"];
  phone: Scalars["String"]["output"];
};

export type BouncerAuthResponse = {
  __typename?: "BouncerAuthResponse";
  auth_response: AuthResponse;
  bouncer: Bouncer;
  event: Event;
};

export type BroadcastAppGuest = {
  __typename?: "BroadcastAppGuest";
  /**
   * no_linked_account, no_registered_device, push_unavailable, or push_available.
   *   push_unavailable includes OS denial and guest push preferences; details are private.
   */
  app_reachability: Scalars["String"]["output"];
  invitation_id: Scalars["UUID"]["output"];
  push_device_count: Scalars["Int"]["output"];
  recipient_user_id?: Maybe<Scalars["UUID"]["output"]>;
  registered_device_count: Scalars["Int"]["output"];
};

export type BroadcastAppNotificationInput = {
  audience: WeddingAnnouncementAudienceInput;
  idempotency_key?: InputMaybe<Scalars["String"]["input"]>;
  preview_token?: InputMaybe<Scalars["UUID"]["input"]>;
  title: Scalars["String"]["input"];
};

export type BroadcastAppNotificationSettings = {
  __typename?: "BroadcastAppNotificationSettings";
  audience_kind: Scalars["String"]["output"];
  event_part_id?: Maybe<Scalars["UUID"]["output"]>;
  invitation_ids: Array<Scalars["UUID"]["output"]>;
  title: Scalars["String"]["output"];
};

export enum CacheControlScope {
  Private = "PRIVATE",
  Public = "PUBLIC",
}

export type Category = {
  __typename?: "Category";
  created_at?: Maybe<Scalars["Time"]["output"]>;
  event_id: Scalars["Int"]["output"];
  event_uuid: Scalars["UUID"]["output"];
  general_invites?: Maybe<Array<Maybe<GeneralInvite>>>;
  id: Scalars["Int"]["output"];
  invitation_card: InvitationCard;
  invitations?: Maybe<InvitationListResponse>;
  invite_message_image?: Maybe<Scalars["String"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Time"]["output"]>;
  uuid: Scalars["UUID"]["output"];
};

export type CategoryInvitationsArgs = {
  page?: InputMaybe<Scalars["Int"]["input"]>;
  page_size?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CategoryInviteMessageImagePresignedUrlResponse = {
  __typename?: "CategoryInviteMessageImagePresignedURLResponse";
  category_id: Scalars["UUID"]["output"];
  event_id: Scalars["UUID"]["output"];
  expiry_time: Scalars["Time"]["output"];
  expiry_time_in_seconds: Scalars["Int"]["output"];
  file_uri: Scalars["String"]["output"];
  upload_url: Scalars["String"]["output"];
};

export enum Channel {
  Email = "email",
  Imessage = "imessage",
  /** App inbox/push delivery. Supported by wedding broadcasts. */
  Push = "push",
  Rcs = "rcs",
  Sms = "sms",
  Whatsapp = "whatsapp",
}

export type CheckInGuestRequest = {
  bouncer_id: Scalars["UUID"]["input"];
  invitation_id: Scalars["UUID"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
  slot?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ContactInfo = {
  __typename?: "ContactInfo";
  address_line1?: Maybe<Scalars["String"]["output"]>;
  address_line2?: Maybe<Scalars["String"]["output"]>;
  city?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  email: Scalars["String"]["output"];
  first_name: Scalars["String"]["output"];
  last_name: Scalars["String"]["output"];
  phone_number: Scalars["String"]["output"];
  postal_code?: Maybe<Scalars["String"]["output"]>;
  state?: Maybe<Scalars["String"]["output"]>;
};

export type ContactInfoInput = {
  address_line1: Scalars["String"]["input"];
  address_line2?: InputMaybe<Scalars["String"]["input"]>;
  city: Scalars["String"]["input"];
  country: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
  first_name: Scalars["String"]["input"];
  last_name: Scalars["String"]["input"];
  phone_number: Scalars["String"]["input"];
  postal_code: Scalars["String"]["input"];
  state: Scalars["String"]["input"];
};

export type ContactInput = {
  default: Scalars["Boolean"]["input"];
  email: Scalars["String"]["input"];
  first_name: Scalars["String"]["input"];
  last_name: Scalars["String"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
  phone_number: Scalars["String"]["input"];
};

export type ContactSupportMailInput = {
  content: Scalars["String"]["input"];
  subject?: InputMaybe<Scalars["String"]["input"]>;
};

export type CoupleDetail = {
  __typename?: "CoupleDetail";
  first_name: Scalars["String"]["output"];
  image?: Maybe<Scalars["String"]["output"]>;
  last_name: Scalars["String"]["output"];
  role: EventOwnerRole;
};

export type CoupleImagePresignedUrlResponse = {
  __typename?: "CoupleImagePresignedURLResponse";
  event_id: Scalars["UUID"]["output"];
  expiry_time: Scalars["Time"]["output"];
  expiry_time_in_seconds: Scalars["Int"]["output"];
  file_uri: Scalars["String"]["output"];
  upload_url: Scalars["String"]["output"];
};

export enum CoupleRole {
  Bride = "BRIDE",
  Groom = "GROOM",
}

export type CreateAseobiPackageInput = {
  aseobi_id: Scalars["UUID"]["input"];
  cover_image?: InputMaybe<Scalars["String"]["input"]>;
  currency_iso: Currency;
  description?: InputMaybe<Scalars["String"]["input"]>;
  images?: InputMaybe<Array<Scalars["String"]["input"]>>;
  items?: InputMaybe<Array<AseobiPackageItemInput>>;
  name: Scalars["String"]["input"];
  price?: InputMaybe<Scalars["Float"]["input"]>;
  stock_quantity?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CreateEventResponse = {
  __typename?: "CreateEventResponse";
  created_at: Scalars["Time"]["output"];
  id: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Time"]["output"]>;
};

export type CreateFaqInput = {
  answer: Scalars["String"]["input"];
  event_id: Scalars["UUID"]["input"];
  event_part_id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  order_index?: InputMaybe<Scalars["Float"]["input"]>;
  question: Scalars["String"]["input"];
};

export type CreateInvitationReq = {
  category_id: Scalars["Int"]["input"];
  event_id: Scalars["Int"]["input"];
  template_url?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateInvitationSlotInput = {
  allowed_channels: Array<InputMaybe<Channel>>;
  category_id: Scalars["UUID"]["input"];
  event_id: Scalars["UUID"]["input"];
  expires_at?: InputMaybe<Scalars["Time"]["input"]>;
  invitation_id: Scalars["UUID"]["input"];
  max_invites?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CreateRecItemInput = {
  contactInfo?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  link?: InputMaybe<Scalars["String"]["input"]>;
  listId: Scalars["UUID"]["input"];
  mediaType?: InputMaybe<RecMediaType>;
  mediaUrl?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
};

export type CreateRecListInput = {
  category: RecCategory;
  description?: InputMaybe<Scalars["String"]["input"]>;
  eventId: Scalars["UUID"]["input"];
  name: Scalars["String"]["input"];
};

export type CreateStreamer = {
  eventId: Scalars["Int"]["input"];
  inviteListId: Scalars["Int"]["input"];
  streamer_email?: InputMaybe<Scalars["String"]["input"]>;
  streamer_name: Scalars["String"]["input"];
  streamer_phone: Scalars["String"]["input"];
};

export type Creator = {
  __typename?: "Creator";
  image?: Maybe<Scalars["String"]["output"]>;
  user_id?: Maybe<Scalars["UUID"]["output"]>;
  username?: Maybe<Scalars["String"]["output"]>;
};

export enum Currency {
  Aed = "aed",
  All = "all",
  Aoa = "aoa",
  Ars = "ars",
  Aud = "aud",
  Azn = "azn",
  Bbd = "bbd",
  Bdt = "bdt",
  Bgn = "bgn",
  Bhd = "bhd",
  Bob = "bob",
  Brl = "brl",
  Bsd = "bsd",
  Bwp = "bwp",
  Bzd = "bzd",
  Cad = "cad",
  Chf = "chf",
  Clp = "clp",
  Cny = "cny",
  Cop = "cop",
  Crc = "crc",
  Cup = "cup",
  Czk = "czk",
  Dkk = "dkk",
  Dop = "dop",
  Dzd = "dzd",
  Egp = "egp",
  Etb = "etb",
  Eur = "eur",
  Fjd = "fjd",
  Gbp = "gbp",
  Gel = "gel",
  Ghs = "ghs",
  Gnf = "gnf",
  Gtq = "gtq",
  Hkd = "hkd",
  Hnl = "hnl",
  Hrk = "hrk",
  Htg = "htg",
  Huf = "huf",
  Idr = "idr",
  Ils = "ils",
  Inr = "inr",
  Iqd = "iqd",
  Irr = "irr",
  Isk = "isk",
  Jmd = "jmd",
  Jod = "jod",
  Jpy = "jpy",
  Kes = "kes",
  Khr = "khr",
  Krw = "krw",
  Kwd = "kwd",
  Kzt = "kzt",
  Lbp = "lbp",
  Lkr = "lkr",
  Lyd = "lyd",
  Mad = "mad",
  Mdl = "mdl",
  Mkd = "mkd",
  Mmk = "mmk",
  Mnt = "mnt",
  Mur = "mur",
  Mwk = "mwk",
  Mxn = "mxn",
  Myr = "myr",
  Mzn = "mzn",
  Nad = "nad",
  Ngn = "ngn",
  Nio = "nio",
  Nok = "nok",
  Npr = "npr",
  Nzd = "nzd",
  Omr = "omr",
  Pab = "pab",
  Pen = "pen",
  Pgk = "pgk",
  Php = "php",
  Pkr = "pkr",
  Pln = "pln",
  Pyg = "pyg",
  Qar = "qar",
  Ron = "ron",
  Rsd = "rsd",
  Rub = "rub",
  Rwf = "rwf",
  Sar = "sar",
  Sbd = "sbd",
  Scr = "scr",
  Sdg = "sdg",
  Sek = "sek",
  Sgd = "sgd",
  Sll = "sll",
  Sos = "sos",
  Std = "std",
  Syp = "syp",
  Thb = "thb",
  Tnd = "tnd",
  Top = "top",
  Try = "try",
  Ttd = "ttd",
  Tzs = "tzs",
  Uah = "uah",
  Ugx = "ugx",
  Usd = "usd",
  Uyu = "uyu",
  Uzs = "uzs",
  Ves = "ves",
  Vnd = "vnd",
  Vuv = "vuv",
  Wst = "wst",
  Xaf = "xaf",
  Xof = "xof",
  Yer = "yer",
  Zar = "zar",
  Zmw = "zmw",
}

export type CustomDomain = {
  __typename?: "CustomDomain";
  auto_renew: Scalars["Boolean"]["output"];
  created_at: Scalars["Time"]["output"];
  currency: Scalars["String"]["output"];
  dns_configured: Scalars["Boolean"]["output"];
  domain_name: Scalars["String"]["output"];
  event?: Maybe<Event>;
  event_id?: Maybe<Scalars["UUID"]["output"]>;
  expiry_date?: Maybe<Scalars["Time"]["output"]>;
  id: Scalars["UUID"]["output"];
  payment?: Maybe<CustomDomainPayment>;
  purchase_date?: Maybe<Scalars["Time"]["output"]>;
  purchase_price: Scalars["Float"]["output"];
  renewal_price: Scalars["Float"]["output"];
  status: DomainStatus;
  updated_at?: Maybe<Scalars["Time"]["output"]>;
  user?: Maybe<User>;
  user_id: Scalars["UUID"]["output"];
};

export type CustomDomainPayment = {
  __typename?: "CustomDomainPayment";
  auto_renew: Scalars["Boolean"]["output"];
  cloudflare_fee: Scalars["Float"]["output"];
  created_at: Scalars["Time"]["output"];
  currency: Currency;
  domain_name: Scalars["String"]["output"];
  fee: Scalars["Float"]["output"];
  id: Scalars["UUID"]["output"];
  payment_processor: Scalars["String"]["output"];
  payment_processor_reference: Scalars["String"]["output"];
  payment_reference: Scalars["String"]["output"];
  registrar: Scalars["String"]["output"];
  registrar_fee: Scalars["Float"]["output"];
  registrar_reference_id: Scalars["String"]["output"];
  tld: Scalars["String"]["output"];
  total_amount: Scalars["Float"]["output"];
  updated_at?: Maybe<Scalars["Time"]["output"]>;
  user_id: Scalars["UUID"]["output"];
  vat: Scalars["Float"]["output"];
  vercel_fee: Scalars["Float"]["output"];
  years: Scalars["Int"]["output"];
};

export type CustomDomainPaymentMetaData = {
  __typename?: "CustomDomainPaymentMetaData";
  auto_renew: Scalars["Boolean"]["output"];
  cloudflare_fee: Scalars["Float"]["output"];
  contact_info: ContactInfo;
  currency_iso: Scalars["String"]["output"];
  custom_domain_payment_id: Scalars["UUID"]["output"];
  custom_fields: Array<PaymentMetaDataCustomField>;
  domain_name: Scalars["String"]["output"];
  event_id?: Maybe<Scalars["UUID"]["output"]>;
  fee: Scalars["Float"]["output"];
  hash: Scalars["String"]["output"];
  inawo_product: Scalars["String"]["output"];
  payment_provider: Scalars["String"]["output"];
  payment_reference: Scalars["String"]["output"];
  registrar: Scalars["String"]["output"];
  registrar_fee: Scalars["Float"]["output"];
  timestamp: Scalars["Time"]["output"];
  tld: Scalars["String"]["output"];
  total_amount: Scalars["Float"]["output"];
  total_payment_intent_amount: Scalars["Float"]["output"];
  user_id: Scalars["UUID"]["output"];
  vat: Scalars["Float"]["output"];
  vercel_fee: Scalars["Float"]["output"];
  years: Scalars["Int"]["output"];
};

export type CustomDomainPaymentMetadataRequest = {
  auto_renew: Scalars["Boolean"]["input"];
  contact_info: ContactInfoInput;
  currency_iso?: InputMaybe<Currency>;
  domain_name: Scalars["String"]["input"];
  event_id: Scalars["UUID"]["input"];
  years: Scalars["Int"]["input"];
};

export type CustomDomainStatus = {
  __typename?: "CustomDomainStatus";
  domain_name: Scalars["String"]["output"];
  status: DomainStatus;
};

export type DetachDomainInput = {
  domain_id: Scalars["UUID"]["input"];
  reason?: InputMaybe<Scalars["String"]["input"]>;
};

export type DojahBankInfo = {
  __typename?: "DojahBankInfo";
  code: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export type DomainAvailabilityResponse = {
  __typename?: "DomainAvailabilityResponse";
  available: Scalars["Boolean"]["output"];
  currency: Scalars["String"]["output"];
  premium: Scalars["Boolean"]["output"];
  price: Scalars["Float"]["output"];
};

export type DomainContactInput = {
  address: Scalars["String"]["input"];
  city: Scalars["String"]["input"];
  country: Scalars["String"]["input"];
  email: Scalars["Email"]["input"];
  first_name: Scalars["String"]["input"];
  last_name: Scalars["String"]["input"];
  phone: Scalars["E164"]["input"];
  postal_code: Scalars["String"]["input"];
  state: Scalars["String"]["input"];
};

export type DomainHistory = {
  __typename?: "DomainHistory";
  attached_at: Scalars["Time"]["output"];
  attached_by: Scalars["UUID"]["output"];
  attached_by_user?: Maybe<User>;
  detach_reason?: Maybe<Scalars["String"]["output"]>;
  detached_at?: Maybe<Scalars["Time"]["output"]>;
  detached_by?: Maybe<Scalars["UUID"]["output"]>;
  detached_by_user?: Maybe<User>;
  domain?: Maybe<CustomDomain>;
  domain_id: Scalars["UUID"]["output"];
  event?: Maybe<Event>;
  event_id?: Maybe<Scalars["UUID"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type DomainListResponse = {
  __typename?: "DomainListResponse";
  domains: Array<CustomDomain>;
  total: Scalars["Int"]["output"];
};

export type DomainPricing = {
  __typename?: "DomainPricing";
  currency: Scalars["String"]["output"];
  last_updated: Scalars["Time"]["output"];
  register_price: Scalars["Float"]["output"];
  renewal_price: Scalars["Float"]["output"];
  tld: Scalars["String"]["output"];
  transfer_price: Scalars["Float"]["output"];
};

export enum DomainStatus {
  Attached = "ATTACHED",
  AttachFailed = "ATTACH_FAILED",
  Detached = "DETACHED",
  Expired = "EXPIRED",
  Pending = "PENDING",
  PurchaseCancelled = "PURCHASE_CANCELLED",
  PurchaseFailed = "PURCHASE_FAILED",
}

export type DomainSuggestion = {
  __typename?: "DomainSuggestion";
  available: Scalars["Boolean"]["output"];
  currency: Scalars["String"]["output"];
  domain: Scalars["String"]["output"];
  premium: Scalars["Boolean"]["output"];
  price: Scalars["Float"]["output"];
};

export type EstimateInvitationCostReq = {
  all: Scalars["Boolean"]["input"];
  channel: Channel;
  number_of_guests: Scalars["Int"]["input"];
  pending: Scalars["Boolean"]["input"];
};

export type EstimateInvitationCostResp = {
  __typename?: "EstimateInvitationCostResp";
  cost: Scalars["Float"]["output"];
  cost_usd: Scalars["Float"]["output"];
  currency: Currency;
  invite_credit: Scalars["Int"]["output"];
  rate: Scalars["Float"]["output"];
  usd_rate: Scalars["Float"]["output"];
};

export type Event = {
  __typename?: "Event";
  age?: Maybe<Scalars["Int"]["output"]>;
  /** public URL of the published AI-built website; null means use template_id */
  ai_website_url?: Maybe<Scalars["String"]["output"]>;
  available_gift_payment_currencies?: Maybe<
    Array<AvailableGiftPaymentCurrency>
  >;
  bank_account?: Maybe<BirthdayBankAccount>;
  birth_date?: Maybe<Scalars["Time"]["output"]>;
  birthday_status?: Maybe<BirthdayStatus>;
  /** Birthday deletion permission for the authenticated user; false for unavailable/non-birthday events. */
  can_delete: Scalars["Boolean"]["output"];
  card?: Maybe<InvitationCard>;
  country_iso_alpha2?: Maybe<Scalars["String"]["output"]>;
  couple_details: Array<CoupleDetail>;
  created_at?: Maybe<Scalars["Time"]["output"]>;
  date?: Maybe<Scalars["String"]["output"]>;
  default_currency_iso: Currency;
  enabled_currencies?: Maybe<Array<Maybe<Currency>>>;
  eventTimezone?: Maybe<Scalars["String"]["output"]>;
  event_parts?: Maybe<Array<EventPart>>;
  event_preference?: Maybe<EventPreference>;
  event_type?: Maybe<EventType>;
  event_wallet?: Maybe<Array<Maybe<Wallet>>>;
  gifts_enabled?: Maybe<Scalars["Boolean"]["output"]>;
  hash_tag?: Maybe<Scalars["String"]["output"]>;
  hero_image?: Maybe<Scalars["String"]["output"]>;
  hero_image_thumbnail?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["Int"]["output"];
  invitation?: Maybe<InvitationList>;
  invite_credit: InviteCredit;
  is_admin: Scalars["Boolean"]["output"];
  is_invited: Scalars["Boolean"]["output"];
  logo?: Maybe<Scalars["String"]["output"]>;
  luxe: Scalars["Boolean"]["output"];
  main_photo?: Maybe<Scalars["String"]["output"]>;
  my_role?: Maybe<EventOwnerRole>;
  name: Scalars["String"]["output"];
  pass_image?: Maybe<Scalars["String"]["output"]>;
  slug?: Maybe<Scalars["String"]["output"]>;
  supported_currencies: Array<EventSupportCurrency>;
  /** deprecated */
  team: Array<TeamMember>;
  template_id: Scalars["String"]["output"];
  toast?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Time"]["output"]>;
  uuid: Scalars["UUID"]["output"];
  venue?: Maybe<Scalars["String"]["output"]>;
  venue_address?: Maybe<Scalars["String"]["output"]>;
  vibe?: Maybe<Scalars["String"]["output"]>;
  wallet_created?: Maybe<Scalars["Boolean"]["output"]>;
  welcome_msg?: Maybe<Scalars["String"]["output"]>;
  /** public (approved-only) guestbook wishes - safe to expose unauthenticated */
  wishes?: Maybe<Array<Message>>;
  wishlist_note?: Maybe<Scalars["String"]["output"]>;
};

export type EventBroadcast = {
  __typename?: "EventBroadcast";
  /**
   * App content identifier. Use this broadcast's id with broadcastAnnouncementStatus.
   *   Device delivery and reading are distinct from completed inbox fan-out.
   */
  announcement_id?: Maybe<Scalars["UUID"]["output"]>;
  /** Editable App title/audience; preview tokens and idempotency keys are never returned. */
  app_notification_settings?: Maybe<BroadcastAppNotificationSettings>;
  /** Which channels this broadcast goes out on (e.g. whatsapp + sms at once). */
  channels: Array<Scalars["String"]["output"]>;
  completed_at?: Maybe<Scalars["Time"]["output"]>;
  created_at: Scalars["Time"]["output"];
  created_by: Scalars["UUID"]["output"];
  delivered_count: Scalars["Int"]["output"];
  event_id: Scalars["UUID"]["output"];
  failed_count: Scalars["Int"]["output"];
  id: Scalars["UUID"]["output"];
  link_type?: Maybe<EventBroadcastLinkType>;
  message: Scalars["String"]["output"];
  original_message: Scalars["String"]["output"];
  read_count: Scalars["Int"]["output"];
  /** The couple's explicit guest picks; empty means the default RSVP'd yes/maybe cohort. */
  recipient_invitation_ids?: Maybe<Array<Scalars["UUID"]["output"]>>;
  refunded_count: Scalars["Int"]["output"];
  /** When set, this broadcast was deferred to this time instead of sending immediately. */
  scheduled_at?: Maybe<Scalars["Time"]["output"]>;
  sent_count: Scalars["Int"]["output"];
  status: EventBroadcastStatus;
  /**
   * Counts recipient x channel send attempts (guests reachable per channel, summed),
   *   not just guest count, so it stays comparable to sent/delivered/etc. counts below.
   */
  total_recipients: Scalars["Int"]["output"];
  updated_at?: Maybe<Scalars["Time"]["output"]>;
};

/** guest-website link to attach as a WhatsApp button on a broadcast; more may be added later */
export enum EventBroadcastLinkType {
  Asoebi = "asoebi",
}

/**
 * One row per (guest, channel) the broadcast targeted — a guest sent on two
 * channels appears twice, once per channel, with its own status.
 */
export type EventBroadcastRecipient = {
  __typename?: "EventBroadcastRecipient";
  /** Present for App rows. Registration is an observation, not proof of installation. */
  app_eligibility?: Maybe<BroadcastAppGuest>;
  attempts: Scalars["Int"]["output"];
  broadcast_id: Scalars["UUID"]["output"];
  channel: Scalars["String"]["output"];
  created_at: Scalars["Time"]["output"];
  delivered_at?: Maybe<Scalars["Time"]["output"]>;
  event_id: Scalars["UUID"]["output"];
  failed_at?: Maybe<Scalars["Time"]["output"]>;
  failure_reason?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  /** App inbox creation is distinct from push provider acceptance. */
  inbox_at?: Maybe<Scalars["Time"]["output"]>;
  invitation?: Maybe<InvitationList>;
  invitation_id: Scalars["UUID"]["output"];
  phone: Scalars["String"]["output"];
  read_at?: Maybe<Scalars["Time"]["output"]>;
  refunded_at?: Maybe<Scalars["Time"]["output"]>;
  sent_at?: Maybe<Scalars["Time"]["output"]>;
  status: EventBroadcastRecipientStatus;
  updated_at?: Maybe<Scalars["Time"]["output"]>;
};

export enum EventBroadcastRecipientStatus {
  Delivered = "delivered",
  Failed = "failed",
  Inbox = "inbox",
  Initiated = "initiated",
  Queued = "queued",
  Read = "read",
  Sent = "sent",
  Suppressed = "suppressed",
}

export enum EventBroadcastStatus {
  Completed = "completed",
  CompletedWithFailures = "completed_with_failures",
  Draft = "draft",
  Failed = "failed",
  Processing = "processing",
  Queued = "queued",
  Scheduled = "scheduled",
}

export type EventCacheData = {
  __typename?: "EventCacheData";
  data: Scalars["Map"]["output"];
  hash: Scalars["String"]["output"];
  version: Scalars["Float"]["output"];
};

export enum EventOwnerRole {
  Asoebi = "asoebi",
  Bouncer = "bouncer",
  Bride = "bride",
  Celebrant = "celebrant",
  Groom = "groom",
  Planner = "planner",
}

export type EventPart = {
  __typename?: "EventPart";
  address: Scalars["String"]["output"];
  city?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  created_at?: Maybe<Scalars["Time"]["output"]>;
  eventPartTimezone?: Maybe<Scalars["String"]["output"]>;
  event_id: Scalars["Int"]["output"];
  geo_position?: Maybe<GeoPosition>;
  guest_website_template_id?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["Int"]["output"];
  image?: Maybe<Scalars["String"]["output"]>;
  map_coordinate?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  part: Scalars["String"]["output"];
  people?: Maybe<Array<Maybe<InvitationList>>>;
  programs?: Maybe<Array<Maybe<EventPartProgram>>>;
  state?: Maybe<Scalars["String"]["output"]>;
  time: Scalars["Time"]["output"];
  updated_at?: Maybe<Scalars["Time"]["output"]>;
  uuid: Scalars["UUID"]["output"];
  welcome_msg?: Maybe<Scalars["String"]["output"]>;
};

export type EventPartProgram = {
  __typename?: "EventPartProgram";
  attr?: Maybe<Scalars["Map"]["output"]>;
  index: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
};

export type EventPartProgramInput = {
  attr?: InputMaybe<Scalars["Map"]["input"]>;
  index: Scalars["Int"]["input"];
  name: Scalars["String"]["input"];
};

export type EventPlan = {
  __typename?: "EventPlan";
  access_control: Scalars["Boolean"]["output"];
  add_back_story: Scalars["Boolean"]["output"];
  add_event_vendors: Scalars["Boolean"]["output"];
  add_foreign_account: Scalars["Boolean"]["output"];
  add_live_hall: Scalars["Boolean"]["output"];
  add_wishlist: Scalars["Boolean"]["output"];
  asoebi: Scalars["Boolean"]["output"];
  build_invite_list: Scalars["Boolean"]["output"];
  categories: Scalars["Boolean"]["output"];
  custom_domain: Scalars["Boolean"]["output"];
  event_details: Scalars["Boolean"]["output"];
  event_id: Scalars["Int"]["output"];
  event_schedule: Scalars["Boolean"]["output"];
  hero_image: Scalars["Boolean"]["output"];
  invitation_card: Scalars["Boolean"]["output"];
  seating_chart: Scalars["Boolean"]["output"];
  send_out_invites: Scalars["Boolean"]["output"];
  upload_pictures: Scalars["Boolean"]["output"];
  wallet_pin_set: Scalars["Boolean"]["output"];
  website_template: Scalars["Boolean"]["output"];
};

export type EventPreference = {
  __typename?: "EventPreference";
  access_control?: Maybe<Scalars["Boolean"]["output"]>;
  ads?: Maybe<Scalars["Boolean"]["output"]>;
  asoebi_selection?: Maybe<Scalars["Boolean"]["output"]>;
  created_at?: Maybe<Scalars["Time"]["output"]>;
  dress_code?: Maybe<Scalars["Boolean"]["output"]>;
  event_id: Scalars["UUID"]["output"];
  faq?: Maybe<Scalars["Boolean"]["output"]>;
  food?: Maybe<Scalars["Boolean"]["output"]>;
  force_guest_app_download?: Maybe<Scalars["Boolean"]["output"]>;
  gift_in_invitation?: Maybe<Scalars["Boolean"]["output"]>;
  gifts?: Maybe<Scalars["Boolean"]["output"]>;
  guest_pov_default_public?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["UUID"]["output"];
  live_hall?: Maybe<Scalars["Boolean"]["output"]>;
  map?: Maybe<Scalars["Boolean"]["output"]>;
  oyple_integration?: Maybe<Scalars["Boolean"]["output"]>;
  plus_one_request?: Maybe<Scalars["Boolean"]["output"]>;
  private?: Maybe<Scalars["Boolean"]["output"]>;
  recommendations?: Maybe<Scalars["Boolean"]["output"]>;
  reservation?: Maybe<Scalars["Boolean"]["output"]>;
  smart_send?: Maybe<Scalars["Boolean"]["output"]>;
  store?: Maybe<Scalars["Boolean"]["output"]>;
  updated_at?: Maybe<Scalars["Time"]["output"]>;
  vendor_store?: Maybe<Scalars["Boolean"]["output"]>;
  website_after_invitation?: Maybe<Scalars["Boolean"]["output"]>;
};

export type EventSiteTemplate = {
  __typename?: "EventSiteTemplate";
  contact: Scalars["String"]["output"];
  created_at?: Maybe<Scalars["Time"]["output"]>;
  created_by: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  event_type: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
  image: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Time"]["output"]>;
};

export type EventSupportCurrency = {
  __typename?: "EventSupportCurrency";
  currency: Currency;
  gift_supported_providers: Array<Maybe<EventSupportCurrencyProvider>>;
  providers: Array<Maybe<EventSupportCurrencyProvider>>;
};

export enum EventSupportCurrencyProvider {
  BankDetails = "BANK_DETAILS",
  Flutterwave = "FLUTTERWAVE",
  Monnify = "MONNIFY",
  Paystack = "PAYSTACK",
  Stripe = "STRIPE",
}

export type EventTable = {
  __typename?: "EventTable";
  alias?: Maybe<Scalars["String"]["output"]>;
  capacity: Scalars["Int"]["output"];
  category_id?: Maybe<Scalars["UUID"]["output"]>;
  event_id: Scalars["UUID"]["output"];
  event_part_id: Scalars["UUID"]["output"];
  id: Scalars["UUID"]["output"];
  meta?: Maybe<Scalars["Map"]["output"]>;
  name: Scalars["String"]["output"];
  position_x?: Maybe<Scalars["Float"]["output"]>;
  position_y?: Maybe<Scalars["Float"]["output"]>;
  radius_x?: Maybe<Scalars["Float"]["output"]>;
  radius_y?: Maybe<Scalars["Float"]["output"]>;
  seats?: Maybe<Array<EventTableSeat>>;
  table_type?: Maybe<TableType>;
};

export type EventTableSeat = {
  __typename?: "EventTableSeat";
  admit_index: Scalars["Int"]["output"];
  created_at: Scalars["Time"]["output"];
  event_table_id: Scalars["UUID"]["output"];
  guest_info: InvitationList;
  id: Scalars["UUID"]["output"];
  invitation_id: Scalars["UUID"]["output"];
  meta?: Maybe<Scalars["Map"]["output"]>;
  position_x?: Maybe<Scalars["Float"]["output"]>;
  position_y?: Maybe<Scalars["Float"]["output"]>;
  radius_x?: Maybe<Scalars["Float"]["output"]>;
  radius_y?: Maybe<Scalars["Float"]["output"]>;
  seat_number: Scalars["Int"]["output"];
  updated_at?: Maybe<Scalars["Time"]["output"]>;
  user_id?: Maybe<Scalars["UUID"]["output"]>;
};

export type EventTask = {
  __typename?: "EventTask";
  created_at?: Maybe<Scalars["Time"]["output"]>;
  deadline?: Maybe<Scalars["Time"]["output"]>;
  description: Scalars["String"]["output"];
  done?: Maybe<Scalars["Boolean"]["output"]>;
  due_date?: Maybe<Scalars["Time"]["output"]>;
  eventUUID: Scalars["UUID"]["output"];
  event_id: Scalars["Int"]["output"];
  event_task_assets?: Maybe<Array<EventTaskAssets>>;
  event_task_comments?: Maybe<Array<EventTaskComment>>;
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  public?: Maybe<Scalars["Boolean"]["output"]>;
  updated_at?: Maybe<Scalars["Time"]["output"]>;
};

export type EventTaskAssetPresignedUrlResponse = {
  __typename?: "EventTaskAssetPresignedURLResponse";
  event_id: Scalars["UUID"]["output"];
  expiry_time: Scalars["Time"]["output"];
  expiry_time_in_seconds: Scalars["Int"]["output"];
  file_uri: Scalars["String"]["output"];
  task_id: Scalars["UUID"]["output"];
  upload_url: Scalars["String"]["output"];
};

export type EventTaskAssets = {
  __typename?: "EventTaskAssets";
  created_at?: Maybe<Scalars["Time"]["output"]>;
  event_id: Scalars["UUID"]["output"];
  file_name: Scalars["String"]["output"];
  file_type: Scalars["String"]["output"];
  file_url: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  task_id: Scalars["UUID"]["output"];
  updated_at?: Maybe<Scalars["Time"]["output"]>;
  uploaded_by: Scalars["UUID"]["output"];
};

export type EventTaskComment = {
  __typename?: "EventTaskComment";
  comment: Scalars["String"]["output"];
  commented_by: Scalars["UUID"]["output"];
  created_at?: Maybe<Scalars["Time"]["output"]>;
  event_id: Scalars["UUID"]["output"];
  id: Scalars["UUID"]["output"];
  task_id: Scalars["UUID"]["output"];
  updated_at?: Maybe<Scalars["Time"]["output"]>;
};

export type EventTeamMemberRequest = {
  __typename?: "EventTeamMemberRequest";
  email: Scalars["String"]["output"];
  event_id: Scalars["Int"]["output"];
  event_type: Scalars["String"]["output"];
  event_uuid: Scalars["UUID"]["output"];
  first_name: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
  last_name: Scalars["String"]["output"];
  owner_role: EventOwnerRole;
  phone_number: Scalars["String"]["output"];
  sent_status: Scalars["Boolean"]["output"];
};

export type EventTemplates = {
  __typename?: "EventTemplates";
  currency: Currency;
  fee: Scalars["Float"]["output"];
  id: Scalars["String"]["output"];
};

export type EventType = {
  __typename?: "EventType";
  description: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
};

export type EventVendor = {
  __typename?: "EventVendor";
  created_at?: Maybe<Scalars["Time"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  event_id: Scalars["Int"]["output"];
  facebook?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["Int"]["output"];
  image?: Maybe<Scalars["String"]["output"]>;
  instagram_handle?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  phone_number: Scalars["String"]["output"];
  role?: Maybe<Scalars["String"]["output"]>;
  twitter?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Time"]["output"]>;
};

export enum ExportFormat {
  Csv = "CSV",
  Json = "JSON",
}

export type Faq = {
  __typename?: "FAQ";
  answer: Scalars["String"]["output"];
  created_at: Scalars["Time"]["output"];
  event_id: Scalars["UUID"]["output"];
  event_part_id?: Maybe<Scalars["UUID"]["output"]>;
  id: Scalars["UUID"]["output"];
  is_active: Scalars["Boolean"]["output"];
  order_index?: Maybe<Scalars["Float"]["output"]>;
  question: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Time"]["output"]>;
};

export type FaqFilter = {
  event_part_id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type FaqOrderInput = {
  id: Scalars["UUID"]["input"];
  order_index: Scalars["Float"]["input"];
};

export type FaqResponse = {
  __typename?: "FAQResponse";
  faq?: Maybe<Faq>;
  message?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

export type FeatureFlag = {
  __typename?: "FeatureFlag";
  created_at: Scalars["Time"]["output"];
  enabled: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  updated_at: Scalars["Time"]["output"];
};

export enum FileUploadPermissionEnum {
  Admin = "admin",
  All = "all",
  Guest = "guest",
}

export type FlutterwaveProfile = {
  __typename?: "FlutterwaveProfile";
  account_name: Scalars["String"]["output"];
  account_number: Scalars["String"]["output"];
  bank_code: Scalars["String"]["output"];
  bank_name?: Maybe<Scalars["String"]["output"]>;
  country_iso_alpha2: Scalars["String"]["output"];
  currency_iso: Scalars["String"]["output"];
  default: Scalars["Boolean"]["output"];
  disabled: Scalars["Boolean"]["output"];
  status: PayoutProfileStatusEnum;
  subaccount_code: Scalars["String"]["output"];
  subaccount_id: Scalars["Int"]["output"];
};

export enum Gender {
  Female = "female",
  Male = "male",
}

export type GeneralInvitationResp = {
  __typename?: "GeneralInvitationResp";
  event?: Maybe<Event>;
  invitation_card?: Maybe<InvitationCard>;
};

export type GeneralInvite = {
  __typename?: "GeneralInvite";
  active_used_count: Scalars["Int"]["output"];
  category: Category;
  category_id: Scalars["UUID"]["output"];
  code: Scalars["String"]["output"];
  created_at: Scalars["Time"]["output"];
  deleted_used_count: Scalars["Int"]["output"];
  event_id: Scalars["UUID"]["output"];
  expires_at: Scalars["Time"]["output"];
  id: Scalars["UUID"]["output"];
  invitations?: Maybe<InvitationListResponse>;
  is_valid: Scalars["Boolean"]["output"];
  max_uses: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  remaining_uses: Scalars["Int"]["output"];
  used_count: Scalars["Int"]["output"];
};

export type GeneralInviteInvitationsArgs = {
  page?: InputMaybe<Scalars["Int"]["input"]>;
  page_size?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GeneralInviteResp = {
  __typename?: "GeneralInviteResp";
  auth_response: AuthResponse;
  event: Event;
  invitation: InvitationList;
  invitation_card: InvitationCard;
  invite_token: Scalars["String"]["output"];
};

export type GeoPosition = {
  __typename?: "GeoPosition";
  geo_position_id?: Maybe<Scalars["String"]["output"]>;
  latitude?: Maybe<Scalars["String"]["output"]>;
  longitude?: Maybe<Scalars["String"]["output"]>;
};

export type GeoPositionInput = {
  geo_position_id?: InputMaybe<Scalars["String"]["input"]>;
  latitude?: InputMaybe<Scalars["Float"]["input"]>;
  longitude?: InputMaybe<Scalars["Float"]["input"]>;
};

export type Gift = {
  __typename?: "Gift";
  amount: Scalars["Float"]["output"];
  created_at: Scalars["Time"]["output"];
  creditor_alias?: Maybe<Scalars["String"]["output"]>;
  currency_iso: Currency;
  event_id: Scalars["UUID"]["output"];
  fee: Scalars["Float"]["output"];
  id: Scalars["UUID"]["output"];
  narration: Scalars["String"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
  payment_provider: Scalars["String"]["output"];
  payment_provider_reference: Scalars["String"]["output"];
  total_amount: Scalars["Float"]["output"];
  user?: Maybe<User>;
  user_id?: Maybe<Scalars["UUID"]["output"]>;
  wallet_id: Scalars["UUID"]["output"];
  wish_list_item_id?: Maybe<Scalars["UUID"]["output"]>;
};

export type GiftPaymentMetaData = {
  __typename?: "GiftPaymentMetaData";
  contact_email?: Maybe<Scalars["String"]["output"]>;
  contact_phone_number?: Maybe<Scalars["String"]["output"]>;
  currency_iso: Scalars["String"]["output"];
  custom_fields: Array<PaymentMetaDataCustomField>;
  event_id: Scalars["UUID"]["output"];
  full_name?: Maybe<Scalars["String"]["output"]>;
  gift_id: Scalars["UUID"]["output"];
  hash: Scalars["String"]["output"];
  inawo_product: Scalars["String"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
  payment_provider: Scalars["String"]["output"];
  payment_reference: Scalars["String"]["output"];
  split_payments?: Maybe<Array<SplitPayments>>;
  split_percentage: Scalars["Float"]["output"];
  sub_account_code: Scalars["String"]["output"];
  sub_account_id: Scalars["String"]["output"];
  timestamp: Scalars["Time"]["output"];
  total_payment_intent_amount: Scalars["Float"]["output"];
  user_id?: Maybe<Scalars["UUID"]["output"]>;
  wish_list_item_id?: Maybe<Scalars["UUID"]["output"]>;
};

export type GiftPaymentMetadataRequest = {
  amount: Scalars["Float"]["input"];
  contact_email?: InputMaybe<Scalars["String"]["input"]>;
  contact_phone?: InputMaybe<Scalars["String"]["input"]>;
  currency: Currency;
  currency_iso: Currency;
  event_id: Scalars["UUID"]["input"];
  full_name?: InputMaybe<Scalars["String"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
  payment_provider: PaymentProcessor;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
  wish_list_item_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type GiftsWithPagination = {
  __typename?: "GiftsWithPagination";
  gifts?: Maybe<Array<Maybe<Gift>>>;
  meta?: Maybe<Pagination>;
};

export type GuestLoginRequest = {
  email: Scalars["String"]["input"];
  event_id: Scalars["UUID"]["input"];
  otp: Scalars["String"]["input"];
};

export type GuestPerCategory = {
  __typename?: "GuestPerCategory";
  category_id: Scalars["Int"]["output"];
  category_name: Scalars["String"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  num_guest?: Maybe<Scalars["Int"]["output"]>;
};

export type GuestUpload = {
  __typename?: "GuestUpload";
  created_at: Scalars["Time"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  event_id: Scalars["UUID"]["output"];
  event_part_id?: Maybe<Scalars["UUID"]["output"]>;
  expires_at: Scalars["Time"]["output"];
  id: Scalars["UUID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  secret: Scalars["String"]["output"];
  tags?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type GuestWebsiteChatMessage = {
  __typename?: "GuestWebsiteChatMessage";
  content: Scalars["String"]["output"];
  preview_url?: Maybe<Scalars["String"]["output"]>;
  role: Scalars["String"]["output"];
  version?: Maybe<Scalars["Int"]["output"]>;
};

export type GuestWebsiteChatResponse = {
  __typename?: "GuestWebsiteChatResponse";
  error?: Maybe<Scalars["String"]["output"]>;
  history: Array<GuestWebsiteChatMessage>;
  preview_url?: Maybe<Scalars["String"]["output"]>;
  status: GuestWebsiteChatStatus;
  summary: Scalars["String"]["output"];
  turns_left: Scalars["Int"]["output"];
};

export enum GuestWebsiteChatStatus {
  Failed = "FAILED",
  Idle = "IDLE",
  Pending = "PENDING",
  Ready = "READY",
}

export type GuestWebsiteUploadResponse = {
  __typename?: "GuestWebsiteUploadResponse";
  preview_url: Scalars["String"]["output"];
};

export type InawoAskChat = {
  __typename?: "InawoAskChat";
  id: Scalars["UUID"]["output"];
  messages: Array<InawoAskMessage>;
  questions_left: Scalars["Int"]["output"];
};

export type InawoAskImageUpload = {
  __typename?: "InawoAskImageUpload";
  file_uri: Scalars["String"]["output"];
  upload_url: Scalars["String"]["output"];
};

export type InawoAskMessage = {
  __typename?: "InawoAskMessage";
  content: Scalars["String"]["output"];
  images: Array<Scalars["String"]["output"]>;
  role: Scalars["String"]["output"];
  support_ticket: Scalars["Boolean"]["output"];
};

export type InawoAssistantPaymentMetaData = {
  __typename?: "InawoAssistantPaymentMetaData";
  amount: Scalars["Float"]["output"];
  contact_email: Scalars["String"]["output"];
  contact_phone_number?: Maybe<Scalars["String"]["output"]>;
  currency_iso: Scalars["String"]["output"];
  custom_fields: Array<PaymentMetaDataCustomField>;
  event_id: Scalars["UUID"]["output"];
  full_name: Scalars["String"]["output"];
  hash: Scalars["String"]["output"];
  inawo_product: Scalars["String"]["output"];
  payment_provider: Scalars["String"]["output"];
  payment_reference: Scalars["String"]["output"];
  timestamp: Scalars["Time"]["output"];
  total_payment_intent_amount: Scalars["Float"]["output"];
  user_id: Scalars["UUID"]["output"];
};

export type InawoPassProgress = {
  __typename?: "InawoPassProgress";
  in_progress: Scalars["Boolean"]["output"];
  total_guest: Scalars["Int"]["output"];
  total_sent: Scalars["Int"]["output"];
};

export type InboxEventDisplay = {
  __typename?: "InboxEventDisplay";
  display_title: Scalars["String"]["output"];
  event_type: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
};

export type InboxNotification = {
  __typename?: "InboxNotification";
  action?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  created_at: Scalars["Time"]["output"];
  entity_id?: Maybe<Scalars["UUID"]["output"]>;
  event_display?: Maybe<InboxEventDisplay>;
  event_id?: Maybe<Scalars["UUID"]["output"]>;
  event_part_id?: Maybe<Scalars["UUID"]["output"]>;
  id: Scalars["UUID"]["output"];
  invitation_id?: Maybe<Scalars["UUID"]["output"]>;
  lead_days?: Maybe<Scalars["Int"]["output"]>;
  occurrence_date?: Maybe<Scalars["String"]["output"]>;
  read_at?: Maybe<Scalars["Time"]["output"]>;
  title: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type InboxNotificationConnection = {
  __typename?: "InboxNotificationConnection";
  edges: Array<InboxNotificationEdge>;
  page_info: InboxPageInfo;
};

export type InboxNotificationEdge = {
  __typename?: "InboxNotificationEdge";
  cursor: Scalars["String"]["output"];
  node: InboxNotification;
};

export type InboxPageInfo = {
  __typename?: "InboxPageInfo";
  end_cursor?: Maybe<Scalars["String"]["output"]>;
  has_next_page: Scalars["Boolean"]["output"];
};

export type InitiateLuxeCardPaymentResponse = {
  __typename?: "InitiateLuxeCardPaymentResponse";
  message: Scalars["String"]["output"];
  payment_link?: Maybe<Scalars["String"]["output"]>;
  payment_reference?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

export type InitiatePaymentResponse = {
  __typename?: "InitiatePaymentResponse";
  authorization_url: Scalars["String"]["output"];
  client_secret: Scalars["String"]["output"];
  reference: Scalars["String"]["output"];
  subaccount_id?: Maybe<Scalars["String"]["output"]>;
};

export type InvitationBroadcast = {
  __typename?: "InvitationBroadcast";
  broadcast_id: Scalars["UUID"]["output"];
  channel: Scalars["String"]["output"];
  link_type?: Maybe<EventBroadcastLinkType>;
  message: Scalars["String"]["output"];
  sent_at?: Maybe<Scalars["Time"]["output"]>;
  status: Scalars["String"]["output"];
  updated_at: Scalars["Time"]["output"];
};

export type InvitationCard = {
  __typename?: "InvitationCard";
  created_at?: Maybe<Scalars["Time"]["output"]>;
  event_id: Scalars["Int"]["output"];
  event_uuid: Scalars["UUID"]["output"];
  id: Scalars["Int"]["output"];
  static_image: Scalars["String"]["output"];
  template?: Maybe<InvitationCardTemplate>;
  template_id?: Maybe<Scalars["UUID"]["output"]>;
  template_variables?: Maybe<Array<InvitationCardSchemaFieldValue>>;
  updated_at?: Maybe<Scalars["Time"]["output"]>;
  uuid: Scalars["UUID"]["output"];
};

export type InvitationCardPresignedUrlResponse = {
  __typename?: "InvitationCardPresignedURLResponse";
  event_id: Scalars["UUID"]["output"];
  expiry_time: Scalars["Time"]["output"];
  expiry_time_in_seconds: Scalars["Int"]["output"];
  file_uri: Scalars["String"]["output"];
  upload_url: Scalars["String"]["output"];
};

export type InvitationCardSchemaField = {
  __typename?: "InvitationCardSchemaField";
  data_type: Scalars["String"]["output"];
  default_value?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  options?: Maybe<Array<Scalars["String"]["output"]>>;
  placeholder?: Maybe<Scalars["String"]["output"]>;
  position?: Maybe<Scalars["Map"]["output"]>;
  regrex?: Maybe<Scalars["String"]["output"]>;
  required: Scalars["Boolean"]["output"];
  style?: Maybe<Scalars["Map"]["output"]>;
};

export type InvitationCardSchemaFieldValue = {
  __typename?: "InvitationCardSchemaFieldValue";
  data_type: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  position?: Maybe<Scalars["Map"]["output"]>;
  style?: Maybe<Scalars["Map"]["output"]>;
  value: Scalars["String"]["output"];
};

export type InvitationCardSchemaFields = {
  __typename?: "InvitationCardSchemaFields";
  fields: Array<InvitationCardSchemaField>;
};

export type InvitationCardTemplate = {
  __typename?: "InvitationCardTemplate";
  component_url?: Maybe<Scalars["String"]["output"]>;
  created_at?: Maybe<Scalars["Time"]["output"]>;
  id: Scalars["UUID"]["output"];
  luxe: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  schema_fields: InvitationCardSchemaFields;
  thumbnail_url: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Time"]["output"]>;
};

export type InvitationList = {
  __typename?: "InvitationList";
  CheckInAt?: Maybe<Scalars["Time"]["output"]>;
  activities?: Maybe<Array<Maybe<InvitationListActivity>>>;
  admits?: Maybe<Scalars["Int"]["output"]>;
  admits_used?: Maybe<Scalars["Int"]["output"]>;
  assigned_slot?: Maybe<InvitationSlot>;
  broadcast?: Maybe<Array<InvitationBroadcast>>;
  category?: Maybe<Category>;
  category_id?: Maybe<Scalars["Int"]["output"]>;
  created_at?: Maybe<Scalars["Time"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  event_id: Scalars["Int"]["output"];
  event_uuid: Scalars["UUID"]["output"];
  first_name: Scalars["String"]["output"];
  general_invite_id?: Maybe<Scalars["UUID"]["output"]>;
  id: Scalars["Int"]["output"];
  inawo_pass_image?: Maybe<Scalars["String"]["output"]>;
  inawo_pass_status?: Maybe<InvitationListDeliveryStatus>;
  invitation_mode: InvitationMode;
  invitation_slot_id?: Maybe<Scalars["UUID"]["output"]>;
  invitation_status?: Maybe<InvitationListDeliveryStatus>;
  last_name: Scalars["String"]["output"];
  other_name?: Maybe<Scalars["String"]["output"]>;
  phone: Scalars["String"]["output"];
  plus_one_request_id?: Maybe<Scalars["UUID"]["output"]>;
  qr_code?: Maybe<Scalars["String"]["output"]>;
  rsvp_status?: Maybe<Scalars["String"]["output"]>;
  seating?: Maybe<Array<InvitationListReservation>>;
  selfie?: Maybe<Scalars["String"]["output"]>;
  sent: Scalars["Boolean"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Time"]["output"]>;
  uuid: Scalars["UUID"]["output"];
};

export type InvitationListActivity = {
  __typename?: "InvitationListActivity";
  action: Scalars["String"]["output"];
  authorization?: Maybe<Scalars["Map"]["output"]>;
  note?: Maybe<Scalars["String"]["output"]>;
  timestamp: Scalars["Time"]["output"];
};

export type InvitationListDeliveryStatus = {
  __typename?: "InvitationListDeliveryStatus";
  direct?: Maybe<InvitationListDeliveryTime>;
  email?: Maybe<InvitationListDeliveryTime>;
  sms?: Maybe<InvitationListDeliveryTime>;
  whatsapp?: Maybe<InvitationListDeliveryTime>;
};

export type InvitationListDeliveryTime = {
  __typename?: "InvitationListDeliveryTime";
  delivered_at?: Maybe<Scalars["Time"]["output"]>;
  failed_at?: Maybe<Scalars["Time"]["output"]>;
  failure_reason?: Maybe<Scalars["String"]["output"]>;
  initiated_at?: Maybe<Scalars["Time"]["output"]>;
  read_at?: Maybe<Scalars["Time"]["output"]>;
  sent_at?: Maybe<Scalars["Time"]["output"]>;
};

export type InvitationListReservation = {
  __typename?: "InvitationListReservation";
  admit_index: Scalars["Int"]["output"];
  created_at: Scalars["Time"]["output"];
  event_part: EventPart;
  event_part_id: Scalars["UUID"]["output"];
  event_table_id: Scalars["UUID"]["output"];
  event_table_seat_id: Scalars["UUID"]["output"];
  seat_number: Scalars["Int"]["output"];
  table_alias: Scalars["String"]["output"];
  table_name: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Time"]["output"]>;
};

export type InvitationListResponse = {
  __typename?: "InvitationListResponse";
  invitationList?: Maybe<Array<InvitationList>>;
  meta: PaginationMeta;
  total: Scalars["Int"]["output"];
};

export enum InvitationListRsvpStatus {
  Maybe = "maybe",
  No = "no",
  Pending = "pending",
  Yes = "yes",
}

export enum InvitationMode {
  Custom = "CUSTOM",
  GeneralInvite = "GENERAL_INVITE",
  InvitationSlot = "INVITATION_SLOT",
  PlusOne = "PLUS_ONE",
}

export type InvitationSlot = {
  __typename?: "InvitationSlot";
  active: Scalars["Boolean"]["output"];
  allowed_channels?: Maybe<Array<Channel>>;
  category: Category;
  category_id: Scalars["UUID"]["output"];
  code: Scalars["String"]["output"];
  created_at: Scalars["Time"]["output"];
  event_id: Scalars["UUID"]["output"];
  expires_at?: Maybe<Scalars["Time"]["output"]>;
  id: Scalars["UUID"]["output"];
  invitation: InvitationList;
  invitation_id: Scalars["UUID"]["output"];
  invites_used: Scalars["Int"]["output"];
  max_invites: Scalars["Int"]["output"];
  updated_at?: Maybe<Scalars["Time"]["output"]>;
};

export type InvitationTokenLookup = {
  __typename?: "InvitationTokenLookup";
  event_id: Scalars["UUID"]["output"];
  event_int_id: Scalars["Int"]["output"];
  invitation_id: Scalars["UUID"]["output"];
  invitation_mode: InvitationMode;
  invite_token: Scalars["String"]["output"];
  phone: Scalars["String"]["output"];
};

export type InviteCredit = {
  __typename?: "InviteCredit";
  imessage: Scalars["Int"]["output"];
  rcs: Scalars["Int"]["output"];
  sms: Scalars["Int"]["output"];
  whatsapp: Scalars["Int"]["output"];
};

export type InviteFeePaymentMetaData = {
  __typename?: "InviteFeePaymentMetaData";
  amount: Scalars["Float"]["output"];
  channel: Channel;
  count: Scalars["Int"]["output"];
  currency_iso: Currency;
  custom_fields: Array<PaymentMetaDataCustomField>;
  event_id: Scalars["UUID"]["output"];
  hash: Scalars["String"]["output"];
  inawo_product: Scalars["String"]["output"];
  payment_provider: Scalars["String"]["output"];
  payment_reference: Scalars["String"]["output"];
  timestamp: Scalars["Time"]["output"];
  total_payment_intent_amount: Scalars["Float"]["output"];
  user_id: Scalars["UUID"]["output"];
};

export type IsStreamerInput = {
  eventId: Scalars["Int"]["input"];
  userId: Scalars["Int"]["input"];
};

export type ListMeta = {
  __typename?: "ListMeta";
  page?: Maybe<Scalars["Int"]["output"]>;
  pageCount?: Maybe<Scalars["Int"]["output"]>;
  perPage?: Maybe<Scalars["Int"]["output"]>;
  skipped?: Maybe<Scalars["Int"]["output"]>;
  total?: Maybe<Scalars["Int"]["output"]>;
};

export type LiveComment = {
  __typename?: "LiveComment";
  comment: Scalars["String"]["output"];
  created_at: Scalars["Time"]["output"];
  id: Scalars["String"]["output"];
  kind: LiveCommentKind;
  updated_at?: Maybe<Scalars["Time"]["output"]>;
  username: Scalars["String"]["output"];
};

export type LiveCommentEvent = {
  __typename?: "LiveCommentEvent";
  comment: Scalars["String"]["output"];
  created_at: Scalars["String"]["output"];
  kind: LiveCommentKind;
  live_schedule_id: Scalars["String"]["output"];
  username: Scalars["String"]["output"];
};

export enum LiveCommentKind {
  Greeting = "greeting",
  Regular = "regular",
}

export type LiveSchedule = {
  __typename?: "LiveSchedule";
  created_at?: Maybe<Scalars["Time"]["output"]>;
  event: Event;
  event_part: EventPart;
  event_part_uuid: Scalars["UUID"]["output"];
  event_uuid: Scalars["UUID"]["output"];
  id: Scalars["UUID"]["output"];
  link: Scalars["String"]["output"];
  time: Scalars["Time"]["output"];
  updated_at?: Maybe<Scalars["Time"]["output"]>;
};

export type LiveSprayEvent = {
  __typename?: "LiveSprayEvent";
  created_at: Scalars["String"]["output"];
  currency: Currency;
  live_schedule_id: Scalars["String"]["output"];
  sprays: Array<Spray>;
  username: Scalars["String"]["output"];
};

export type LoginRequest = {
  password: Scalars["String"]["input"];
  username: Scalars["String"]["input"];
};

export type LuxeCard = {
  __typename?: "LuxeCard";
  code: Scalars["String"]["output"];
  created_at: Scalars["Time"]["output"];
  currency: Currency;
  expires_at: Scalars["Time"]["output"];
  id: Scalars["UUID"]["output"];
  is_redeemed: Scalars["Boolean"]["output"];
  message: Scalars["String"]["output"];
  original_amount: Scalars["Float"]["output"];
  purchaser_email: Scalars["String"]["output"];
  purchaser_name: Scalars["String"]["output"];
  recipient_email: Scalars["String"]["output"];
  recipient_name: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
};

export type LuxeCardPaymentMetaData = {
  __typename?: "LuxeCardPaymentMetaData";
  amount: Scalars["Float"]["output"];
  currency_iso: Scalars["String"]["output"];
  custom_fields: Array<PaymentMetaDataCustomField>;
  hash: Scalars["String"]["output"];
  inawo_product: Scalars["String"]["output"];
  luxe_discount_percentage: Scalars["Float"]["output"];
  message: Scalars["String"]["output"];
  payment_provider: Scalars["String"]["output"];
  payment_reference: Scalars["String"]["output"];
  purchaser_email: Scalars["String"]["output"];
  purchaser_name: Scalars["String"]["output"];
  recipient_email: Scalars["String"]["output"];
  recipient_name: Scalars["String"]["output"];
  timestamp: Scalars["Time"]["output"];
  total_payment_intent_amount: Scalars["Float"]["output"];
};

export type LuxeDescription = {
  __typename?: "LuxeDescription";
  currency: Currency;
  discount_percentage: Scalars["Float"]["output"];
  discounted_amount: Scalars["Float"]["output"];
  notes: Scalars["String"]["output"];
  undiscounted_amount: Scalars["Float"]["output"];
};

export type LuxePaymentMetaData = {
  __typename?: "LuxePaymentMetaData";
  amount_after_discount: Scalars["Float"]["output"];
  amount_before_discount: Scalars["Float"]["output"];
  currency_iso: Scalars["String"]["output"];
  custom_fields: Array<PaymentMetaDataCustomField>;
  discount_amount_applied: Scalars["Float"]["output"];
  discount_percentage_applied: Scalars["Float"]["output"];
  event_id: Scalars["UUID"]["output"];
  full_name: Scalars["String"]["output"];
  hash: Scalars["String"]["output"];
  inawo_product: Scalars["String"]["output"];
  payment_provider: Scalars["String"]["output"];
  payment_reference: Scalars["String"]["output"];
  timestamp: Scalars["Time"]["output"];
  total_payment_intent_amount: Scalars["Float"]["output"];
  user_id: Scalars["UUID"]["output"];
};

export type LuxePaymentMetadataRequest = {
  currency: Currency;
  event_id: Scalars["UUID"]["input"];
  payment_provider: PaymentProcessor;
};

export type MapObject = {
  __typename?: "MapObject";
  Key: Scalars["String"]["output"];
  Value: Scalars["String"]["output"];
};

export type MapObjectInput = {
  Key: Scalars["String"]["input"];
  Value: Scalars["String"]["input"];
};

export type MediaFilter = {
  album_id?: InputMaybe<Scalars["String"]["input"]>;
  no_album?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  tags?: InputMaybe<Array<AlbumMediaTag>>;
};

export type MediaMeta = {
  __typename?: "MediaMeta";
  height?: Maybe<Scalars["Int"]["output"]>;
  s3_url?: Maybe<Scalars["String"]["output"]>;
  width?: Maybe<Scalars["Int"]["output"]>;
};

export type MediaPresignUrlResponse = {
  __typename?: "MediaPresignURLResponse";
  event_id: Scalars["UUID"]["output"];
  expiry_time: Scalars["Time"]["output"];
  expiry_time_in_seconds: Scalars["Int"]["output"];
  file_uri: Scalars["String"]["output"];
  media_id: Scalars["UUID"]["output"];
  thumbnail_uri: Scalars["String"]["output"];
  upload_url: Scalars["String"]["output"];
};

export type Message = {
  __typename?: "Message";
  content?: Maybe<Scalars["String"]["output"]>;
  created_at?: Maybe<Scalars["Time"]["output"]>;
  event_id: Scalars["Int"]["output"];
  id: Scalars["Int"]["output"];
  reply?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["Boolean"]["output"];
  updated_at?: Maybe<Scalars["Time"]["output"]>;
  user?: Maybe<User>;
  user_id: Scalars["Int"]["output"];
  uuid: Scalars["UUID"]["output"];
  video?: Maybe<BirthdayWishVideo>;
};

export type MessageResponse = {
  __typename?: "MessageResponse";
  messages?: Maybe<Array<Message>>;
  total: Scalars["Int"]["output"];
};

export type Meta = {
  __typename?: "Meta";
  next?: Maybe<Scalars["Int"]["output"]>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pageSize?: Maybe<Scalars["Int"]["output"]>;
};

export type Mutation = {
  __typename?: "Mutation";
  GeneralInviteListReq: GeneralInviteResp;
  acceptEventTeam?: Maybe<AcceptEventTeam>;
  addAseobiAttire: Scalars["UUID"]["output"];
  addAsoebiAttireFromOyple: Scalars["UUID"]["output"];
  addBackStory?: Maybe<BackStory>;
  addCustomMyPlanTask: EventTask;
  addEventPart: EventPart;
  addEventTaskAsset: EventTaskAssets;
  addEventTaskComment: EventTaskComment;
  addEventTeamMember?: Maybe<Scalars["Boolean"]["output"]>;
  addEventVendor?: Maybe<EventVendor>;
  /** Add a single guest to the invitation list. */
  addGuestToInviteList: Scalars["UUID"]["output"];
  addGuestViaInvitationSlot: Scalars["String"]["output"];
  addMedia: AlbumMedia;
  addMediaToAlbum: Scalars["String"]["output"];
  /** STREAMERS */
  addStreamerFromInviteList?: Maybe<Scalars["Boolean"]["output"]>;
  /** Add a list of guests to the invitation list. It returns the any already guests. */
  addToInviteList?: Maybe<Array<Maybe<InvitationList>>>;
  /** Add a secondary PHONE or EMAIL to the caller's account and send a verification OTP. Not stored until verified. */
  addUserIdentifier: Scalars["String"]["output"];
  addWeddingParty?: Maybe<WeddingParty>;
  addWishListItem?: Maybe<WishListItem>;
  appreciateGift?: Maybe<Scalars["Boolean"]["output"]>;
  archiveAseobiPackage: AseobiPackage;
  askInawo: InawoAskChat;
  attachAseobiPayment: Scalars["UUID"]["output"];
  attachDomain: CustomDomain;
  attachEventWalletToSubaccount?: Maybe<Scalars["Boolean"]["output"]>;
  authenticateBouncerSecret: BouncerAuthResponse;
  authenticateInviteLink: GeneralInviteResp;
  autoReserveTable?: Maybe<Scalars["Boolean"]["output"]>;
  autoSendInawoPass?: Maybe<Scalars["Boolean"]["output"]>;
  beginPasskeyLogin: PasskeyBeginResponse;
  beginPasskeyRegistration: PasskeyBeginResponse;
  bookingOrderCreate: BookingOrderCreateResult;
  bookingOrderPreview: BookingOrderPreviewResult;
  broadcastAppreciation?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * channels, invitation_ids, link_type and draft are only used when creating a
   *   new broadcast (message set, broadcast_id omitted).
   *
   *   broadcast_id set: resends only the (guest, channel) pairs that failed, reusing
   *   its settings. Errors on a draft; use sendDraftBroadcast for that.
   *
   *   channels: which channels to send on at once (default: whatsapp only).
   *   push is the App channel and may be combined with whatsapp/sms/email/rcs.
   *   With push selected, app_notification supplies its title, audience and send proof;
   *   the previewed audience is the common audience for every selected channel.
   *   invitation_ids: send to exactly these guests instead of the default RSVP'd yes/maybe cohort.
   *   scheduled_at: defer sending to this time instead of sending immediately.
   *   draft: save without charging or sending; send later with sendDraftBroadcast.
   */
  broadcastMessage: EventBroadcast;
  bulkCreateFAQs: Array<Faq>;
  bulkDeleteMedia?: Maybe<Scalars["String"]["output"]>;
  cancelAsoebiCheckout: Scalars["Boolean"]["output"];
  /** Turns a scheduled broadcast back into a draft and refunds its credits. */
  cancelScheduledBroadcast: EventBroadcast;
  changePassword?: Maybe<Scalars["String"]["output"]>;
  chatGuestWebsite: GuestWebsiteChatResponse;
  checkInGuest: Scalars["Boolean"]["output"];
  clearEventCache: Scalars["Boolean"]["output"];
  comment?: Maybe<Scalars["String"]["output"]>;
  createAlbum?: Maybe<Album>;
  createAseobi: Scalars["UUID"]["output"];
  createAseobiPackage: AseobiPackage;
  /**
   * role is a top-level argument: celebrant (default) or planner.
   *   Other EventOwnerRole values are rejected. A planner cannot supply bank_account.
   */
  createBirthday: Event;
  createBirthdayStripeConnectAccount: StripeConnectOnboardingResponse;
  createBirthdayStripeConnectLoginLink: Scalars["String"]["output"];
  createEvent?: Maybe<Event>;
  createFAQ: FaqResponse;
  createGeneralInviteV3: GeneralInvite;
  createGuestCategory: Category;
  createGuestUpload: GuestUpload;
  createInvitationCard: InvitationCard;
  createInvitationSlot: InvitationSlot;
  createLiveSchedule?: Maybe<Scalars["String"]["output"]>;
  createMessage: Scalars["String"]["output"];
  createMultipleGuestCategories?: Maybe<Array<Category>>;
  createNote: Note;
  createRecItem: RecommendationItem;
  createRecList: RecList;
  createRecommendation: Recommendation;
  createStripeConnectAccount?: Maybe<StripeConnectOnboardingResponse>;
  createStripeConnectLoginLink?: Maybe<Scalars["String"]["output"]>;
  createTable?: Maybe<Scalars["Boolean"]["output"]>;
  /** Permanently deletes the caller's account immediately: PII anonymized, sole-owned weddings taken offline. Irreversible. */
  deleteAccount: Scalars["String"]["output"];
  deleteAlbum?: Maybe<Scalars["String"]["output"]>;
  deleteAseobi: Scalars["String"]["output"];
  deleteAseobiAttire: Scalars["String"]["output"];
  deleteBackStory?: Maybe<Scalars["String"]["output"]>;
  deleteBirthday: Scalars["Boolean"]["output"];
  deleteCustomMyPlanTask?: Maybe<Scalars["Boolean"]["output"]>;
  /** Soft-deletes a saved draft broadcast. */
  deleteDraftBroadcast: Scalars["Boolean"]["output"];
  deleteEvent?: Maybe<Scalars["String"]["output"]>;
  deleteEventPart: Scalars["String"]["output"];
  deleteEventTaskAsset?: Maybe<Scalars["Boolean"]["output"]>;
  deleteEventTaskComment?: Maybe<Scalars["Boolean"]["output"]>;
  deleteFAQ: FaqResponse;
  deleteForeignAccountDetails: Scalars["Boolean"]["output"];
  deleteGeneralInviteV3: Scalars["Boolean"]["output"];
  deleteGuestCategory: Scalars["String"]["output"];
  deleteInvitationSlotByCode: Scalars["Boolean"]["output"];
  deleteLiveSchedule: Scalars["Boolean"]["output"];
  deleteMedia?: Maybe<Scalars["String"]["output"]>;
  deleteMessageById: Scalars["String"]["output"];
  deleteNote: Note;
  deleteRecItem: Scalars["Boolean"]["output"];
  deleteRecList: Scalars["Boolean"]["output"];
  deleteRecommendation: Recommendation;
  deleteTable?: Maybe<Scalars["Boolean"]["output"]>;
  deleteTableSeat?: Maybe<Scalars["Boolean"]["output"]>;
  deleteWeddingParty?: Maybe<Scalars["String"]["output"]>;
  deleteWishListItem: Scalars["String"]["output"];
  detachDomain: CustomDomain;
  detachEventWalletFromSubaccount?: Maybe<Scalars["Boolean"]["output"]>;
  downloadInawoPasses?: Maybe<Scalars["Boolean"]["output"]>;
  editCustomMyPlanTask: EventTask;
  estimateInvitationCost: EstimateInvitationCostResp;
  finishPasskeyLogin: AuthResponse;
  finishPasskeyRegistration: Scalars["Boolean"]["output"];
  generateAseobiAttirePresignUrl: AseobiAttirePresignUrlResponse;
  generateAseobiPackageMediaUploadUrl: AseobiPackageMediaUploadResponse;
  generateAsoebiPaymentMetadata: AsoebiPaymentMetaData;
  generateBackstoryPresignedUrl: BackStoryPresignedUrlResponse;
  generateBirthdayGiftPaymentMetadata: BirthdayGiftPaymentMetaData;
  generateBirthdayMediaPresignedUrl: BirthdayMediaPresignUrlResponse;
  generateBirthdayWishVideoPresignedUrl: BirthdayWishVideoPresignUrlResponse;
  generateCategoryInviteMessageImagePresignedURL: CategoryInviteMessageImagePresignedUrlResponse;
  generateCoupleImagePresignedUrl: CoupleImagePresignedUrlResponse;
  generateCustomDomainPaymentMetadata: CustomDomainPaymentMetaData;
  generateEventPreviewToken: AuthResponse;
  generateEventTaskAssetPresignedUrl: EventTaskAssetPresignedUrlResponse;
  generateGiftPaymentMetadata: GiftPaymentMetaData;
  generateInawoAssistantPaymentMetadata: InawoAssistantPaymentMetaData;
  generateInvitationCardPresignedUrl: InvitationCardPresignedUrlResponse;
  generateInvitationSelfiePreSignedUrl: SelfiePresignUrlResponse;
  generateInviteFeePaymentMetadata: InviteFeePaymentMetaData;
  generateLuxePaymentMetadata: LuxePaymentMetaData;
  generatePreviewToken: Scalars["String"]["output"];
  generateProfileImagePreSignedUrl: ProfilePresignUrlResponse;
  generateSeatingChartImagePresignedUrl: SeatingChartImagePresignedUrlResponse;
  generateSprayMoneyMetadata: SprayMoneyMetaData;
  generateWeddingPartyPresignedUrl: WeddingPartyPresignedUrlResponse;
  generateWishListPresignedUrl: WishListPresignedUrlResponse;
  getBirthdayStripeConnectAccountStatus: StripeConnectStatusResponse;
  getInawoAskImageUploadUrl: InawoAskImageUpload;
  getMediaPresignedUrl: MediaPresignUrlResponse;
  getSprayMoneyCode: SprayMoneyResponse;
  getStripeConnectAccountStatus?: Maybe<StripeConnectStatusResponse>;
  guestLogin: AuthResponse;
  helloLiveEvents: Scalars["Boolean"]["output"];
  hiUser: Scalars["String"]["output"];
  incrementEventWebsiteView: Scalars["Boolean"]["output"];
  initiateBirthdayStripePaymentIntent: InitiatePaymentResponse;
  initiateLuxeCardPayment: InitiateLuxeCardPaymentResponse;
  initiateStripePaymentIntent: InitiatePaymentResponse;
  likeAlbum?: Maybe<Scalars["String"]["output"]>;
  likeMedia: Scalars["String"]["output"];
  login: AuthResponse;
  logout: Scalars["String"]["output"];
  markAllNotificationsRead: Scalars["Int"]["output"];
  markNotificationRead: InboxNotification;
  payForSprayMoneyV1: Scalars["Boolean"]["output"];
  /**
   * Previews an app broadcast using the same Guests management access as other broadcasts.
   *   App recipients need verified linked invitations; no SMS/WhatsApp credits are charged.
   */
  previewBroadcastAnnouncement: WeddingAnnouncementPreview;
  /** @deprecated Retired: use previewBroadcastAnnouncement from Broadcasts. */
  previewWeddingAnnouncement: WeddingAnnouncementPreview;
  publishAseobi: Scalars["Boolean"]["output"];
  publishAseobiPackage: AseobiPackage;
  publishBirthday: Event;
  publishGuestWebsite: Scalars["Boolean"]["output"];
  publishWeddingInvitation: Scalars["Boolean"]["output"];
  publishWeddingPass: WeddingGuestPass;
  redeemLuxeCard: Scalars["Boolean"]["output"];
  registerPushDevice: PushDevice;
  removeEventVendor?: Maybe<Scalars["String"]["output"]>;
  removeFromInvitationList: Scalars["String"]["output"];
  removeHeroImage?: Maybe<Scalars["String"]["output"]>;
  removePassImage?: Maybe<Scalars["Boolean"]["output"]>;
  removeStreamerFromInviteList?: Maybe<Scalars["Boolean"]["output"]>;
  removeTeamMember?: Maybe<Scalars["Boolean"]["output"]>;
  reorderFAQs: Array<Faq>;
  replyMessage?: Maybe<Scalars["String"]["output"]>;
  requestGuestLoginOTP: Scalars["String"]["output"];
  requestPlusOne: Array<PlusOneRequest>;
  /** Re-send the verification OTP for a pending identifier. */
  resendUserIdentifierOTP: Scalars["String"]["output"];
  resendVerifyPhoneOTP?: Maybe<Scalars["Boolean"]["output"]>;
  reserveTable?: Maybe<Scalars["Boolean"]["output"]>;
  resetGeneralInviteToken?: Maybe<Scalars["String"]["output"]>;
  resetPassword: Scalars["String"]["output"];
  resolveBankAccountWithFlutterwave?: Maybe<Account>;
  resolveBankAccountWithPaystack?: Maybe<Account>;
  respondToPlusOne: Array<PlusOneRequest>;
  respondToWeddingPart: WeddingInvitationPart;
  retryDomainPurchase: CustomDomain;
  revokeWeddingInvitation: Scalars["Boolean"]["output"];
  selectTemplate: Scalars["String"]["output"];
  sendBirthdayWish: Message;
  sendBouncerSecret?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * Explicitly accepts an app broadcast and creates its Broadcasts history row atomically.
   *   Idempotency, immutable content and preview recipient snapshots apply.
   * @deprecated Use broadcastMessage with channels:[push] and app_notification to share drafts, scheduling and channels.
   */
  sendBroadcastAnnouncement: WeddingAnnouncement;
  sendContactSupportMail: Scalars["Boolean"]["output"];
  /** Sends a saved draft now, or at scheduled_at if given. */
  sendDraftBroadcast: EventBroadcast;
  sendForgetPasswordOTP: Scalars["String"]["output"];
  sendInawoPass?: Maybe<Scalars["Boolean"]["output"]>;
  sendInvitations?: Maybe<SendInvitationsResponse>;
  /** @deprecated Retired: use sendBroadcastAnnouncement from Broadcasts. */
  sendWeddingAnnouncement: WeddingAnnouncement;
  setEventCache: Scalars["Boolean"]["output"];
  setEventPartPeople: Scalars["Boolean"]["output"];
  setForeignAccountDetails: Scalars["Boolean"]["output"];
  setHeroImage?: Maybe<Scalars["String"]["output"]>;
  setPassImage?: Maybe<Scalars["Boolean"]["output"]>;
  setUpBirthdayFlutterwaveSubaccount: Scalars["Boolean"]["output"];
  setUpBirthdayPaystackSubaccount: Scalars["Boolean"]["output"];
  setUpFlutterwaveSubaccount?: Maybe<Scalars["Boolean"]["output"]>;
  setUpPaystackSubaccount?: Maybe<Scalars["Boolean"]["output"]>;
  setWeddingInvitationParts: Array<WeddingInvitationPart>;
  setWeddingPushMute: WeddingPushMute;
  shrinkLink?: Maybe<Scalars["String"]["output"]>;
  signupByInviteLink?: Maybe<GeneralInviteResp>;
  signupByPhoneNumber?: Maybe<Scalars["Boolean"]["output"]>;
  sprayMoney: Scalars["Boolean"]["output"];
  startStreaming: Scalars["Boolean"]["output"];
  stopStreaming: Scalars["Boolean"]["output"];
  /** submit the reason a user abandoned a payment; sends a support email when option is CONTACT_SUPPORT */
  submitAbandonedPaymentSurvey: Scalars["Boolean"]["output"];
  trackDirectInvitations?: Maybe<SendInvitationsResponse>;
  unlikeAlbum?: Maybe<Scalars["String"]["output"]>;
  unlikeMedia: Scalars["String"]["output"];
  unpublishAseobi: Scalars["Boolean"]["output"];
  unpublishGuestWebsite: Scalars["Boolean"]["output"];
  unregisterPushDevice: Scalars["Boolean"]["output"];
  updateAlbum?: Maybe<Album>;
  updateAseobi: Scalars["UUID"]["output"];
  updateAseobiAttire: Scalars["UUID"]["output"];
  updateAseobiOrderStatus: Scalars["Boolean"]["output"];
  updateAseobiPackage: AseobiPackage;
  updateBackStory?: Maybe<BackStory>;
  updateBirthday: Event;
  updateBirthdayCardTemplate: BirthdayCardTemplate;
  updateBirthdayWishStatus: Message;
  updateDoneStatus?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * Updates a saved draft before it is sent. Omitted fields are left unchanged.
   *   Pass an empty invitation_ids list to return the draft to the default recipient cohort.
   */
  updateDraftBroadcast: EventBroadcast;
  updateEvent?: Maybe<Event>;
  updateEventPart: EventPart;
  updateEventPreference?: Maybe<EventPreference>;
  updateEventSlug?: Maybe<Event>;
  updateEventTeamMemberRole?: Maybe<Scalars["Boolean"]["output"]>;
  updateEventVendor?: Maybe<EventVendor>;
  updateFAQ: FaqResponse;
  updateForeignAccountDetails: Scalars["Boolean"]["output"];
  updateGeneralInviteV3: GeneralInvite;
  updateGuestCategory: Category;
  updateInvitationCard?: Maybe<InvitationCard>;
  updateInvitationSlot: InvitationSlot;
  updateInviteList?: Maybe<Scalars["String"]["output"]>;
  updateLiveSchedule?: Maybe<Scalars["String"]["output"]>;
  updateMedia?: Maybe<AlbumMedia>;
  updateMediaOrder?: Maybe<AlbumMedia>;
  updateMessage: Message;
  updateMessageStatus: Scalars["String"]["output"];
  updateNote: Note;
  updateNotificationPreferences: NotificationPreferences;
  updateRecItem: RecommendationItem;
  updateRecList: RecList;
  updateRecommendation: Recommendation;
  updateRsvpStatus: Scalars["Boolean"]["output"];
  updateStreamer?: Maybe<Scalars["Boolean"]["output"]>;
  updateTable?: Maybe<Scalars["Boolean"]["output"]>;
  updateUserProfile?: Maybe<User>;
  /** @deprecated Retired: returns REMINDERS_SERVER_MANAGED for all inputs. Manage dates and timezones through Event Parts. */
  updateWeddingGuestNotificationSettings: WeddingGuestNotificationSettings;
  updateWeddingParty?: Maybe<WeddingParty>;
  updateWishListItem?: Maybe<WishListItem>;
  upgradeToLuxe: Scalars["Boolean"]["output"];
  uploadGuestWebsiteHTML: GuestWebsiteUploadResponse;
  verifyAnonymousGuestMediaUpload: Scalars["String"]["output"];
  verifyAseobiAttireUpload: Scalars["String"]["output"];
  verifyAseobiPackageMediaUpload: Scalars["Boolean"]["output"];
  verifyBirthdayGiftPayment: Gift;
  verifyBirthdayMediaUpload: Scalars["Boolean"]["output"];
  verifyCoupleImageUpload: Scalars["String"]["output"];
  verifyEventPreviewToken: AuthResponse;
  verifyInvitationCardUpload: Scalars["String"]["output"];
  verifyInvitationSelfieUpload: Scalars["String"]["output"];
  verifyMediaUpload: Scalars["String"]["output"];
  verifyPhone: AuthResponse;
  verifyTransaction: TransactionV1;
  /** Confirm an added identifier with its OTP; on success it becomes login-eligible. */
  verifyUserIdentifier: Scalars["String"]["output"];
  verifyWishListUpload: Scalars["String"]["output"];
};

export type MutationGeneralInviteListReqArgs = {
  args: AddToInviteListReq;
  event_token: Scalars["String"]["input"];
};

export type MutationAcceptEventTeamArgs = {
  token: Scalars["String"]["input"];
};

export type MutationAddAseobiAttireArgs = {
  event_id: Scalars["UUID"]["input"];
  input: AseobiAttireInput;
};

export type MutationAddAsoebiAttireFromOypleArgs = {
  event_id: Scalars["UUID"]["input"];
  input: OypleAsoebiAttireInput;
};

export type MutationAddBackStoryArgs = {
  event_id: Scalars["Int"]["input"];
  input: AddBackStoryReq;
};

export type MutationAddCustomMyPlanTaskArgs = {
  deadline?: InputMaybe<Scalars["Time"]["input"]>;
  description: Scalars["String"]["input"];
  due_date?: InputMaybe<Scalars["Time"]["input"]>;
  event_id: Scalars["UUID"]["input"];
  taskName: Scalars["String"]["input"];
};

export type MutationAddEventPartArgs = {
  input: AddEventPartRequest;
};

export type MutationAddEventTaskAssetArgs = {
  event_id: Scalars["UUID"]["input"];
  file_name: Scalars["String"]["input"];
  file_type: Scalars["String"]["input"];
  file_url: Scalars["String"]["input"];
  task_id: Scalars["UUID"]["input"];
};

export type MutationAddEventTaskCommentArgs = {
  comment: Scalars["String"]["input"];
  event_id: Scalars["UUID"]["input"];
  task_id: Scalars["UUID"]["input"];
};

export type MutationAddEventTeamMemberArgs = {
  team: TeamMemberInvite;
};

export type MutationAddEventVendorArgs = {
  input: AddEventVendorRequest;
};

export type MutationAddGuestToInviteListArgs = {
  event_id: Scalars["Int"]["input"];
  guest: AddToInviteListReq;
};

export type MutationAddGuestViaInvitationSlotArgs = {
  event_id: Scalars["UUID"]["input"];
  guest: AddToInviteListReq;
  slot_code: Scalars["String"]["input"];
};

export type MutationAddMediaArgs = {
  album_id?: InputMaybe<Scalars["UUID"]["input"]>;
  event_id: Scalars["UUID"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  tags: Array<AlbumMediaTag>;
  type?: InputMaybe<Scalars["String"]["input"]>;
  url: Scalars["String"]["input"];
};

export type MutationAddMediaToAlbumArgs = {
  album_id: Scalars["UUID"]["input"];
  event_id: Scalars["UUID"]["input"];
  media_ids: Array<Scalars["String"]["input"]>;
  tags?: InputMaybe<Array<AlbumMediaTag>>;
};

export type MutationAddStreamerFromInviteListArgs = {
  args: Array<CreateStreamer>;
};

export type MutationAddToInviteListArgs = {
  event_id: Scalars["Int"]["input"];
  invite_list: Array<AddToInviteListReq>;
};

export type MutationAddUserIdentifierArgs = {
  kind: UserIdentifierKind;
  value: Scalars["String"]["input"];
};

export type MutationAddWeddingPartyArgs = {
  event_id: Scalars["UUID"]["input"];
  input: AddWeddingPartyReq;
};

export type MutationAddWishListItemArgs = {
  amount: Scalars["Float"]["input"];
  currency: Currency;
  event_id: Scalars["UUID"]["input"];
  image: Scalars["String"]["input"];
  link?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
};

export type MutationAppreciateGiftArgs = {
  appreciation: Scalars["String"]["input"];
  event_id: Scalars["Int"]["input"];
  transactionId: Scalars["String"]["input"];
  walletId: Scalars["String"]["input"];
};

export type MutationArchiveAseobiPackageArgs = {
  event_id: Scalars["UUID"]["input"];
  expected_version: Scalars["Int"]["input"];
  package_id: Scalars["UUID"]["input"];
};

export type MutationAskInawoArgs = {
  conversation_id?: InputMaybe<Scalars["UUID"]["input"]>;
  event_id: Scalars["UUID"]["input"];
  images?: InputMaybe<Array<Scalars["String"]["input"]>>;
  question: Scalars["String"]["input"];
};

export type MutationAttachAseobiPaymentArgs = {
  aseobi_id: Scalars["UUID"]["input"];
  currency_iso: Currency;
  event_id: Scalars["UUID"]["input"];
  subaccount_code: Scalars["String"]["input"];
};

export type MutationAttachDomainArgs = {
  input: AttachDomainInput;
};

export type MutationAttachEventWalletToSubaccountArgs = {
  event_id: Scalars["UUID"]["input"];
  input: AttachEventWalletToSubaccountInput;
};

export type MutationAuthenticateBouncerSecretArgs = {
  bouncer_email: Scalars["String"]["input"];
  event_id: Scalars["UUID"]["input"];
  secret: Scalars["String"]["input"];
};

export type MutationAuthenticateInviteLinkArgs = {
  event_id: Scalars["Int"]["input"];
  inviteToken: Scalars["String"]["input"];
};

export type MutationAutoReserveTableArgs = {
  event_id: Scalars["UUID"]["input"];
  event_part_id: Scalars["UUID"]["input"];
  request: AutoReserveTableRequest;
};

export type MutationAutoSendInawoPassArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type MutationBeginPasskeyLoginArgs = {
  identifier?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationBookingOrderCreateArgs = {
  input: BookingOrderCreateInput;
};

export type MutationBookingOrderPreviewArgs = {
  input: BookingOrderPreviewInput;
};

export type MutationBroadcastAppreciationArgs = {
  appreciation: Scalars["String"]["input"];
  event_id: Scalars["Int"]["input"];
};

export type MutationBroadcastMessageArgs = {
  app_notification?: InputMaybe<BroadcastAppNotificationInput>;
  broadcast_id?: InputMaybe<Scalars["UUID"]["input"]>;
  channels?: InputMaybe<Array<Channel>>;
  draft?: InputMaybe<Scalars["Boolean"]["input"]>;
  event_id: Scalars["UUID"]["input"];
  invitation_ids?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  link_type?: InputMaybe<EventBroadcastLinkType>;
  message?: InputMaybe<Scalars["String"]["input"]>;
  scheduled_at?: InputMaybe<Scalars["Time"]["input"]>;
};

export type MutationBulkCreateFaQsArgs = {
  event_id: Scalars["UUID"]["input"];
  faqs: Array<CreateFaqInput>;
};

export type MutationBulkDeleteMediaArgs = {
  event_id: Scalars["UUID"]["input"];
  media_id: Array<Scalars["UUID"]["input"]>;
};

export type MutationCancelAsoebiCheckoutArgs = {
  event_id: Scalars["UUID"]["input"];
  payment_reference: Scalars["String"]["input"];
};

export type MutationCancelScheduledBroadcastArgs = {
  broadcast_id: Scalars["UUID"]["input"];
  event_id: Scalars["UUID"]["input"];
};

export type MutationChangePasswordArgs = {
  newPassword: Scalars["String"]["input"];
  oldPassword: Scalars["String"]["input"];
};

export type MutationChatGuestWebsiteArgs = {
  event_id: Scalars["UUID"]["input"];
  message: Scalars["String"]["input"];
  start_fresh?: Scalars["Boolean"]["input"];
};

export type MutationCheckInGuestArgs = {
  event_id: Scalars["UUID"]["input"];
  request: CheckInGuestRequest;
};

export type MutationClearEventCacheArgs = {
  event_id: Scalars["UUID"]["input"];
  key: Scalars["String"]["input"];
};

export type MutationCommentArgs = {
  UserName: Scalars["String"]["input"];
  comment: Scalars["String"]["input"];
  kind: LiveCommentKind;
  liveScheduleID: Scalars["String"]["input"];
};

export type MutationCreateAlbumArgs = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  event_id: Scalars["UUID"]["input"];
  name: Scalars["String"]["input"];
};

export type MutationCreateAseobiArgs = {
  category_id?: InputMaybe<Scalars["UUID"]["input"]>;
  contact: ContactInput;
  deadline: Scalars["Time"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  event_id: Scalars["UUID"]["input"];
  name: Scalars["String"]["input"];
};

export type MutationCreateAseobiPackageArgs = {
  event_id: Scalars["UUID"]["input"];
  input: CreateAseobiPackageInput;
};

export type MutationCreateBirthdayArgs = {
  input: BirthdayInput;
  role?: InputMaybe<EventOwnerRole>;
};

export type MutationCreateBirthdayStripeConnectAccountArgs = {
  birthday_id: Scalars["UUID"]["input"];
  country_iso_alpha2: Scalars["String"]["input"];
  default_currency_iso: Currency;
};

export type MutationCreateBirthdayStripeConnectLoginLinkArgs = {
  birthday_id: Scalars["UUID"]["input"];
  currency: Currency;
};

export type MutationCreateEventArgs = {
  country_iso_alpha2?: InputMaybe<Scalars["String"]["input"]>;
  default_currency_iso?: InputMaybe<Currency>;
  eventTimezone?: InputMaybe<Scalars["String"]["input"]>;
  event_type_id: Scalars["Int"]["input"];
  hashTag?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  role?: InputMaybe<Scalars["String"]["input"]>;
  template_id?: InputMaybe<Scalars["String"]["input"]>;
  welcomeMsg?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateFaqArgs = {
  input: CreateFaqInput;
};

export type MutationCreateGeneralInviteV3Args = {
  category_id: Scalars["UUID"]["input"];
  event_id: Scalars["UUID"]["input"];
  expires_in_seconds: Scalars["Int"]["input"];
  max_uses: Scalars["Int"]["input"];
  name: Scalars["String"]["input"];
};

export type MutationCreateGuestCategoryArgs = {
  event_id: Scalars["Int"]["input"];
  message?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
};

export type MutationCreateGuestUploadArgs = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  event_id: Scalars["UUID"]["input"];
  event_part_id?: InputMaybe<Scalars["UUID"]["input"]>;
  expires_at?: InputMaybe<Scalars["Time"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  tags?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type MutationCreateInvitationCardArgs = {
  event_id: Scalars["UUID"]["input"];
  name: Scalars["String"]["input"];
  static_image: Scalars["String"]["input"];
  template_id: Scalars["UUID"]["input"];
  template_variables: Scalars["Map"]["input"];
};

export type MutationCreateInvitationSlotArgs = {
  input: CreateInvitationSlotInput;
};

export type MutationCreateLiveScheduleArgs = {
  date: Scalars["String"]["input"];
  eventPartUuid: Scalars["String"]["input"];
  eventUuid: Scalars["String"]["input"];
  link: Scalars["String"]["input"];
  time: Scalars["String"]["input"];
};

export type MutationCreateMessageArgs = {
  content: Scalars["String"]["input"];
  event_id: Scalars["Int"]["input"];
};

export type MutationCreateMultipleGuestCategoriesArgs = {
  event_id: Scalars["Int"]["input"];
  names?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type MutationCreateNoteArgs = {
  content: Scalars["String"]["input"];
  event_id: Scalars["UUID"]["input"];
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  order_index?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationCreateRecItemArgs = {
  input: CreateRecItemInput;
};

export type MutationCreateRecListArgs = {
  input: CreateRecListInput;
};

export type MutationCreateRecommendationArgs = {
  description: Scalars["String"]["input"];
  event_id: Scalars["UUID"]["input"];
  image_urls?: InputMaybe<Array<Scalars["String"]["input"]>>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  order_index?: InputMaybe<Scalars["Int"]["input"]>;
  title: Scalars["String"]["input"];
};

export type MutationCreateStripeConnectAccountArgs = {
  country_iso_alpha2: Scalars["String"]["input"];
  default_currency_iso: Currency;
  event_id: Scalars["UUID"]["input"];
};

export type MutationCreateTableArgs = {
  event_id: Scalars["UUID"]["input"];
  event_part_id: Scalars["UUID"]["input"];
  request: CreateTableRequest;
};

export type MutationDeleteAccountArgs = {
  password: Scalars["String"]["input"];
};

export type MutationDeleteAlbumArgs = {
  album_id: Scalars["UUID"]["input"];
  event_id: Scalars["UUID"]["input"];
};

export type MutationDeleteAseobiArgs = {
  aseobi_id: Scalars["UUID"]["input"];
  event_id: Scalars["UUID"]["input"];
};

export type MutationDeleteAseobiAttireArgs = {
  aseobi_attire_id: Scalars["UUID"]["input"];
  event_id: Scalars["UUID"]["input"];
};

export type MutationDeleteBackStoryArgs = {
  event_id: Scalars["Int"]["input"];
  id: Scalars["Int"]["input"];
};

export type MutationDeleteBirthdayArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationDeleteCustomMyPlanTaskArgs = {
  event_id: Scalars["UUID"]["input"];
  task_id: Scalars["UUID"]["input"];
};

export type MutationDeleteDraftBroadcastArgs = {
  broadcast_id: Scalars["UUID"]["input"];
  event_id: Scalars["UUID"]["input"];
};

export type MutationDeleteEventArgs = {
  event_id: Scalars["Int"]["input"];
};

export type MutationDeleteEventPartArgs = {
  event_id: Scalars["Int"]["input"];
  partId: Scalars["Int"]["input"];
};

export type MutationDeleteEventTaskAssetArgs = {
  asset_id: Scalars["UUID"]["input"];
  event_id: Scalars["UUID"]["input"];
};

export type MutationDeleteEventTaskCommentArgs = {
  comment_id: Scalars["UUID"]["input"];
  event_id: Scalars["UUID"]["input"];
};

export type MutationDeleteFaqArgs = {
  event_id: Scalars["UUID"]["input"];
  id: Scalars["UUID"]["input"];
};

export type MutationDeleteForeignAccountDetailsArgs = {
  foreignAccountId: Scalars["String"]["input"];
};

export type MutationDeleteGeneralInviteV3Args = {
  event_id: Scalars["UUID"]["input"];
  link_id: Scalars["UUID"]["input"];
};

export type MutationDeleteGuestCategoryArgs = {
  categoryId: Scalars["Int"]["input"];
  event_id: Scalars["Int"]["input"];
};

export type MutationDeleteInvitationSlotByCodeArgs = {
  eventID: Scalars["UUID"]["input"];
  slotCode: Scalars["String"]["input"];
};

export type MutationDeleteLiveScheduleArgs = {
  id: Scalars["String"]["input"];
};

export type MutationDeleteMediaArgs = {
  event_id: Scalars["UUID"]["input"];
  media_id: Scalars["UUID"]["input"];
};

export type MutationDeleteMessageByIdArgs = {
  event_id: Scalars["Int"]["input"];
  message_id: Scalars["Int"]["input"];
};

export type MutationDeleteNoteArgs = {
  event_id: Scalars["UUID"]["input"];
  id: Scalars["UUID"]["input"];
};

export type MutationDeleteRecItemArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationDeleteRecListArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationDeleteRecommendationArgs = {
  event_id: Scalars["UUID"]["input"];
  id: Scalars["UUID"]["input"];
};

export type MutationDeleteTableArgs = {
  event_id: Scalars["UUID"]["input"];
  event_part_id: Scalars["UUID"]["input"];
  table_id: Scalars["UUID"]["input"];
};

export type MutationDeleteTableSeatArgs = {
  event_id: Scalars["UUID"]["input"];
  event_part_id: Scalars["UUID"]["input"];
  table_seat_ids: Array<Scalars["UUID"]["input"]>;
};

export type MutationDeleteWeddingPartyArgs = {
  event_id: Scalars["UUID"]["input"];
  id: Scalars["UUID"]["input"];
};

export type MutationDeleteWishListItemArgs = {
  event_id: Scalars["UUID"]["input"];
  itemId: Scalars["UUID"]["input"];
};

export type MutationDetachDomainArgs = {
  input: DetachDomainInput;
};

export type MutationDetachEventWalletFromSubaccountArgs = {
  currency: Currency;
  event_id: Scalars["UUID"]["input"];
};

export type MutationDownloadInawoPassesArgs = {
  event_id: Scalars["UUID"]["input"];
  invitation_ids: Array<Scalars["UUID"]["input"]>;
};

export type MutationEditCustomMyPlanTaskArgs = {
  deadline?: InputMaybe<Scalars["Time"]["input"]>;
  description: Scalars["String"]["input"];
  due_date?: InputMaybe<Scalars["Time"]["input"]>;
  event_id: Scalars["UUID"]["input"];
  taskName: Scalars["String"]["input"];
  task_id: Scalars["UUID"]["input"];
};

export type MutationEstimateInvitationCostArgs = {
  event_id: Scalars["UUID"]["input"];
  req: EstimateInvitationCostReq;
};

export type MutationFinishPasskeyLoginArgs = {
  input: PasskeyFinishRequest;
};

export type MutationFinishPasskeyRegistrationArgs = {
  input: PasskeyFinishRequest;
};

export type MutationGenerateAseobiAttirePresignUrlArgs = {
  attire_id: Scalars["UUID"]["input"];
  event_id: Scalars["UUID"]["input"];
  mediaType: Scalars["String"]["input"];
};

export type MutationGenerateAseobiPackageMediaUploadUrlArgs = {
  event_id: Scalars["UUID"]["input"];
  item_id?: InputMaybe<Scalars["UUID"]["input"]>;
  mediaType: Scalars["String"]["input"];
  package_id: Scalars["UUID"]["input"];
};

export type MutationGenerateAsoebiPaymentMetadataArgs = {
  event_id: Scalars["UUID"]["input"];
  input: AseobiPaymentMetadataRequest;
};

export type MutationGenerateBackstoryPresignedUrlArgs = {
  event_id: Scalars["UUID"]["input"];
  mediaType: Scalars["String"]["input"];
};

export type MutationGenerateBirthdayGiftPaymentMetadataArgs = {
  input: BirthdayGiftPaymentMetadataRequest;
};

export type MutationGenerateBirthdayMediaPresignedUrlArgs = {
  birthday_id: Scalars["UUID"]["input"];
  content_type: Scalars["String"]["input"];
  kind: BirthdayMediaKind;
};

export type MutationGenerateBirthdayWishVideoPresignedUrlArgs = {
  content_type: Scalars["String"]["input"];
  slug: Scalars["String"]["input"];
};

export type MutationGenerateCategoryInviteMessageImagePresignedUrlArgs = {
  category_id: Scalars["UUID"]["input"];
  event_id: Scalars["UUID"]["input"];
  mediaType: Scalars["String"]["input"];
};

export type MutationGenerateCoupleImagePresignedUrlArgs = {
  event_id: Scalars["UUID"]["input"];
  mediaType: Scalars["String"]["input"];
  role: CoupleRole;
};

export type MutationGenerateCustomDomainPaymentMetadataArgs = {
  input: CustomDomainPaymentMetadataRequest;
};

export type MutationGenerateEventPreviewTokenArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type MutationGenerateEventTaskAssetPresignedUrlArgs = {
  event_id: Scalars["UUID"]["input"];
  file_name: Scalars["String"]["input"];
  file_type: Scalars["String"]["input"];
  task_id: Scalars["UUID"]["input"];
};

export type MutationGenerateGiftPaymentMetadataArgs = {
  input: GiftPaymentMetadataRequest;
};

export type MutationGenerateInawoAssistantPaymentMetadataArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type MutationGenerateInvitationCardPresignedUrlArgs = {
  event_id: Scalars["UUID"]["input"];
  mediaType: Scalars["String"]["input"];
};

export type MutationGenerateInvitationSelfiePreSignedUrlArgs = {
  event_id: Scalars["UUID"]["input"];
  invitation_id: Scalars["UUID"]["input"];
  mediaType: Scalars["String"]["input"];
};

export type MutationGenerateInviteFeePaymentMetadataArgs = {
  channel: Scalars["String"]["input"];
  count: Scalars["Int"]["input"];
  event_id: Scalars["UUID"]["input"];
  payment_provider?: InputMaybe<PaymentProcessor>;
  request?: InputMaybe<SendInviteReq>;
};

export type MutationGenerateLuxePaymentMetadataArgs = {
  input: LuxePaymentMetadataRequest;
};

export type MutationGeneratePreviewTokenArgs = {
  eventId: Scalars["UUID"]["input"];
};

export type MutationGenerateProfileImagePreSignedUrlArgs = {
  mediaType: Scalars["String"]["input"];
};

export type MutationGenerateSeatingChartImagePresignedUrlArgs = {
  event_id: Scalars["UUID"]["input"];
  event_part_id: Scalars["UUID"]["input"];
  mediaType: Scalars["String"]["input"];
};

export type MutationGenerateSprayMoneyMetadataArgs = {
  input: SprayMoneyMetadataRequest;
};

export type MutationGenerateWeddingPartyPresignedUrlArgs = {
  event_id: Scalars["UUID"]["input"];
  mediaType: Scalars["String"]["input"];
};

export type MutationGenerateWishListPresignedUrlArgs = {
  event_id: Scalars["UUID"]["input"];
  mediaType: Scalars["String"]["input"];
};

export type MutationGetBirthdayStripeConnectAccountStatusArgs = {
  birthday_id: Scalars["UUID"]["input"];
  currency: Currency;
};

export type MutationGetInawoAskImageUploadUrlArgs = {
  event_id: Scalars["UUID"]["input"];
  media_type: Scalars["String"]["input"];
};

export type MutationGetMediaPresignedUrlArgs = {
  event_id: Scalars["UUID"]["input"];
  mediaType: Scalars["String"]["input"];
  secret?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationGetSprayMoneyCodeArgs = {
  liveScheduleID: Scalars["String"]["input"];
  paymentProcessor: Scalars["String"]["input"];
  reference: Scalars["String"]["input"];
  sprays: Array<SprayInput>;
  username: Scalars["String"]["input"];
};

export type MutationGuestLoginArgs = {
  input: GuestLoginRequest;
};

export type MutationHiUserArgs = {
  name: Scalars["String"]["input"];
};

export type MutationIncrementEventWebsiteViewArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type MutationInitiateBirthdayStripePaymentIntentArgs = {
  args: BirthdayInitiatePaymentInput;
};

export type MutationInitiateLuxeCardPaymentArgs = {
  email: Scalars["String"]["input"];
};

export type MutationInitiateStripePaymentIntentArgs = {
  args: InitiatePaymentInput;
};

export type MutationLikeAlbumArgs = {
  album_id: Scalars["UUID"]["input"];
  event_id: Scalars["UUID"]["input"];
};

export type MutationLikeMediaArgs = {
  event_id: Scalars["UUID"]["input"];
  media_id: Scalars["UUID"]["input"];
};

export type MutationLoginArgs = {
  input: LoginRequest;
};

export type MutationMarkAllNotificationsReadArgs = {
  event_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type MutationMarkNotificationReadArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationPayForSprayMoneyV1Args = {
  payload: PayForSprayMoneyRequest;
};

export type MutationPreviewBroadcastAnnouncementArgs = {
  event_id: Scalars["UUID"]["input"];
  input: WeddingAnnouncementInput;
};

export type MutationPreviewWeddingAnnouncementArgs = {
  event_id: Scalars["UUID"]["input"];
  input: WeddingAnnouncementInput;
};

export type MutationPublishAseobiArgs = {
  aseobi_id: Scalars["UUID"]["input"];
  event_id: Scalars["UUID"]["input"];
};

export type MutationPublishAseobiPackageArgs = {
  event_id: Scalars["UUID"]["input"];
  expected_version: Scalars["Int"]["input"];
  package_id: Scalars["UUID"]["input"];
};

export type MutationPublishBirthdayArgs = {
  id: Scalars["UUID"]["input"];
  published: Scalars["Boolean"]["input"];
};

export type MutationPublishGuestWebsiteArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type MutationPublishWeddingInvitationArgs = {
  event_id: Scalars["UUID"]["input"];
  invitation_id: Scalars["UUID"]["input"];
  passes?: InputMaybe<Array<WeddingPassInput>>;
};

export type MutationPublishWeddingPassArgs = {
  event_id: Scalars["UUID"]["input"];
  input: WeddingPassInput;
  invitation_id: Scalars["UUID"]["input"];
};

export type MutationRedeemLuxeCardArgs = {
  code: Scalars["String"]["input"];
  event_id: Scalars["UUID"]["input"];
  pin: Scalars["String"]["input"];
};

export type MutationRegisterPushDeviceArgs = {
  input: RegisterPushDeviceInput;
};

export type MutationRemoveEventVendorArgs = {
  event_id: Scalars["Int"]["input"];
  vendorId: Scalars["Int"]["input"];
};

export type MutationRemoveFromInvitationListArgs = {
  event_id: Scalars["Int"]["input"];
  invitation_list_ids: Array<Scalars["Int"]["input"]>;
};

export type MutationRemoveHeroImageArgs = {
  event_id: Scalars["Int"]["input"];
};

export type MutationRemovePassImageArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type MutationRemoveStreamerFromInviteListArgs = {
  streamerId: Scalars["String"]["input"];
};

export type MutationRemoveTeamMemberArgs = {
  event_id: Scalars["UUID"]["input"];
  team_member_id: Scalars["UUID"]["input"];
};

export type MutationReorderFaQsArgs = {
  event_id: Scalars["UUID"]["input"];
  faq_orders: Array<FaqOrderInput>;
};

export type MutationReplyMessageArgs = {
  event_id: Scalars["Int"]["input"];
  message_id: Scalars["Int"]["input"];
  reply: Scalars["String"]["input"];
};

export type MutationRequestGuestLoginOtpArgs = {
  email: Scalars["String"]["input"];
  event_id: Scalars["UUID"]["input"];
};

export type MutationRequestPlusOneArgs = {
  event_id: Scalars["UUID"]["input"];
  guest: PlusOneGuestInput;
};

export type MutationResendUserIdentifierOtpArgs = {
  kind: UserIdentifierKind;
  value: Scalars["String"]["input"];
};

export type MutationResendVerifyPhoneOtpArgs = {
  phone: Scalars["String"]["input"];
};

export type MutationReserveTableArgs = {
  event_id: Scalars["UUID"]["input"];
  event_part_id: Scalars["UUID"]["input"];
  request: ReservationRequest;
};

export type MutationResetGeneralInviteTokenArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type MutationResetPasswordArgs = {
  OTP: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
  phone: Scalars["String"]["input"];
};

export type MutationResolveBankAccountWithFlutterwaveArgs = {
  account_number: Scalars["String"]["input"];
  bank_code: Scalars["String"]["input"];
};

export type MutationResolveBankAccountWithPaystackArgs = {
  account_number: Scalars["String"]["input"];
  bank_code: Scalars["String"]["input"];
};

export type MutationRespondToPlusOneArgs = {
  decisions: Array<PlusOneDecisionInput>;
  event_id: Scalars["UUID"]["input"];
};

export type MutationRespondToWeddingPartArgs = {
  event_part_id: Scalars["UUID"]["input"];
  invitation_id: Scalars["UUID"]["input"];
  status: Scalars["String"]["input"];
};

export type MutationRetryDomainPurchaseArgs = {
  domain_id: Scalars["UUID"]["input"];
};

export type MutationRevokeWeddingInvitationArgs = {
  event_id: Scalars["UUID"]["input"];
  invitation_id: Scalars["UUID"]["input"];
};

export type MutationSelectTemplateArgs = {
  req: SelectTemplateReq;
};

export type MutationSendBirthdayWishArgs = {
  input: BirthdayWishInput;
  slug: Scalars["String"]["input"];
};

export type MutationSendBouncerSecretArgs = {
  bouncer_email: Scalars["String"]["input"];
  event_id: Scalars["UUID"]["input"];
};

export type MutationSendBroadcastAnnouncementArgs = {
  event_id: Scalars["UUID"]["input"];
  idempotency_key: Scalars["String"]["input"];
  input: WeddingAnnouncementInput;
  preview_token: Scalars["UUID"]["input"];
};

export type MutationSendContactSupportMailArgs = {
  event_id: Scalars["UUID"]["input"];
  input: ContactSupportMailInput;
};

export type MutationSendDraftBroadcastArgs = {
  app_notification?: InputMaybe<BroadcastAppNotificationInput>;
  broadcast_id: Scalars["UUID"]["input"];
  event_id: Scalars["UUID"]["input"];
  scheduled_at?: InputMaybe<Scalars["Time"]["input"]>;
};

export type MutationSendForgetPasswordOtpArgs = {
  phone: Scalars["String"]["input"];
};

export type MutationSendInawoPassArgs = {
  event_id: Scalars["UUID"]["input"];
  invitation_ids: Array<Scalars["UUID"]["input"]>;
};

export type MutationSendInvitationsArgs = {
  event_id: Scalars["UUID"]["input"];
  req: SendInviteReq;
};

export type MutationSendWeddingAnnouncementArgs = {
  event_id: Scalars["UUID"]["input"];
  idempotency_key: Scalars["String"]["input"];
  input: WeddingAnnouncementInput;
  preview_token: Scalars["UUID"]["input"];
};

export type MutationSetEventCacheArgs = {
  event_id: Scalars["UUID"]["input"];
  expiry_in_seconds: Scalars["Int"]["input"];
  key: Scalars["String"]["input"];
  value: Scalars["Map"]["input"];
};

export type MutationSetEventPartPeopleArgs = {
  event_id: Scalars["UUID"]["input"];
  event_part_id: Scalars["UUID"]["input"];
  invitation_list_ids: Array<Scalars["UUID"]["input"]>;
};

export type MutationSetForeignAccountDetailsArgs = {
  args: ForeignAccountDetails;
};

export type MutationSetHeroImageArgs = {
  event_id: Scalars["Int"]["input"];
  image: Scalars["String"]["input"];
};

export type MutationSetPassImageArgs = {
  event_id: Scalars["UUID"]["input"];
  image: Scalars["String"]["input"];
};

export type MutationSetUpBirthdayFlutterwaveSubaccountArgs = {
  birthday_id: Scalars["UUID"]["input"];
  input: BirthdayBankDetailsRequest;
};

export type MutationSetUpBirthdayPaystackSubaccountArgs = {
  birthday_id: Scalars["UUID"]["input"];
  input: BirthdayBankDetailsRequest;
};

export type MutationSetUpFlutterwaveSubaccountArgs = {
  event_id: Scalars["UUID"]["input"];
  input: UpdateBankDetailsRequestFlw;
};

export type MutationSetUpPaystackSubaccountArgs = {
  event_id: Scalars["UUID"]["input"];
  input: UpdateBankDetailsRequest;
};

export type MutationSetWeddingInvitationPartsArgs = {
  event_id: Scalars["UUID"]["input"];
  invitation_id: Scalars["UUID"]["input"];
  parts: Array<WeddingInvitationPartInput>;
};

export type MutationSetWeddingPushMuteArgs = {
  event_id: Scalars["UUID"]["input"];
  muted: Scalars["Boolean"]["input"];
};

export type MutationShrinkLinkArgs = {
  event_id: Scalars["UUID"]["input"];
  link: Scalars["String"]["input"];
};

export type MutationSignupByInviteLinkArgs = {
  eventId: Scalars["Int"]["input"];
  inviteToken: Scalars["String"]["input"];
};

export type MutationSignupByPhoneNumberArgs = {
  input: SignUpRequest;
};

export type MutationSprayMoneyArgs = {
  currency: Currency;
  spray: Array<SprayInput>;
  sprayCode: Scalars["String"]["input"];
};

export type MutationStartStreamingArgs = {
  streamerId: Scalars["String"]["input"];
};

export type MutationStopStreamingArgs = {
  streamerId: Scalars["String"]["input"];
};

export type MutationSubmitAbandonedPaymentSurveyArgs = {
  email?: InputMaybe<Scalars["Email"]["input"]>;
  event_id: Scalars["UUID"]["input"];
  inawo_product: Scalars["String"]["input"];
  option: AbandonedPaymentReason;
  phone?: InputMaybe<Scalars["E164"]["input"]>;
  text?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationTrackDirectInvitationsArgs = {
  event_id: Scalars["UUID"]["input"];
  invitation_ids: Array<Scalars["UUID"]["input"]>;
  mark: Scalars["Boolean"]["input"];
};

export type MutationUnlikeAlbumArgs = {
  album_id: Scalars["UUID"]["input"];
  event_id: Scalars["UUID"]["input"];
};

export type MutationUnlikeMediaArgs = {
  event_id: Scalars["UUID"]["input"];
  media_id: Scalars["UUID"]["input"];
};

export type MutationUnpublishAseobiArgs = {
  aseobi_id: Scalars["UUID"]["input"];
  event_id: Scalars["UUID"]["input"];
};

export type MutationUnpublishGuestWebsiteArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type MutationUnregisterPushDeviceArgs = {
  installation_id: Scalars["String"]["input"];
};

export type MutationUpdateAlbumArgs = {
  album_id: Scalars["UUID"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  event_id: Scalars["UUID"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateAseobiArgs = {
  category_id?: InputMaybe<Scalars["UUID"]["input"]>;
  contact?: InputMaybe<ContactInput>;
  currency_iso?: InputMaybe<Currency>;
  deadline?: InputMaybe<Scalars["Time"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  event_id: Scalars["UUID"]["input"];
  id: Scalars["UUID"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<AsoebiStatusEnum>;
};

export type MutationUpdateAseobiAttireArgs = {
  event_id: Scalars["UUID"]["input"];
  id: Scalars["UUID"]["input"];
  input: AseobiAttireInput;
};

export type MutationUpdateAseobiOrderStatusArgs = {
  event_id: Scalars["UUID"]["input"];
  order_id: Scalars["UUID"]["input"];
  status: AseobiOrderStatusEnum;
};

export type MutationUpdateAseobiPackageArgs = {
  event_id: Scalars["UUID"]["input"];
  expected_version: Scalars["Int"]["input"];
  input: UpdateAseobiPackageInput;
  package_id: Scalars["UUID"]["input"];
};

export type MutationUpdateBackStoryArgs = {
  event_id: Scalars["Int"]["input"];
  input: UpdateBackStoryReq;
};

export type MutationUpdateBirthdayArgs = {
  id: Scalars["UUID"]["input"];
  input: BirthdayInput;
};

export type MutationUpdateBirthdayCardTemplateArgs = {
  birthday_id: Scalars["UUID"]["input"];
  input: BirthdayCardTemplateInput;
  kind: BirthdayCardKind;
};

export type MutationUpdateBirthdayWishStatusArgs = {
  approved: Scalars["Boolean"]["input"];
  birthday_id: Scalars["UUID"]["input"];
  wish_id: Scalars["UUID"]["input"];
};

export type MutationUpdateDoneStatusArgs = {
  eventID: Scalars["UUID"]["input"];
  isDone: Scalars["Boolean"]["input"];
  task_id: Scalars["UUID"]["input"];
};

export type MutationUpdateDraftBroadcastArgs = {
  app_notification?: InputMaybe<BroadcastAppNotificationInput>;
  broadcast_id: Scalars["UUID"]["input"];
  channels?: InputMaybe<Array<Channel>>;
  clear_link_type?: InputMaybe<Scalars["Boolean"]["input"]>;
  event_id: Scalars["UUID"]["input"];
  invitation_ids?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  link_type?: InputMaybe<EventBroadcastLinkType>;
  message?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateEventArgs = {
  country_iso_alpha2?: InputMaybe<Scalars["String"]["input"]>;
  default_currency_iso?: InputMaybe<Currency>;
  eventTimezone?: InputMaybe<Scalars["String"]["input"]>;
  event_id: Scalars["Int"]["input"];
  event_type_id?: InputMaybe<Scalars["Int"]["input"]>;
  hashTag?: InputMaybe<Scalars["String"]["input"]>;
  logo?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  template_id?: InputMaybe<Scalars["String"]["input"]>;
  toast?: InputMaybe<Scalars["String"]["input"]>;
  welcomeMsg?: InputMaybe<Scalars["String"]["input"]>;
  wishlist_note?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateEventPartArgs = {
  input: UpdateEventPartRequest;
};

export type MutationUpdateEventPreferenceArgs = {
  input?: InputMaybe<UpdateEventPreferenceRequest>;
};

export type MutationUpdateEventSlugArgs = {
  event_id: Scalars["Int"]["input"];
  slug: Scalars["String"]["input"];
};

export type MutationUpdateEventTeamMemberRoleArgs = {
  event_id: Scalars["UUID"]["input"];
  role: EventOwnerRole;
  team_member_id: Scalars["UUID"]["input"];
};

export type MutationUpdateEventVendorArgs = {
  input: UpdateEventVendorRequest;
};

export type MutationUpdateFaqArgs = {
  input: UpdateFaqInput;
};

export type MutationUpdateForeignAccountDetailsArgs = {
  args: ForeignAccountDetails;
  id: Scalars["UUID"]["input"];
};

export type MutationUpdateGeneralInviteV3Args = {
  category_id?: InputMaybe<Scalars["UUID"]["input"]>;
  event_id: Scalars["UUID"]["input"];
  expires_in_seconds?: InputMaybe<Scalars["Int"]["input"]>;
  link_id: Scalars["UUID"]["input"];
  max_uses?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateGuestCategoryArgs = {
  categoryId: Scalars["Int"]["input"];
  event_id: Scalars["Int"]["input"];
  message?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
};

export type MutationUpdateInvitationCardArgs = {
  event_id: Scalars["Int"]["input"];
  template: Scalars["String"]["input"];
};

export type MutationUpdateInvitationSlotArgs = {
  event_id: Scalars["UUID"]["input"];
  input: UpdateInvitationSlotInput;
  slot_id: Scalars["UUID"]["input"];
};

export type MutationUpdateInviteListArgs = {
  event_id: Scalars["Int"]["input"];
  invite_list: Array<UpdateInviteListReq>;
};

export type MutationUpdateLiveScheduleArgs = {
  date?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
  link?: InputMaybe<Scalars["String"]["input"]>;
  time?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateMediaArgs = {
  album_id?: InputMaybe<Scalars["UUID"]["input"]>;
  event_id: Scalars["UUID"]["input"];
  media_id: Scalars["UUID"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  order_index?: InputMaybe<Scalars["Float"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<AlbumMediaTag>>>;
  type?: InputMaybe<Scalars["String"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateMediaOrderArgs = {
  event_id: Scalars["UUID"]["input"];
  media_id: Scalars["UUID"]["input"];
  order_index: Scalars["Float"]["input"];
};

export type MutationUpdateMessageArgs = {
  content: Scalars["String"]["input"];
  message_id: Scalars["Int"]["input"];
};

export type MutationUpdateMessageStatusArgs = {
  event_id: Scalars["Int"]["input"];
  messages: Array<UpdateMessageStatusReq>;
};

export type MutationUpdateNoteArgs = {
  content?: InputMaybe<Scalars["String"]["input"]>;
  event_id: Scalars["UUID"]["input"];
  id: Scalars["UUID"]["input"];
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  order_index?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateNotificationPreferencesArgs = {
  input: NotificationPreferencesInput;
};

export type MutationUpdateRecItemArgs = {
  contactInfo?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  link?: InputMaybe<Scalars["String"]["input"]>;
  mediaType?: InputMaybe<RecMediaType>;
  mediaUrl?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateRecListArgs = {
  category?: InputMaybe<RecCategory>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateRecommendationArgs = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  event_id: Scalars["UUID"]["input"];
  id: Scalars["UUID"]["input"];
  image_urls?: InputMaybe<Array<Scalars["String"]["input"]>>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  order_index?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateRsvpStatusArgs = {
  event_id: Scalars["Int"]["input"];
  status: Scalars["String"]["input"];
};

export type MutationUpdateStreamerArgs = {
  args: UpdateStreamer;
};

export type MutationUpdateTableArgs = {
  event_id: Scalars["UUID"]["input"];
  event_part_id: Scalars["UUID"]["input"];
  request: UpdateTableRequest;
};

export type MutationUpdateUserProfileArgs = {
  input: UpdateUserProfileRequest;
};

export type MutationUpdateWeddingGuestNotificationSettingsArgs = {
  event_id: Scalars["UUID"]["input"];
  input: WeddingGuestNotificationSettingsInput;
};

export type MutationUpdateWeddingPartyArgs = {
  event_id: Scalars["UUID"]["input"];
  input: UpdateWeddingPartyReq;
};

export type MutationUpdateWishListItemArgs = {
  amount?: InputMaybe<Scalars["Float"]["input"]>;
  currency: Currency;
  event_id: Scalars["UUID"]["input"];
  image?: InputMaybe<Scalars["String"]["input"]>;
  itemId: Scalars["UUID"]["input"];
  link?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpgradeToLuxeArgs = {
  eventID: Scalars["UUID"]["input"];
};

export type MutationUploadGuestWebsiteHtmlArgs = {
  event_id: Scalars["UUID"]["input"];
  html: Scalars["String"]["input"];
};

export type MutationVerifyAnonymousGuestMediaUploadArgs = {
  device_id?: InputMaybe<Scalars["String"]["input"]>;
  event_id: Scalars["UUID"]["input"];
  name: Scalars["String"]["input"];
  tags: Array<AlbumMediaTag>;
  url: Scalars["String"]["input"];
};

export type MutationVerifyAseobiAttireUploadArgs = {
  attire_id: Scalars["UUID"]["input"];
  event_id: Scalars["UUID"]["input"];
  fileUri: Scalars["String"]["input"];
  replace: Scalars["Boolean"]["input"];
};

export type MutationVerifyAseobiPackageMediaUploadArgs = {
  event_id: Scalars["UUID"]["input"];
  fileUri: Scalars["String"]["input"];
  package_id: Scalars["UUID"]["input"];
};

export type MutationVerifyBirthdayGiftPaymentArgs = {
  provider: PaymentProcessor;
  reference: Scalars["String"]["input"];
  sub_account_id?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationVerifyBirthdayMediaUploadArgs = {
  birthday_id: Scalars["UUID"]["input"];
  file_uri: Scalars["String"]["input"];
  kind: BirthdayMediaKind;
};

export type MutationVerifyCoupleImageUploadArgs = {
  event_id: Scalars["UUID"]["input"];
  fileUri: Scalars["String"]["input"];
  role: CoupleRole;
};

export type MutationVerifyEventPreviewTokenArgs = {
  eventId: Scalars["UUID"]["input"];
  previewToken: Scalars["String"]["input"];
};

export type MutationVerifyInvitationCardUploadArgs = {
  event_id: Scalars["UUID"]["input"];
  fileUri: Scalars["String"]["input"];
};

export type MutationVerifyInvitationSelfieUploadArgs = {
  event_id: Scalars["UUID"]["input"];
  fileUri: Scalars["String"]["input"];
  invitation_id: Scalars["UUID"]["input"];
};

export type MutationVerifyMediaUploadArgs = {
  event_id: Scalars["UUID"]["input"];
  tags: Array<AlbumMediaTag>;
  url: Scalars["String"]["input"];
};

export type MutationVerifyPhoneArgs = {
  otp: Scalars["String"]["input"];
  phone: Scalars["String"]["input"];
};

export type MutationVerifyTransactionArgs = {
  provider: PaymentProcessor;
  reference: Scalars["String"]["input"];
  sub_account_id?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationVerifyUserIdentifierArgs = {
  kind: UserIdentifierKind;
  otp: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
};

export type MutationVerifyWishListUploadArgs = {
  event_id: Scalars["UUID"]["input"];
  fileUri: Scalars["String"]["input"];
  itemId: Scalars["UUID"]["input"];
};

export type Note = {
  __typename?: "Note";
  content: Scalars["String"]["output"];
  created_at: Scalars["Time"]["output"];
  event_id: Scalars["UUID"]["output"];
  id: Scalars["UUID"]["output"];
  image_url?: Maybe<Scalars["String"]["output"]>;
  is_active: Scalars["Boolean"]["output"];
  order_index?: Maybe<Scalars["Int"]["output"]>;
  title: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Time"]["output"]>;
};

export type NotificationPreferences = {
  __typename?: "NotificationPreferences";
  birthday_recap_push: Scalars["Boolean"]["output"];
  birthday_reminder_days: Array<Scalars["Int"]["output"]>;
  birthday_setup_push: Scalars["Boolean"]["output"];
  birthday_sharing_push: Scalars["Boolean"]["output"];
  cash_gifts_push: Scalars["Boolean"]["output"];
  /** deprecated -> use cash_gifts_push and wishlist_contributions_push; true only while both are on */
  gifts_push: Scalars["Boolean"]["output"];
  reminders_push: Scalars["Boolean"]["output"];
  wedding_announcements_push: Scalars["Boolean"]["output"];
  wedding_reminders_push: Scalars["Boolean"]["output"];
  wedding_rsvp_reminders_push: Scalars["Boolean"]["output"];
  wishes_push: Scalars["Boolean"]["output"];
  wishlist_complete_push: Scalars["Boolean"]["output"];
  wishlist_contributions_push: Scalars["Boolean"]["output"];
  wishlist_halfway_push: Scalars["Boolean"]["output"];
};

export type NotificationPreferencesInput = {
  birthday_recap_push?: InputMaybe<Scalars["Boolean"]["input"]>;
  birthday_reminder_days?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  birthday_setup_push?: InputMaybe<Scalars["Boolean"]["input"]>;
  birthday_sharing_push?: InputMaybe<Scalars["Boolean"]["input"]>;
  cash_gifts_push?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** deprecated -> use cash_gifts_push and wishlist_contributions_push; sets both and can't be sent with either */
  gifts_push?: InputMaybe<Scalars["Boolean"]["input"]>;
  reminders_push?: InputMaybe<Scalars["Boolean"]["input"]>;
  wedding_announcements_push?: InputMaybe<Scalars["Boolean"]["input"]>;
  wedding_reminders_push?: InputMaybe<Scalars["Boolean"]["input"]>;
  wedding_rsvp_reminders_push?: InputMaybe<Scalars["Boolean"]["input"]>;
  wishes_push?: InputMaybe<Scalars["Boolean"]["input"]>;
  wishlist_complete_push?: InputMaybe<Scalars["Boolean"]["input"]>;
  wishlist_contributions_push?: InputMaybe<Scalars["Boolean"]["input"]>;
  wishlist_halfway_push?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type OypleAsoebiAttire = {
  __typename?: "OypleAsoebiAttire";
  assets: Array<OypleMedia>;
  category: OypleCategory;
  colors: Array<OypleColor>;
  currency: Scalars["String"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  gender?: Maybe<OypleGender>;
  id: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  price: Scalars["Float"]["output"];
  size_options: Array<Scalars["String"]["output"]>;
  size_unit?: Maybe<Scalars["String"]["output"]>;
  slug: Scalars["String"]["output"];
  vendor: OypleVendor;
};

export type OypleAsoebiAttires = {
  __typename?: "OypleAsoebiAttires";
  asoebiAttires: Array<OypleAsoebiAttire>;
  page: Scalars["Int"]["output"];
  pageSize: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type OypleCategory = {
  __typename?: "OypleCategory";
  asset?: Maybe<OypleMedia>;
  id: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
};

export type OypleColor = {
  __typename?: "OypleColor";
  hex?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
};

export type OypleFilters = {
  __typename?: "OypleFilters";
  categories: Array<OypleCategory>;
  colors: Array<OypleColor>;
  genders: Array<OypleGender>;
};

export type OypleGender = {
  __typename?: "OypleGender";
  id: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
};

export type OypleMedia = {
  __typename?: "OypleMedia";
  id: Scalars["Int"]["output"];
  positions?: Maybe<Scalars["String"]["output"]>;
  type: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type OypleVendor = {
  __typename?: "OypleVendor";
  name: Scalars["String"]["output"];
};

export type PaginatedAlbum = {
  __typename?: "PaginatedAlbum";
  data: Array<Album>;
  page: Scalars["Int"]["output"];
  pageCount: Scalars["Int"]["output"];
  pageSize: Scalars["Int"]["output"];
  recordCount: Scalars["Int"]["output"];
};

export type PaginatedAlbumMedia = {
  __typename?: "PaginatedAlbumMedia";
  data: Array<AlbumMedia>;
  page: Scalars["Int"]["output"];
  pageCount: Scalars["Int"]["output"];
  pageSize: Scalars["Int"]["output"];
  recordCount: Scalars["Int"]["output"];
};

export type PaginatedAuditLogs = {
  __typename?: "PaginatedAuditLogs";
  data: Array<AuditLog>;
  page: Scalars["Int"]["output"];
  page_count: Scalars["Int"]["output"];
  page_size: Scalars["Int"]["output"];
  record_count: Scalars["Int"]["output"];
};

export type PaginatedFaQs = {
  __typename?: "PaginatedFAQs";
  data: Array<Faq>;
  page: Scalars["Int"]["output"];
  pageCount: Scalars["Int"]["output"];
  pageSize: Scalars["Int"]["output"];
  recordCount: Scalars["Int"]["output"];
};

export type PaginatedLiveComments = {
  __typename?: "PaginatedLiveComments";
  data: Array<LiveComment>;
  page: Scalars["Int"]["output"];
  pageCount: Scalars["Int"]["output"];
  pageSize: Scalars["Int"]["output"];
  recordCount: Scalars["Int"]["output"];
};

export type PaginatedLiveSchedule = {
  __typename?: "PaginatedLiveSchedule";
  data: Array<LiveSchedule>;
  page: Scalars["Int"]["output"];
  pageCount: Scalars["Int"]["output"];
  pageSize: Scalars["Int"]["output"];
  recordCount: Scalars["Int"]["output"];
};

export type Pagination = {
  __typename?: "Pagination";
  back?: Maybe<Scalars["String"]["output"]>;
  next?: Maybe<Scalars["String"]["output"]>;
};

export type PaginationMeta = {
  __typename?: "PaginationMeta";
  page: Scalars["Int"]["output"];
  page_count: Scalars["Int"]["output"];
  page_size: Scalars["Int"]["output"];
  record_count: Scalars["Int"]["output"];
};

export type PasskeyBeginResponse = {
  __typename?: "PasskeyBeginResponse";
  options: Scalars["String"]["output"];
  session_token: Scalars["String"]["output"];
};

export type PasskeyFinishRequest = {
  credential: Scalars["String"]["input"];
  session_token: Scalars["String"]["input"];
};

export type PayStackBankData = {
  __typename?: "PayStackBankData";
  active?: Maybe<Scalars["Boolean"]["output"]>;
  code?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["Time"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  gateway?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  is_deleted?: Maybe<Scalars["Boolean"]["output"]>;
  longcode?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  pay_with_bank?: Maybe<Scalars["Boolean"]["output"]>;
  slug?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  updatedAt?: Maybe<Scalars["Time"]["output"]>;
};

export type PayStackBanks = {
  __typename?: "PayStackBanks";
  data?: Maybe<Array<Maybe<PayStackBankData>>>;
  message?: Maybe<Scalars["String"]["output"]>;
  meta?: Maybe<Meta>;
  status?: Maybe<Scalars["Boolean"]["output"]>;
};

export type PaymentMetaDataCustomField = {
  __typename?: "PaymentMetaDataCustomField";
  display_name: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
  variable_name: Scalars["String"]["output"];
};

export type PayoutProfile = {
  __typename?: "PayoutProfile";
  created_at: Scalars["Time"]["output"];
  flutterwave_profiles?: Maybe<Array<FlutterwaveProfile>>;
  id: Scalars["UUID"]["output"];
  paystack_profiles?: Maybe<Array<PaystackProfile>>;
  stripe_profiles?: Maybe<StripeProfile>;
  updated_at?: Maybe<Scalars["Time"]["output"]>;
  user_id: Scalars["UUID"]["output"];
};

export enum PayoutProfileStatusEnum {
  Completed = "completed",
  Pending = "pending",
}

export type PaystackProfile = {
  __typename?: "PaystackProfile";
  account_name: Scalars["String"]["output"];
  account_number: Scalars["String"]["output"];
  bank_code: Scalars["String"]["output"];
  bank_name: Scalars["String"]["output"];
  country_iso_alpha2: Scalars["String"]["output"];
  currency_iso: Scalars["String"]["output"];
  default: Scalars["Boolean"]["output"];
  disabled: Scalars["Boolean"]["output"];
  status: PayoutProfileStatusEnum;
  subaccount_code: Scalars["String"]["output"];
  subaccount_id: Scalars["String"]["output"];
};

export enum PeopleKind {
  Contact = "contact",
  Guest = "guest",
  Invitee = "invitee",
}

export type PeopleListFilter = {
  /**
   * Verified linked account has an active App device registration.
   *    False includes guests without a linked account. Omit/null means no filter.
   */
  app_registered?: InputMaybe<Scalars["Boolean"]["input"]>;
  category_id?: InputMaybe<Scalars["Int"]["input"]>;
  checked_in?: InputMaybe<Scalars["Boolean"]["input"]>;
  event_part_ids?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  general_invite_id?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  has_seat_reservation?: InputMaybe<Scalars["Boolean"]["input"]>;
  ids?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  invitation_slot_ids?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  kind?: InputMaybe<PeopleKind>;
  omit_invited_via_general_invite?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  page_size?: InputMaybe<Scalars["Int"]["input"]>;
  /**
   * Has a registered device eligible for announcement push: token, reported OS
   *    permission, account category preference and wedding mute. Delivery is not guaranteed.
   */
  push_available?: InputMaybe<Scalars["Boolean"]["input"]>;
  rsvp_status?: InputMaybe<Array<InvitationListRsvpStatus>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  sent_access_control?: InputMaybe<Scalars["Boolean"]["input"]>;
  sort_by?: InputMaybe<Scalars["String"]["input"]>;
  sort_order?: InputMaybe<Scalars["String"]["input"]>;
};

export type PlusOneDecisionInput = {
  accept: Scalars["Boolean"]["input"];
  request_id: Scalars["UUID"]["input"];
};

export type PlusOneGuestInfoInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  first_name: Scalars["String"]["input"];
  last_name?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
};

export type PlusOneGuestInput = {
  admits: Scalars["Int"]["input"];
  guests: Array<PlusOneGuestInfoInput>;
  request_type: PlusOneRequestType;
};

export type PlusOneRequest = {
  __typename?: "PlusOneRequest";
  created_at: Scalars["Time"]["output"];
  guest_email?: Maybe<Scalars["String"]["output"]>;
  guest_first_name?: Maybe<Scalars["String"]["output"]>;
  guest_last_name?: Maybe<Scalars["String"]["output"]>;
  guest_phone?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  invitation_id: Scalars["UUID"]["output"];
  request_type: PlusOneRequestType;
  status: Scalars["String"]["output"];
};

export enum PlusOneRequestType {
  Admit = "ADMIT",
  Guest = "GUEST",
}

export type PlusOneRequestWithInvitation = {
  __typename?: "PlusOneRequestWithInvitation";
  created_at: Scalars["Time"]["output"];
  guest_email?: Maybe<Scalars["String"]["output"]>;
  guest_first_name?: Maybe<Scalars["String"]["output"]>;
  guest_last_name?: Maybe<Scalars["String"]["output"]>;
  guest_phone?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  invitation?: Maybe<InvitationList>;
  request_type: PlusOneRequestType;
  status: Scalars["String"]["output"];
};

export type Pov = {
  __typename?: "Pov";
  media: Array<AlbumMedia>;
  total_likes: Scalars["Int"]["output"];
  total_media_count: Scalars["Int"]["output"];
  total_pictures: Scalars["Int"]["output"];
  total_videos: Scalars["Int"]["output"];
  uploader: Creator;
};

export type ProfilePresignUrlResponse = {
  __typename?: "ProfilePresignURLResponse";
  expiry_time: Scalars["Time"]["output"];
  expiry_time_in_seconds: Scalars["Int"]["output"];
  file_uri: Scalars["String"]["output"];
  upload_url: Scalars["String"]["output"];
  user_id: Scalars["UUID"]["output"];
};

export type PushDevice = {
  __typename?: "PushDevice";
  active: Scalars["Boolean"]["output"];
  app_id: Scalars["String"]["output"];
  app_version?: Maybe<Scalars["String"]["output"]>;
  environment: PushEnvironment;
  id: Scalars["UUID"]["output"];
  installation_id: Scalars["String"]["output"];
  last_seen_at: Scalars["Time"]["output"];
  permission_status: PushPermissionStatus;
  platform: PushPlatform;
};

export enum PushEnvironment {
  Development = "development",
  Preview = "preview",
  Production = "production",
}

export enum PushPermissionStatus {
  Denied = "denied",
  Granted = "granted",
  Provisional = "provisional",
  Undetermined = "undetermined",
}

export enum PushPlatform {
  Android = "android",
  Ios = "ios",
}

export type Query = {
  __typename?: "Query";
  _service: _Service;
  /** returns the list of reasons a user may abandon a payment */
  abandonedPaymentReasons: Array<AbandonedPaymentOption>;
  birthday: Event;
  birthdayCardTemplates: Array<BirthdayCardTemplate>;
  birthdayGifts: Array<Gift>;
  birthdayWishes: Array<Message>;
  bookingAccommodationsAvailability: BookingAccommodationsAvailabilityResult;
  bookingAccommodationsDetails: BookingAccommodationsDetailsResult;
  bookingAccommodationsSearch: BookingAccommodationsSearchResult;
  bookingCarsDetails: BookingCarsDetailsResult;
  bookingCarsSearch: BookingCarsSearchResult;
  bookingOrderDetails: BookingOrderDetailsResult;
  /**
   * App-channel progress for the broadcast ID. Resolve the current announcement server-side.
   *   Inbox entries, provider hand-off, confirmed device delivery and reads are separate counts.
   */
  broadcastAnnouncementStatus: WeddingAnnouncement;
  broadcastMessageRecipients: Array<EventBroadcastRecipient>;
  broadcastMessages: Array<EventBroadcast>;
  browseAsoebiFromOyple: OypleAsoebiAttires;
  browseAsoebiFromOypleFilters: OypleFilters;
  checkDomainAvailability: Array<DomainAvailabilityResponse>;
  checkDomainAvailabilityMany: Array<DomainAvailabilityResponse>;
  /** Checks slug availability. Pass event_id (the event's UUID) when editing an existing event so it can reclaim a slug it already owns. */
  checkEventSlug: Scalars["Boolean"]["output"];
  /** returns a list of available currencies with their name, symbol and slug(currency) */
  currency: Array<Maybe<AvailableCurrency>>;
  describeAseobiFeePercentage: Scalars["Float"]["output"];
  describeLuxe: LuxeDescription;
  domain?: Maybe<CustomDomain>;
  domainHistory: Array<DomainHistory>;
  event?: Maybe<Event>;
  eventBySlug?: Maybe<Event>;
  eventByUUID?: Maybe<Event>;
  eventCustomDomainStatuses: Array<CustomDomainStatus>;
  eventDomain?: Maybe<DomainListResponse>;
  eventParts: Array<EventPart>;
  eventVendor: Array<Maybe<EventVendor>>;
  eventWishlistNote?: Maybe<Scalars["String"]["output"]>;
  event_preferences: EventPreference;
  events: Array<Maybe<Event>>;
  featureFlag: FeatureFlag;
  featureFlags: Array<FeatureFlag>;
  fetchInvitedEventsByPhonenumber: Array<Maybe<Event>>;
  fetchStream: StreamingChannel;
  filterPeople: InvitationListResponse;
  findAvailableTemplates: Array<EventTemplates>;
  getAlbums: PaginatedAlbum;
  getAllInvitations: InvitationListResponse;
  getApprovedMessages?: Maybe<Array<Maybe<Message>>>;
  getAseobi?: Maybe<Array<Aseobi>>;
  getAseobiAttires?: Maybe<Array<AseobiAttire>>;
  getAseobiOrders?: Maybe<Array<AseobiOrder>>;
  getAseobiOrdersV2: Array<AseobiOrderV2>;
  getAseobiPackage: AseobiPackage;
  getAseobiPackages: Array<AseobiPackage>;
  getAseobiPackingList: Array<AseobiPackingTotal>;
  getAsoebiCheckoutStatus: AsoebiCheckoutSummary;
  getBackStory?: Maybe<Array<Maybe<BackStory>>>;
  getBanksWithFlutterwave: Array<Maybe<Bank>>;
  getBanksWithPaystack: Array<Maybe<Bank>>;
  getBeneficiaries?: Maybe<Array<Beneficiary>>;
  getCustomMyPlanTask: Array<Maybe<EventTask>>;
  getEventCache: EventCacheData;
  getEventDetailsWithToken?: Maybe<GeneralInvitationResp>;
  getEventPlan: EventPlan;
  getEventRecommendationLists: Array<RecList>;
  /** STREAMERS */
  getEventStreamers?: Maybe<Array<Maybe<Streamer>>>;
  getEventTaskAssets: Array<Maybe<EventTaskAssets>>;
  getEventTaskComments: Array<Maybe<EventTaskComment>>;
  getEventType: Array<EventType>;
  getEventWebsiteViews: Scalars["Int"]["output"];
  getFAQ?: Maybe<Faq>;
  getFAQsByEvent: PaginatedFaQs;
  getForeignAccountDetails: Array<Maybe<AccountDetails>>;
  getGeneralInviteToken: Scalars["String"]["output"];
  getGeneralInvites: Array<GeneralInvite>;
  getGiftHistory?: Maybe<GiftsWithPagination>;
  getGuestWebsiteChat: GuestWebsiteChatResponse;
  getGuestWebsiteStarterPrompt: Scalars["String"]["output"];
  getGuestsBySlotCode: Array<InvitationList>;
  getHeroImage: Scalars["String"]["output"];
  getInawoAskConversations: Array<InawoAskChat>;
  getInawoPassProgress: InawoPassProgress;
  getInvitationByPhoneNumber?: Maybe<InvitationList>;
  getInvitationToken: InvitationTokenLookup;
  getInvitedGuest: InvitationList;
  getLiveComments: PaginatedLiveComments;
  getLiveSchedule: PaginatedLiveSchedule;
  getMedia?: Maybe<Array<Maybe<AlbumMedia>>>;
  /** return all the tags a user can use */
  getMediaTags: Array<AlbumMediaTag>;
  getMessageByUser?: Maybe<Array<Maybe<Message>>>;
  getMessagesByEvent?: Maybe<Array<Maybe<Message>>>;
  getMessagesByEventV1?: Maybe<MessageResponse>;
  getNotesByEvent: Array<Note>;
  getPaidWishListItems?: Maybe<Array<Maybe<WishListItem>>>;
  getPov: Array<Pov>;
  getRecommendationListDetails: RecList;
  getRecommendationsByEvent: Array<Recommendation>;
  getReservedTables?: Maybe<Array<EventTable>>;
  getSeatingCharts?: Maybe<Array<SeatingChart>>;
  getSlotDetails: InvitationSlot;
  getSlots: Array<InvitationSlot>;
  getSpraysLeft: Array<Spray>;
  getTableNameSuggestions?: Maybe<Array<Scalars["String"]["output"]>>;
  getTeamMember: Array<TeamMember>;
  getTeamMemberByInviteToken: EventTeamMemberRequest;
  getWalletByCurrency?: Maybe<Wallet>;
  getWallets: Array<Maybe<Wallet>>;
  getWeddingParty?: Maybe<Array<Maybe<WeddingParty>>>;
  getWishListItemContributions: WishListItemContributions;
  getWishListItems?: Maybe<Array<Maybe<WishListItem>>>;
  getWishlistHistory: Array<Maybe<WishListHistory>>;
  guestCategory: Array<Category>;
  guestCategoryById: Category;
  guestUploads: Array<GuestUpload>;
  health: Scalars["Boolean"]["output"];
  helloLiveVisitors: Scalars["Boolean"]["output"];
  invitationCard?: Maybe<InvitationCard>;
  invitationCardTemplates: Array<InvitationCardTemplate>;
  isInvitedToEvent: Scalars["Boolean"]["output"];
  is_streamer?: Maybe<Scalars["Boolean"]["output"]>;
  myBirthdays: Array<Event>;
  myDomains: DomainListResponse;
  myNotificationPreferences: NotificationPreferences;
  myNotifications: InboxNotificationConnection;
  myPlusOneRequests: Array<PlusOneRequest>;
  myUnreadNotificationCount: Scalars["Int"]["output"];
  myWeddingPushMute: WeddingPushMute;
  noGuestPerCategory: Array<Maybe<GuestPerCategory>>;
  ownerTypes: Array<Scalars["String"]["output"]>;
  owners: Array<TeamMember>;
  paymentPartnerSupportedCountries: Array<PaymentPartnerCountry>;
  payoutProfile?: Maybe<PayoutProfile>;
  plusOneRequest?: Maybe<PlusOneRequest>;
  plusOneRequesterInvitation?: Maybe<InvitationList>;
  plusOneRequests: Array<PlusOneRequestWithInvitation>;
  publicBirthday: Event;
  refresh: AuthResponse;
  suggestDomains: Array<DomainSuggestion>;
  user?: Maybe<User>;
  validateGeneralInviteLink?: Maybe<GeneralInvite>;
  validateLuxeCard: Scalars["Boolean"]["output"];
  weddingAnnouncement: WeddingAnnouncement;
  /** @deprecated Retired: use broadcastAnnouncementStatus from Broadcasts. */
  weddingAnnouncementStatus: WeddingAnnouncement;
  /** @deprecated Retired: reminder configuration and diagnostics are internal. This operation returns REMINDERS_SERVER_MANAGED. */
  weddingGuestNotificationSettings: WeddingGuestNotificationSettings;
  weddingGuestPass: WeddingGuestPass;
  weddingGuestPasses: Array<WeddingGuestPass>;
  weddingInvitationParts: Array<WeddingInvitationPart>;
  weddingNotificationDestinations: Array<WeddingNotificationDestination>;
};

export type QueryBirthdayArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryBirthdayCardTemplatesArgs = {
  birthday_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type QueryBirthdayGiftsArgs = {
  birthday_id: Scalars["UUID"]["input"];
};

export type QueryBirthdayWishesArgs = {
  birthday_id: Scalars["UUID"]["input"];
};

export type QueryBookingAccommodationsAvailabilityArgs = {
  input: BookingAccommodationsAvailabilityInput;
};

export type QueryBookingAccommodationsDetailsArgs = {
  input: BookingAccommodationsDetailsInput;
};

export type QueryBookingAccommodationsSearchArgs = {
  input: BookingAccommodationsSearchInput;
};

export type QueryBookingCarsDetailsArgs = {
  input: BookingCarsDetailsInput;
};

export type QueryBookingCarsSearchArgs = {
  input: BookingCarsSearchInput;
};

export type QueryBookingOrderDetailsArgs = {
  input: BookingOrderDetailsInput;
};

export type QueryBroadcastAnnouncementStatusArgs = {
  broadcast_id: Scalars["UUID"]["input"];
  event_id: Scalars["UUID"]["input"];
};

export type QueryBroadcastMessageRecipientsArgs = {
  broadcast_id: Scalars["UUID"]["input"];
  event_id: Scalars["UUID"]["input"];
};

export type QueryBroadcastMessagesArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type QueryBrowseAsoebiFromOypleArgs = {
  event_id: Scalars["UUID"]["input"];
  filter?: InputMaybe<OypleAsoebiAttireFilter>;
};

export type QueryBrowseAsoebiFromOypleFiltersArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type QueryCheckDomainAvailabilityArgs = {
  domain_name: Scalars["String"]["input"];
};

export type QueryCheckDomainAvailabilityManyArgs = {
  domain_names: Array<Scalars["String"]["input"]>;
};

export type QueryCheckEventSlugArgs = {
  event_id?: InputMaybe<Scalars["UUID"]["input"]>;
  slug: Scalars["String"]["input"];
};

export type QueryDescribeAseobiFeePercentageArgs = {
  eventID: Scalars["UUID"]["input"];
};

export type QueryDescribeLuxeArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type QueryDomainArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryDomainHistoryArgs = {
  domain_id: Scalars["UUID"]["input"];
};

export type QueryEventArgs = {
  event_id: Scalars["Int"]["input"];
};

export type QueryEventBySlugArgs = {
  slug: Scalars["String"]["input"];
};

export type QueryEventByUuidArgs = {
  event_uuid: Scalars["String"]["input"];
};

export type QueryEventCustomDomainStatusesArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type QueryEventDomainArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type QueryEventPartsArgs = {
  event_id: Scalars["Int"]["input"];
};

export type QueryEventVendorArgs = {
  event_id: Scalars["Int"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryEventWishlistNoteArgs = {
  event_id: Scalars["Int"]["input"];
};

export type QueryEvent_PreferencesArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type QueryEventsArgs = {
  isInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryFeatureFlagArgs = {
  name: Scalars["String"]["input"];
};

export type QueryFetchInvitedEventsByPhonenumberArgs = {
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  phoneNumber: Scalars["String"]["input"];
};

export type QueryFetchStreamArgs = {
  key: Scalars["String"]["input"];
};

export type QueryFilterPeopleArgs = {
  event_id: Scalars["UUID"]["input"];
  filter: PeopleListFilter;
};

export type QueryGetAlbumsArgs = {
  event_id: Scalars["String"]["input"];
};

export type QueryGetAllInvitationsArgs = {
  page?: InputMaybe<Scalars["Int"]["input"]>;
  page_size?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetApprovedMessagesArgs = {
  event_id: Scalars["Int"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetAseobiArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type QueryGetAseobiAttiresArgs = {
  aseobi_id: Scalars["UUID"]["input"];
  event_id: Scalars["UUID"]["input"];
};

export type QueryGetAseobiOrdersArgs = {
  aseobi_attire_id?: InputMaybe<Scalars["UUID"]["input"]>;
  aseobi_id?: InputMaybe<Scalars["UUID"]["input"]>;
  event_id: Scalars["UUID"]["input"];
};

export type QueryGetAseobiOrdersV2Args = {
  aseobi_id?: InputMaybe<Scalars["UUID"]["input"]>;
  event_id: Scalars["UUID"]["input"];
};

export type QueryGetAseobiPackageArgs = {
  event_id: Scalars["UUID"]["input"];
  package_id: Scalars["UUID"]["input"];
};

export type QueryGetAseobiPackagesArgs = {
  aseobi_id: Scalars["UUID"]["input"];
  event_id: Scalars["UUID"]["input"];
};

export type QueryGetAseobiPackingListArgs = {
  aseobi_id: Scalars["UUID"]["input"];
  event_id: Scalars["UUID"]["input"];
  package_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type QueryGetAsoebiCheckoutStatusArgs = {
  event_id: Scalars["UUID"]["input"];
  payment_reference: Scalars["String"]["input"];
};

export type QueryGetBackStoryArgs = {
  event_id: Scalars["Int"]["input"];
};

export type QueryGetBanksWithFlutterwaveArgs = {
  country_iso_alpha2: Scalars["String"]["input"];
};

export type QueryGetBanksWithPaystackArgs = {
  country_iso_alpha2: Scalars["String"]["input"];
};

export type QueryGetBeneficiariesArgs = {
  wallet_id: Scalars["String"]["input"];
};

export type QueryGetCustomMyPlanTaskArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type QueryGetEventCacheArgs = {
  event_id: Scalars["UUID"]["input"];
  key: Scalars["String"]["input"];
};

export type QueryGetEventDetailsWithTokenArgs = {
  event_token: Scalars["String"]["input"];
};

export type QueryGetEventPlanArgs = {
  event_id: Scalars["Int"]["input"];
};

export type QueryGetEventRecommendationListsArgs = {
  eventId: Scalars["UUID"]["input"];
};

export type QueryGetEventStreamersArgs = {
  eventId: Scalars["Int"]["input"];
};

export type QueryGetEventTaskAssetsArgs = {
  event_id: Scalars["UUID"]["input"];
  task_id: Scalars["UUID"]["input"];
};

export type QueryGetEventTaskCommentsArgs = {
  event_id: Scalars["UUID"]["input"];
  task_id: Scalars["UUID"]["input"];
};

export type QueryGetEventWebsiteViewsArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type QueryGetFaqArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryGetFaQsByEventArgs = {
  event_id: Scalars["UUID"]["input"];
  filter: FaqFilter;
};

export type QueryGetForeignAccountDetailsArgs = {
  event_id: Scalars["Int"]["input"];
};

export type QueryGetGeneralInviteTokenArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type QueryGetGeneralInvitesArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type QueryGetGiftHistoryArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  event_id: Scalars["UUID"]["input"];
  page_size?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetGuestWebsiteChatArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type QueryGetGuestWebsiteStarterPromptArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type QueryGetGuestsBySlotCodeArgs = {
  event_id: Scalars["UUID"]["input"];
  slot_code: Scalars["String"]["input"];
};

export type QueryGetHeroImageArgs = {
  event_id: Scalars["Int"]["input"];
};

export type QueryGetInawoAskConversationsArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type QueryGetInawoPassProgressArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type QueryGetInvitationByPhoneNumberArgs = {
  event_id: Scalars["UUID"]["input"];
  phoneNumber: Scalars["String"]["input"];
};

export type QueryGetInvitationTokenArgs = {
  event_id: Scalars["UUID"]["input"];
  phone_number: Scalars["String"]["input"];
};

export type QueryGetInvitedGuestArgs = {
  token: Scalars["String"]["input"];
};

export type QueryGetLiveCommentsArgs = {
  eventUuid: Scalars["String"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetLiveScheduleArgs = {
  eventUuid: Scalars["String"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetMediaArgs = {
  event_id: Scalars["String"]["input"];
  filter: MediaFilter;
};

export type QueryGetMessageByUserArgs = {
  event_id: Scalars["Int"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetMessagesByEventArgs = {
  event_id: Scalars["Int"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetMessagesByEventV1Args = {
  event_id: Scalars["Int"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetNotesByEventArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type QueryGetPaidWishListItemsArgs = {
  event_id: Scalars["UUID"]["input"];
  listId?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetPovArgs = {
  event_id: Scalars["String"]["input"];
};

export type QueryGetRecommendationListDetailsArgs = {
  listId: Scalars["UUID"]["input"];
};

export type QueryGetRecommendationsByEventArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type QueryGetReservedTablesArgs = {
  event_id: Scalars["UUID"]["input"];
  event_part_id: Scalars["UUID"]["input"];
};

export type QueryGetSeatingChartsArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type QueryGetSlotDetailsArgs = {
  event_id: Scalars["UUID"]["input"];
  slot_code: Scalars["String"]["input"];
};

export type QueryGetSlotsArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type QueryGetSpraysLeftArgs = {
  sprayCode: Scalars["String"]["input"];
};

export type QueryGetTableNameSuggestionsArgs = {
  event_id: Scalars["UUID"]["input"];
  event_part_id: Scalars["UUID"]["input"];
};

export type QueryGetTeamMemberArgs = {
  event_id: Scalars["Int"]["input"];
};

export type QueryGetTeamMemberByInviteTokenArgs = {
  inviteToken: Scalars["String"]["input"];
};

export type QueryGetWalletByCurrencyArgs = {
  currency: Currency;
  event_id: Scalars["Int"]["input"];
};

export type QueryGetWalletsArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type QueryGetWeddingPartyArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type QueryGetWishListItemContributionsArgs = {
  event_id: Scalars["UUID"]["input"];
  wish_list_item_id: Scalars["UUID"]["input"];
};

export type QueryGetWishListItemsArgs = {
  event_id: Scalars["UUID"]["input"];
  listId?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetWishlistHistoryArgs = {
  event_id: Scalars["UUID"]["input"];
  page: Scalars["Int"]["input"];
  page_size?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGuestCategoryArgs = {
  event_id: Scalars["Int"]["input"];
};

export type QueryGuestCategoryByIdArgs = {
  categoryId: Scalars["Int"]["input"];
  event_id: Scalars["Int"]["input"];
};

export type QueryGuestUploadsArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type QueryInvitationCardArgs = {
  event_id: Scalars["Int"]["input"];
};

export type QueryIsInvitedToEventArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type QueryIs_StreamerArgs = {
  args: IsStreamerInput;
};

export type QueryMyNotificationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  event_id?: InputMaybe<Scalars["UUID"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryMyPlusOneRequestsArgs = {
  event_id: Scalars["UUID"]["input"];
  invitation_id: Scalars["UUID"]["input"];
};

export type QueryMyUnreadNotificationCountArgs = {
  event_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type QueryMyWeddingPushMuteArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type QueryNoGuestPerCategoryArgs = {
  event_id: Scalars["Int"]["input"];
};

export type QueryOwnerTypesArgs = {
  event_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type QueryOwnersArgs = {
  event_id: Scalars["Int"]["input"];
};

export type QueryPaymentPartnerSupportedCountriesArgs = {
  paymentPartner: PaymentProcessor;
};

export type QueryPlusOneRequestArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryPlusOneRequesterInvitationArgs = {
  plus_one_request_id: Scalars["UUID"]["input"];
};

export type QueryPlusOneRequestsArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type QueryPublicBirthdayArgs = {
  slug: Scalars["String"]["input"];
};

export type QueryRefreshArgs = {
  refresh_token: Scalars["String"]["input"];
};

export type QuerySuggestDomainsArgs = {
  domain_name: Scalars["String"]["input"];
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  tlds?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type QueryValidateGeneralInviteLinkArgs = {
  code: Scalars["String"]["input"];
};

export type QueryValidateLuxeCardArgs = {
  code: Scalars["String"]["input"];
};

export type QueryWeddingAnnouncementArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryWeddingAnnouncementStatusArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryWeddingGuestNotificationSettingsArgs = {
  event_id: Scalars["UUID"]["input"];
};

export type QueryWeddingGuestPassArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryWeddingGuestPassesArgs = {
  invitation_id: Scalars["UUID"]["input"];
};

export type QueryWeddingInvitationPartsArgs = {
  invitation_id: Scalars["UUID"]["input"];
};

export type QueryWeddingNotificationDestinationsArgs = {
  notification_id: Scalars["UUID"]["input"];
};

export type Rsvp = {
  __typename?: "RSVP";
  created_at: Scalars["Time"]["output"];
  event_id: Scalars["Int"]["output"];
  field: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
  invitation_list_id: Scalars["Int"]["output"];
  updated_at?: Maybe<Scalars["Time"]["output"]>;
  value?: Maybe<Scalars["String"]["output"]>;
};

export type RsvpQuestion = {
  __typename?: "RSVPQuestion";
  created_at: Scalars["Time"]["output"];
  event_id: Scalars["Int"]["output"];
  id: Scalars["Int"]["output"];
  invitation_id: Scalars["Int"]["output"];
  question: Scalars["String"]["output"];
  question_type?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["Boolean"]["output"];
  updated_at?: Maybe<Scalars["Time"]["output"]>;
};

export enum RecCategory {
  Accommodation = "ACCOMMODATION",
  Food = "FOOD",
  Other = "OTHER",
  Transportation = "TRANSPORTATION",
}

export type RecList = {
  __typename?: "RecList";
  category: RecCategory;
  createdAt: Scalars["Time"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  eventId: Scalars["UUID"]["output"];
  id: Scalars["UUID"]["output"];
  items: Array<RecommendationItem>;
  name: Scalars["String"]["output"];
  updatedAt: Scalars["Time"]["output"];
};

export enum RecMediaType {
  Image = "IMAGE",
  Video = "VIDEO",
}

export type Recommendation = {
  __typename?: "Recommendation";
  created_at: Scalars["Time"]["output"];
  description: Scalars["String"]["output"];
  event_id: Scalars["UUID"]["output"];
  id: Scalars["UUID"]["output"];
  image_urls?: Maybe<Array<Scalars["String"]["output"]>>;
  is_active: Scalars["Boolean"]["output"];
  kind: RecommendationKind;
  order_index?: Maybe<Scalars["Int"]["output"]>;
  title: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Time"]["output"]>;
};

export type RecommendationItem = {
  __typename?: "RecommendationItem";
  contactInfo?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["Time"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  link?: Maybe<Scalars["String"]["output"]>;
  listId: Scalars["UUID"]["output"];
  mediaType?: Maybe<RecMediaType>;
  mediaUrl?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  updatedAt: Scalars["Time"]["output"];
};

export enum RecommendationKind {
  Accomodation = "ACCOMODATION",
  CarRental = "CAR_RENTAL",
}

export type RecommendationList = {
  __typename?: "RecommendationList";
  created_at: Scalars["Time"]["output"];
  description: Scalars["String"]["output"];
  event_id: Scalars["UUID"]["output"];
  id: Scalars["UUID"]["output"];
  image_urls?: Maybe<Array<Scalars["String"]["output"]>>;
  is_active: Scalars["Boolean"]["output"];
  metadata?: Maybe<Scalars["Map"]["output"]>;
  order_index?: Maybe<Scalars["Int"]["output"]>;
  provider?: Maybe<RecommendationListProvider>;
  provider_inventory_reference?: Maybe<Scalars["String"]["output"]>;
  recommendation_id: Scalars["UUID"]["output"];
  title: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Time"]["output"]>;
};

export enum RecommendationListProvider {
  Airbnb = "AIRBNB",
  Booking = "BOOKING",
  Expedia = "EXPEDIA",
  Manual = "MANUAL",
}

export type RegisterDomainInput = {
  auto_renew: Scalars["Boolean"]["input"];
  contact: DomainContactInput;
  domain_name: Scalars["String"]["input"];
  event_id: Scalars["UUID"]["input"];
  years: Scalars["Int"]["input"];
};

export type RegisterPushDeviceInput = {
  app_id: Scalars["String"]["input"];
  app_version?: InputMaybe<Scalars["String"]["input"]>;
  environment: PushEnvironment;
  expo_push_token?: InputMaybe<Scalars["String"]["input"]>;
  installation_id: Scalars["String"]["input"];
  permission_status: PushPermissionStatus;
  platform: PushPlatform;
  project_id: Scalars["String"]["input"];
};

export type ResourceCount = {
  __typename?: "ResourceCount";
  count: Scalars["Int"]["output"];
  resource: AuditResource;
};

export type SeatingChart = {
  __typename?: "SeatingChart";
  part: EventPart;
  tables: Array<EventTable>;
};

export type SeatingChartImagePresignedUrlResponse = {
  __typename?: "SeatingChartImagePresignedURLResponse";
  event_id: Scalars["UUID"]["output"];
  event_part_id: Scalars["UUID"]["output"];
  expiry_time: Scalars["Time"]["output"];
  expiry_time_in_seconds: Scalars["Int"]["output"];
  file_uri: Scalars["String"]["output"];
  upload_url: Scalars["String"]["output"];
};

export type SelectTemplateReq = {
  event_id: Scalars["UUID"]["input"];
  template_id: Scalars["String"]["input"];
};

export type SelfiePresignUrlResponse = {
  __typename?: "SelfiePresignURLResponse";
  event_id: Scalars["UUID"]["output"];
  expiry_time: Scalars["Time"]["output"];
  expiry_time_in_seconds: Scalars["Int"]["output"];
  file_uri: Scalars["String"]["output"];
  invitation_id: Scalars["UUID"]["output"];
  upload_url: Scalars["String"]["output"];
};

export type SendInvitationResponse = {
  __typename?: "SendInvitationResponse";
  error: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
};

export type SendInvitationResponseStatus = {
  __typename?: "SendInvitationResponseStatus";
  error?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
};

export type SendInvitationsResponse = {
  __typename?: "SendInvitationsResponse";
  channel: Scalars["String"]["output"];
  status: Array<SendInvitationResponseStatus>;
};

export type SendInviteReq = {
  all: Scalars["Boolean"]["input"];
  channel: Channel;
  list_id: Array<Scalars["UUID"]["input"]>;
  pending: Scalars["Boolean"]["input"];
};

export type SignUpRequest = {
  country_iso_alpha2: Scalars["String"]["input"];
  email: Scalars["Email"]["input"];
  first_name: Scalars["String"]["input"];
  gender?: InputMaybe<Gender>;
  guest?: InputMaybe<Scalars["Boolean"]["input"]>;
  last_name: Scalars["String"]["input"];
  other_name?: InputMaybe<Scalars["String"]["input"]>;
  password: Scalars["Password"]["input"];
  phone_number: Scalars["String"]["input"];
  referral_code?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  utm_attributes?: InputMaybe<UtmAttributes>;
};

export type SplitPayments = {
  __typename?: "SplitPayments";
  couples_account: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  split_percentage: Scalars["Float"]["output"];
  sub_account_code: Scalars["String"]["output"];
  sub_account_id: Scalars["String"]["output"];
};

export type SprayMoneyMetaData = {
  __typename?: "SprayMoneyMetaData";
  amount: Scalars["Float"]["output"];
  contact_email?: Maybe<Scalars["String"]["output"]>;
  contact_phone_number?: Maybe<Scalars["String"]["output"]>;
  currency_iso: Scalars["String"]["output"];
  custom_fields: Array<PaymentMetaDataCustomField>;
  event_id: Scalars["UUID"]["output"];
  full_name?: Maybe<Scalars["String"]["output"]>;
  hash: Scalars["String"]["output"];
  inawo_product: Scalars["String"]["output"];
  live_schedule_id: Scalars["UUID"]["output"];
  payment_provider: Scalars["String"]["output"];
  payment_reference: Scalars["String"]["output"];
  split_payments?: Maybe<Array<SplitPayments>>;
  split_percentage: Scalars["Float"]["output"];
  spray_id: Scalars["UUID"]["output"];
  sprays: Array<Spray>;
  sub_account_code: Scalars["String"]["output"];
  sub_account_id: Scalars["String"]["output"];
  timestamp: Scalars["Time"]["output"];
  total_payment_intent_amount: Scalars["Float"]["output"];
  total_units: Scalars["Int"]["output"];
  user_id?: Maybe<Scalars["UUID"]["output"]>;
  username: Scalars["String"]["output"];
};

export type SprayMoneyMetadataRequest = {
  amount: Scalars["Float"]["input"];
  contact_email?: InputMaybe<Scalars["String"]["input"]>;
  contact_phone?: InputMaybe<Scalars["String"]["input"]>;
  currency: Currency;
  event_id: Scalars["UUID"]["input"];
  full_name?: InputMaybe<Scalars["String"]["input"]>;
  live_schedule_id: Scalars["UUID"]["input"];
  payment_provider: PaymentProcessor;
  sprays: Array<SprayInput>;
  total_units: Scalars["Int"]["input"];
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
  username: Scalars["String"]["input"];
};

export type StreamDetails = {
  __typename?: "StreamDetails";
  Id: Scalars["String"]["output"];
  deviceName: Scalars["String"]["output"];
  eventId: Scalars["Int"]["output"];
  stream_url: Scalars["String"]["output"];
};

export type Streamer = {
  __typename?: "Streamer";
  Id: Scalars["String"]["output"];
  created_at: Scalars["String"]["output"];
  deviceName: Scalars["String"]["output"];
  event: Event;
  event_uuid: Scalars["String"]["output"];
  ingest_endpoint: Scalars["String"]["output"];
  is_streaming: Scalars["Boolean"]["output"];
  playback_url: Scalars["String"]["output"];
  stream_key: Scalars["String"]["output"];
  viewingUrl: Scalars["String"]["output"];
};

export type StreamingChannel = {
  __typename?: "StreamingChannel";
  Id: Scalars["String"]["output"];
  event: Event;
  ingest_endpoint: Scalars["String"]["output"];
  stream_key: Scalars["String"]["output"];
};

export type StripeConnectOnboardingResponse = {
  __typename?: "StripeConnectOnboardingResponse";
  account_id: Scalars["String"]["output"];
  onboard_url: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
};

export type StripeConnectStatusResponse = {
  __typename?: "StripeConnectStatusResponse";
  account_id?: Maybe<Scalars["String"]["output"]>;
  charges_enabled: Scalars["Boolean"]["output"];
  error?: Maybe<Scalars["String"]["output"]>;
  is_connected: Scalars["Boolean"]["output"];
  payouts_enabled: Scalars["Boolean"]["output"];
  requirements_due?: Maybe<Array<Scalars["String"]["output"]>>;
  status: Scalars["String"]["output"];
};

export enum StripeConnectStatusResponseStatusEnum {
  Completed = "completed",
  Error = "error",
  NotStarted = "not_started",
  Pending = "pending",
  RequirementsNeeded = "requirements_needed",
}

export type StripeProfile = {
  __typename?: "StripeProfile";
  account_id: Scalars["String"]["output"];
  status: PayoutProfileStatusEnum;
};

export type Subscription = {
  __typename?: "Subscription";
  getRecentComments: LiveCommentEvent;
  getRecentSpray: LiveSprayEvent;
  userGreeted: Scalars["String"]["output"];
};

export type SubscriptionGetRecentCommentsArgs = {
  liveScheduleID: Scalars["String"]["input"];
};

export type SubscriptionGetRecentSprayArgs = {
  liveScheduleID: Scalars["String"]["input"];
};

export enum TableType {
  Hexagon = "hexagon",
  Oval = "oval",
  Rectangle = "rectangle",
  Round = "round",
  Square = "square",
}

export type TeamMember = {
  __typename?: "TeamMember";
  admin?: Maybe<Scalars["Boolean"]["output"]>;
  created_at?: Maybe<Scalars["Time"]["output"]>;
  event_id: Scalars["UUID"]["output"];
  id: Scalars["UUID"]["output"];
  role?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Time"]["output"]>;
  user?: Maybe<User>;
  user_uuid: Scalars["UUID"]["output"];
};

export type TeamMemberInvite = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  event_id: Scalars["Int"]["input"];
  first_name: Scalars["String"]["input"];
  last_name: Scalars["String"]["input"];
  other_name?: InputMaybe<Scalars["String"]["input"]>;
  phone_number: Scalars["String"]["input"];
  role: EventOwnerRole;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type TransactionMetadata = {
  __typename?: "TransactionMetadata";
  account_name?: Maybe<Scalars["String"]["output"]>;
  amount: Scalars["Float"]["output"];
  amount_sent?: Maybe<Scalars["Float"]["output"]>;
  bank_account_number?: Maybe<Scalars["String"]["output"]>;
  bank_name?: Maybe<Scalars["String"]["output"]>;
  charges?: Maybe<Scalars["Float"]["output"]>;
  creditor_alias?: Maybe<Scalars["String"]["output"]>;
  currency: Scalars["String"]["output"];
  date: Scalars["Time"]["output"];
  description: Scalars["String"]["output"];
  email?: Maybe<Scalars["String"]["output"]>;
  event_id: Scalars["Int"]["output"];
  item_id?: Maybe<Scalars["String"]["output"]>;
  item_name?: Maybe<Scalars["String"]["output"]>;
  payment_processor: Scalars["String"]["output"];
  payment_processor_reference: Scalars["String"]["output"];
  phone_number?: Maybe<Scalars["String"]["output"]>;
  transaction_type: Scalars["String"]["output"];
  user_id?: Maybe<Scalars["String"]["output"]>;
};

export enum TransactionTypeEnum {
  All = "all",
  Credit = "credit",
  Debit = "debit",
  Last = "last",
}

export type TransactionV1 = {
  __typename?: "TransactionV1";
  /** in kobo/cent depending on currency e.g N100 -> 10,000 & $12 -> 1,200 */
  amount: Scalars["Float"]["output"];
  /** time the transaction was done */
  created_at?: Maybe<Scalars["Time"]["output"]>;
  /** for now [ USD | NGN ] ...all caps (upper case) */
  currency: Currency;
  /** provides context of transaction */
  description: Scalars["String"]["output"];
  event_id: Scalars["Int"]["output"];
  /** the id of the event for which the transaction was made */
  event_uuid: Scalars["UUID"]["output"];
  /** anonymous or the person's name */
  full_name?: Maybe<Scalars["String"]["output"]>;
  /** used for indexing */
  id: Scalars["UUID"]["output"];
  /** only provided if the transaction was for payment of a wishlist item */
  item_id?: Maybe<Scalars["String"]["output"]>;
  /** gift, gift-fee, withdraw, withdraw-fee */
  kind: Scalars["String"]["output"];
  metadata: TransactionMetadata;
  /** narration for the transaction */
  narration: Scalars["String"]["output"];
  /** e.g paystack, monnify, stripe, flutterwave ... (all lower case) */
  payment_processor: Scalars["String"]["output"];
  /** reference -> very important (takes precedence over the id) */
  reference: Scalars["String"]["output"];
  /** [ successful | failed | pending ] ... (all lower case) */
  stage: Scalars["String"]["output"];
  /**
   * true|false (a summary of the stage of the transaction) ==>
   *
   * stage:successful-> true
   * &
   * stage:failed -> false
   */
  status: Scalars["String"]["output"];
  /** [ credit | debit ] ... (all lower case) */
  type: Scalars["String"]["output"];
  /** last update at */
  updated_at?: Maybe<Scalars["Time"]["output"]>;
  /** returns if the transaction was made by an authorized user */
  user?: Maybe<User>;
  /** if the transaction was made by an authenticated user */
  user_uuid?: Maybe<Scalars["UUID"]["output"]>;
  /** deprecated -> same as virtual bank account number */
  wallet_code?: Maybe<Scalars["String"]["output"]>;
};

export type TransactionWithPagination = {
  __typename?: "TransactionWithPagination";
  meta?: Maybe<Pagination>;
  transaction?: Maybe<Array<Maybe<TransactionV1>>>;
};

export type TransferResponse = {
  __typename?: "TransferResponse";
  otp_is_required: Scalars["Boolean"]["output"];
  status: Scalars["Boolean"]["output"];
};

export type UpdateAseobiPackageInput = {
  cover_image?: InputMaybe<Scalars["String"]["input"]>;
  currency_iso?: InputMaybe<Currency>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  images?: InputMaybe<Array<Scalars["String"]["input"]>>;
  items?: InputMaybe<Array<AseobiPackageItemInput>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  price?: InputMaybe<Scalars["Float"]["input"]>;
  stock_quantity?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UpdateBankDetailsRequest = {
  account_number: Scalars["String"]["input"];
  bank_code: Scalars["String"]["input"];
  bvn?: InputMaybe<Scalars["String"]["input"]>;
  currency: Currency;
};

export type UpdateBankDetailsRequestFlw = {
  account_name: Scalars["String"]["input"];
  account_number: Scalars["String"]["input"];
  bank_code: Scalars["String"]["input"];
  country_iso_alpha2: Scalars["String"]["input"];
  currency: Currency;
};

export type UpdateEventPartRequest = {
  address?: InputMaybe<Scalars["String"]["input"]>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  eventPartTimezone?: InputMaybe<Scalars["String"]["input"]>;
  event_id: Scalars["Int"]["input"];
  geo_position?: InputMaybe<GeoPositionInput>;
  id: Scalars["Int"]["input"];
  image?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  part?: InputMaybe<Scalars["String"]["input"]>;
  programs?: InputMaybe<Array<InputMaybe<EventPartProgramInput>>>;
  state?: InputMaybe<Scalars["String"]["input"]>;
  time?: InputMaybe<Scalars["String"]["input"]>;
  welcome_msg?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateEventPreferenceRequest = {
  access_control?: InputMaybe<Scalars["Boolean"]["input"]>;
  ads?: InputMaybe<Scalars["Boolean"]["input"]>;
  asoebi_selection?: InputMaybe<Scalars["Boolean"]["input"]>;
  dress_code?: InputMaybe<Scalars["Boolean"]["input"]>;
  event_id: Scalars["UUID"]["input"];
  faq?: InputMaybe<Scalars["Boolean"]["input"]>;
  food?: InputMaybe<Scalars["Boolean"]["input"]>;
  force_guest_app_download?: InputMaybe<Scalars["Boolean"]["input"]>;
  gift_in_invitation?: InputMaybe<Scalars["Boolean"]["input"]>;
  gifts?: InputMaybe<Scalars["Boolean"]["input"]>;
  guest_pov_default_public?: InputMaybe<Scalars["Boolean"]["input"]>;
  live_hall?: InputMaybe<Scalars["Boolean"]["input"]>;
  map?: InputMaybe<Scalars["Boolean"]["input"]>;
  oyple_integration?: InputMaybe<Scalars["Boolean"]["input"]>;
  plus_one_request?: InputMaybe<Scalars["Boolean"]["input"]>;
  private?: InputMaybe<Scalars["Boolean"]["input"]>;
  recommendations?: InputMaybe<Scalars["Boolean"]["input"]>;
  reservation?: InputMaybe<Scalars["Boolean"]["input"]>;
  smart_send?: InputMaybe<Scalars["Boolean"]["input"]>;
  store?: InputMaybe<Scalars["Boolean"]["input"]>;
  vendor_store?: InputMaybe<Scalars["Boolean"]["input"]>;
  website_after_invitation?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UpdateEventSettingRequest = {
  event_id: Scalars["Int"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UpdateEventVendorRequest = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  event_id: Scalars["Int"]["input"];
  facebook?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  image?: InputMaybe<Scalars["String"]["input"]>;
  instagram_handle?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  phone_number?: InputMaybe<Scalars["String"]["input"]>;
  role?: InputMaybe<Scalars["String"]["input"]>;
  twitter?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateFaqInput = {
  answer?: InputMaybe<Scalars["String"]["input"]>;
  event_id: Scalars["UUID"]["input"];
  event_part_id?: InputMaybe<Scalars["UUID"]["input"]>;
  id: Scalars["UUID"]["input"];
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  order_index?: InputMaybe<Scalars["Float"]["input"]>;
  question?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateInvitationSlotInput = {
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  clear_expiration?: InputMaybe<Scalars["Boolean"]["input"]>;
  expires_at?: InputMaybe<Scalars["Time"]["input"]>;
  max_invites?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UpdateInviteListReq = {
  admits?: InputMaybe<Scalars["Int"]["input"]>;
  category_id?: InputMaybe<Scalars["Int"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  first_name?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  last_name?: InputMaybe<Scalars["String"]["input"]>;
  other_name?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateMessageStatusReq = {
  message_id: Scalars["Int"]["input"];
  status: Scalars["Boolean"]["input"];
};

export type UpdateStreamer = {
  eventId: Scalars["Int"]["input"];
  inviteListId: Scalars["Int"]["input"];
  streamer_email?: InputMaybe<Scalars["String"]["input"]>;
  streamer_name: Scalars["String"]["input"];
  streamer_phone: Scalars["String"]["input"];
};

export type UpdateUserDetailsRequest = {
  Country?: InputMaybe<Scalars["String"]["input"]>;
  address?: InputMaybe<Scalars["String"]["input"]>;
  age?: InputMaybe<Scalars["Int"]["input"]>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  image?: InputMaybe<Scalars["String"]["input"]>;
  languages?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  state?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateUserPreferenceRequest = {
  field: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
};

export type UpdateUserProfileRequest = {
  country_iso_alpha2?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  first_name?: InputMaybe<Scalars["String"]["input"]>;
  image?: InputMaybe<Scalars["String"]["input"]>;
  last_name?: InputMaybe<Scalars["String"]["input"]>;
  other_name?: InputMaybe<Scalars["String"]["input"]>;
  phone_number?: InputMaybe<Scalars["String"]["input"]>;
};

/** Users on Inawo */
export type User = {
  __typename?: "User";
  country_iso_alpha2?: Maybe<Scalars["String"]["output"]>;
  created_at?: Maybe<Scalars["Time"]["output"]>;
  email?: Maybe<Scalars["Email"]["output"]>;
  first_name: Scalars["String"]["output"];
  gender?: Maybe<Gender>;
  guest?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["Int"]["output"];
  image?: Maybe<Scalars["String"]["output"]>;
  lastLoggedInAt?: Maybe<Scalars["Time"]["output"]>;
  last_name?: Maybe<Scalars["String"]["output"]>;
  other_name?: Maybe<Scalars["String"]["output"]>;
  payout_profile?: Maybe<PayoutProfile>;
  phone_number: Scalars["String"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Time"]["output"]>;
  uuid: Scalars["UUID"]["output"];
  verified: Scalars["Boolean"]["output"];
};

export type UserActivity = {
  __typename?: "UserActivity";
  action_count: Scalars["Int"]["output"];
  last_activity: Scalars["Time"]["output"];
  user_email: Scalars["String"]["output"];
  user_id: Scalars["UUID"]["output"];
  user_name: Scalars["String"]["output"];
};

/** Sort of secondary/old identifier on a user. Only PHONE and EMAIL are verifiable and login-eligible. */
export enum UserIdentifierKind {
  AppId = "APP_ID",
  DeviceId = "DEVICE_ID",
  Email = "EMAIL",
  FirebaseId = "FIREBASE_ID",
  Phone = "PHONE",
}

export type UserInfo = {
  __typename?: "UserInfo";
  email: Scalars["String"]["output"];
  full_name: Scalars["String"]["output"];
  phone_number: Scalars["String"]["output"];
  user_id?: Maybe<Scalars["UUID"]["output"]>;
};

export enum UserTypeEnum {
  Admin = "admin",
  Guest = "guest",
}

export type UtmAttributes = {
  campaign?: InputMaybe<Scalars["String"]["input"]>;
  content?: InputMaybe<Scalars["String"]["input"]>;
  creative_format?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  marketing_tactic?: InputMaybe<Scalars["String"]["input"]>;
  medium?: InputMaybe<Scalars["String"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  source_platform?: InputMaybe<Scalars["String"]["input"]>;
  term?: InputMaybe<Scalars["String"]["input"]>;
};

export type Wallet = {
  __typename?: "Wallet";
  balance: Scalars["Float"]["output"];
  created_at?: Maybe<Scalars["Time"]["output"]>;
  currency: Currency;
  event_id: Scalars["UUID"]["output"];
  frozen: Scalars["Boolean"]["output"];
  gift_volume: Scalars["Float"]["output"];
  id: Scalars["UUID"]["output"];
  metadata?: Maybe<Scalars["Map"]["output"]>;
  payment_partner_sub_account_id?: Maybe<Scalars["String"]["output"]>;
  payment_provider?: Maybe<PaymentProcessor>;
  pin_is_set: Scalars["Boolean"]["output"];
  status: WalletStatus;
  updated_at?: Maybe<Scalars["Time"]["output"]>;
};

export enum WalletStatus {
  Paused = "paused",
  Pending = "pending",
  Suspended = "suspended",
  Verified = "verified",
}

export type WalletSubAccount = {
  __typename?: "WalletSubAccount";
  currency: Currency;
  provider: Scalars["String"]["output"];
  subaccount_code: Scalars["String"]["output"];
  subaccount_id: Scalars["String"]["output"];
  wallet_id: Scalars["UUID"]["output"];
};

export type WalletUser = {
  email?: InputMaybe<Scalars["Email"]["input"]>;
  /** first name of the person */
  first_name: Scalars["String"]["input"];
  /** gender of the person */
  gender?: InputMaybe<Gender>;
  id: Scalars["Int"]["input"];
  image?: InputMaybe<Scalars["String"]["input"]>;
  /** last name of the person */
  last_name?: InputMaybe<Scalars["String"]["input"]>;
  other_name?: InputMaybe<Scalars["String"]["input"]>;
  /** phone number of the person */
  phone: Scalars["String"]["input"];
  title?: InputMaybe<Scalars["String"]["input"]>;
  uuid?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type WeddingAnnouncement = {
  __typename?: "WeddingAnnouncement";
  accepted: Scalars["Boolean"]["output"];
  body: Scalars["String"]["output"];
  confirmed_delivery_count: Scalars["Int"]["output"];
  created_at: Scalars["Time"]["output"];
  event_id: Scalars["UUID"]["output"];
  failed_count: Scalars["Int"]["output"];
  handed_off_count: Scalars["Int"]["output"];
  id: Scalars["UUID"]["output"];
  inbox_count: Scalars["Int"]["output"];
  invitation_count: Scalars["Int"]["output"];
  queued_count: Scalars["Int"]["output"];
  read_count: Scalars["Int"]["output"];
  recipient_count: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  suppressed_count: Scalars["Int"]["output"];
  title: Scalars["String"]["output"];
  unreachable_count: Scalars["Int"]["output"];
};

export type WeddingAnnouncementAudienceInput = {
  event_part_id?: InputMaybe<Scalars["UUID"]["input"]>;
  invitation_ids?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  kind: Scalars["String"]["input"];
};

export type WeddingAnnouncementInput = {
  audience: WeddingAnnouncementAudienceInput;
  body: Scalars["String"]["input"];
  title: Scalars["String"]["input"];
};

export type WeddingAnnouncementPreview = {
  __typename?: "WeddingAnnouncementPreview";
  eligible_invitation_count: Scalars["Int"]["output"];
  expires_at: Scalars["Time"]["output"];
  /** Per-invitation eligibility observed at preview time; never used as proof of delivery. */
  guests: Array<BroadcastAppGuest>;
  includes_declined: Scalars["Boolean"]["output"];
  /** Distinct linked accounts with at least one currently eligible push registration. */
  push_reachable_recipient_count: Scalars["Int"]["output"];
  recipient_count: Scalars["Int"]["output"];
  token: Scalars["UUID"]["output"];
  unreachable_invitation_count: Scalars["Int"]["output"];
};

export type WeddingGuestNotificationSettings = {
  __typename?: "WeddingGuestNotificationSettings";
  cancelled: Scalars["Boolean"]["output"];
  event_id: Scalars["UUID"]["output"];
  rsvp_deadline?: Maybe<Scalars["Time"]["output"]>;
  rsvp_reminder_enabled: Scalars["Boolean"]["output"];
  rsvp_reminder_lead_hours: Scalars["Int"]["output"];
  schedule: Array<WeddingNotificationScheduleInfo>;
  starts_at?: Maybe<Scalars["Time"]["output"]>;
  timezone?: Maybe<Scalars["String"]["output"]>;
  wedding_reminder_days: Array<Scalars["Int"]["output"]>;
  wedding_reminder_time: Scalars["String"]["output"];
  wedding_reminders_enabled: Scalars["Boolean"]["output"];
};

export type WeddingGuestNotificationSettingsInput = {
  cancelled?: InputMaybe<Scalars["Boolean"]["input"]>;
  clear_rsvp_deadline?: InputMaybe<Scalars["Boolean"]["input"]>;
  rsvp_deadline?: InputMaybe<Scalars["Time"]["input"]>;
  rsvp_reminder_enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  starts_at?: InputMaybe<Scalars["Time"]["input"]>;
  timezone?: InputMaybe<Scalars["String"]["input"]>;
  wedding_reminder_days?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  wedding_reminder_time?: InputMaybe<Scalars["String"]["input"]>;
  wedding_reminders_enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type WeddingGuestPass = {
  __typename?: "WeddingGuestPass";
  access_notes: Scalars["String"]["output"];
  admission_label: Scalars["String"]["output"];
  admits: Scalars["Int"]["output"];
  event_part_id?: Maybe<Scalars["UUID"]["output"]>;
  id: Scalars["UUID"]["output"];
  invitation_id: Scalars["UUID"]["output"];
  published_at: Scalars["Time"]["output"];
  version: Scalars["Int"]["output"];
};

export type WeddingInvitationPart = {
  __typename?: "WeddingInvitationPart";
  event_part_id: Scalars["UUID"]["output"];
  invitation_id: Scalars["UUID"]["output"];
  rsvp_status: Scalars["String"]["output"];
};

export type WeddingInvitationPartInput = {
  event_part_id: Scalars["UUID"]["input"];
  rsvp_status: Scalars["String"]["input"];
};

export type WeddingNotificationDestination = {
  __typename?: "WeddingNotificationDestination";
  announcement_id?: Maybe<Scalars["UUID"]["output"]>;
  event_part_id?: Maybe<Scalars["UUID"]["output"]>;
  invitation_id: Scalars["UUID"]["output"];
  pass_id?: Maybe<Scalars["UUID"]["output"]>;
};

export type WeddingNotificationScheduleInfo = {
  __typename?: "WeddingNotificationScheduleInfo";
  event_part_id?: Maybe<Scalars["UUID"]["output"]>;
  lead_days?: Maybe<Scalars["Int"]["output"]>;
  reason?: Maybe<Scalars["String"]["output"]>;
  scheduled_at?: Maybe<Scalars["Time"]["output"]>;
  status: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type WeddingParty = {
  __typename?: "WeddingParty";
  created_at?: Maybe<Scalars["Time"]["output"]>;
  event_id: Scalars["UUID"]["output"];
  first_name: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  image_url?: Maybe<Scalars["String"]["output"]>;
  last_name: Scalars["String"]["output"];
  nickname?: Maybe<Scalars["String"]["output"]>;
  order_index?: Maybe<Scalars["Float"]["output"]>;
  role: Scalars["String"]["output"];
  story?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Time"]["output"]>;
};

export type WeddingPartyPresignedUrlResponse = {
  __typename?: "WeddingPartyPresignedURLResponse";
  event_id: Scalars["UUID"]["output"];
  expiry_time: Scalars["Time"]["output"];
  expiry_time_in_seconds: Scalars["Int"]["output"];
  file_uri: Scalars["String"]["output"];
  upload_url: Scalars["String"]["output"];
};

export type WeddingPassInput = {
  access_notes: Scalars["String"]["input"];
  admission_label: Scalars["String"]["input"];
  admits: Scalars["Int"]["input"];
  event_part_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type WeddingPushMute = {
  __typename?: "WeddingPushMute";
  event_id: Scalars["UUID"]["output"];
  muted: Scalars["Boolean"]["output"];
};

export type WishListContribution = {
  __typename?: "WishListContribution";
  amount: Scalars["Float"]["output"];
  created_at: Scalars["Time"]["output"];
  currency: Currency;
  full_name: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
  payment_method?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
};

export type WishListHistory = {
  __typename?: "WishListHistory";
  amount: Scalars["Float"]["output"];
  appreciated: Scalars["Boolean"]["output"];
  currency: Currency;
  gift_id: Scalars["UUID"]["output"];
  user?: Maybe<UserInfo>;
  wallet_id: Scalars["UUID"]["output"];
  wish_list_item: WishListItem;
  wish_list_item_id: Scalars["UUID"]["output"];
};

export type WishListItem = {
  __typename?: "WishListItem";
  amount?: Maybe<Scalars["Float"]["output"]>;
  appreciation?: Maybe<Scalars["String"]["output"]>;
  created_at?: Maybe<Scalars["Time"]["output"]>;
  currency: Currency;
  event_id: Scalars["UUID"]["output"];
  id: Scalars["UUID"]["output"];
  image?: Maybe<Scalars["String"]["output"]>;
  link?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  paid?: Maybe<Scalars["Boolean"]["output"]>;
  paid_by?: Maybe<Scalars["UUID"]["output"]>;
  progress: WishListItemProgress;
  qty?: Maybe<Scalars["Int"]["output"]>;
  updated_at?: Maybe<Scalars["Time"]["output"]>;
  user?: Maybe<User>;
};

export type WishListItemContributions = {
  __typename?: "WishListItemContributions";
  contributions: Array<WishListContribution>;
  item: WishListItem;
  progress: WishListItemProgress;
};

export type WishListItemProgress = {
  __typename?: "WishListItemProgress";
  amount_contributed: Scalars["Float"]["output"];
  amount_remaining: Scalars["Float"]["output"];
  contributors_count: Scalars["Int"]["output"];
  currency: Currency;
  goal_reached: Scalars["Boolean"]["output"];
  percentage: Scalars["Float"]["output"];
  target_amount: Scalars["Float"]["output"];
};

export type WishListPresignedUrlResponse = {
  __typename?: "WishListPresignedURLResponse";
  event_id: Scalars["UUID"]["output"];
  expiry_time: Scalars["Time"]["output"];
  expiry_time_in_seconds: Scalars["Int"]["output"];
  file_uri: Scalars["String"]["output"];
  upload_url: Scalars["String"]["output"];
};

export type _Service = {
  __typename?: "_Service";
  sdl?: Maybe<Scalars["String"]["output"]>;
};

export type AddBackStoryReq = {
  image?: InputMaybe<Scalars["String"]["input"]>;
  role: BackStoryRole;
  story: Scalars["String"]["input"];
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type AddWeddingPartyReq = {
  first_name: Scalars["String"]["input"];
  image_url?: InputMaybe<Scalars["String"]["input"]>;
  last_name: Scalars["String"]["input"];
  nickname?: InputMaybe<Scalars["String"]["input"]>;
  order_index?: InputMaybe<Scalars["Float"]["input"]>;
  role: Scalars["String"]["input"];
  story?: InputMaybe<Scalars["String"]["input"]>;
};

export type AttachEventWalletToSubaccountInput = {
  currency: Currency;
  paymentProvider: PaymentProcessor;
};

export type AutoReserveTableRequest = {
  category_id?: InputMaybe<Scalars["UUID"]["input"]>;
  max_seats_per_table: Scalars["Int"]["input"];
  max_tables: Scalars["Int"]["input"];
};

export type CreateTableRequest = {
  alias?: InputMaybe<Scalars["String"]["input"]>;
  capacity: Scalars["Int"]["input"];
  category_id?: InputMaybe<Scalars["UUID"]["input"]>;
  name: Scalars["String"]["input"];
  position_x?: InputMaybe<Scalars["Float"]["input"]>;
  position_y?: InputMaybe<Scalars["Float"]["input"]>;
  radius_x?: InputMaybe<Scalars["Float"]["input"]>;
  radius_y?: InputMaybe<Scalars["Float"]["input"]>;
  type?: InputMaybe<TableType>;
};

export type ForeignAccountDetails = {
  account_number: Scalars["String"]["input"];
  bank_address?: InputMaybe<Scalars["String"]["input"]>;
  bank_name: Scalars["String"]["input"];
  beneficiary_name: Scalars["String"]["input"];
  city: Scalars["String"]["input"];
  country: Scalars["String"]["input"];
  currency: Currency;
  custom_fields?: InputMaybe<Array<AccountDetailsCustomFieldInput>>;
  event_id: Scalars["Int"]["input"];
  post_code: Scalars["String"]["input"];
  sort_code: Scalars["String"]["input"];
  swift_code: Scalars["String"]["input"];
};

export type GuestArrangement = {
  admit_index: Scalars["Int"]["input"];
  guest_id: Scalars["UUID"]["input"];
  seat: Scalars["String"]["input"];
  table: Scalars["String"]["input"];
};

export type InitiatePaymentInput = {
  customer_email: Scalars["String"]["input"];
  event_id: Scalars["UUID"]["input"];
  inawo_payment_reference: Scalars["String"]["input"];
};

export enum InvitationListFilter {
  All = "all",
  NotSent = "not_sent",
  Sent = "sent",
}

export type OypleAsoebiAttireFilter = {
  category_slugs?: InputMaybe<Array<Scalars["String"]["input"]>>;
  color_slugs?: InputMaybe<Array<Scalars["String"]["input"]>>;
  gender_slugs?: InputMaybe<Array<Scalars["String"]["input"]>>;
  max_price?: InputMaybe<Scalars["Float"]["input"]>;
  min_price?: InputMaybe<Scalars["Float"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  sort?: InputMaybe<OypleAsoebiAttireFilterSortEnum>;
};

export enum OypleAsoebiAttireFilterSortEnum {
  HighestPrice = "highest_price",
  LowestPrice = "lowest_price",
  Trending = "trending",
}

export type OypleAsoebiAttireInput = {
  aseobi_id: Scalars["UUID"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  minimum_purchase_quantity: Scalars["Int"]["input"];
  name: Scalars["String"]["input"];
  oyple_product_id: Scalars["Int"]["input"];
  profit_markup: Scalars["Float"]["input"];
};

export type PayForCashGiftRequest = {
  amount?: InputMaybe<Scalars["Float"]["input"]>;
  /** an alias for the creditor, can be any string */
  creditorAlias?: InputMaybe<Scalars["String"]["input"]>;
  /** usd/ngn this is necessary to select the wallet to credit */
  currency: Currency;
  /** email of the person paying e.g hello@inawo.com */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** id of the event, please oo! this has to be correct */
  eventID: Scalars["Int"]["input"];
  /** first_name [other_name] last_name */
  fullName?: InputMaybe<Scalars["String"]["input"]>;
  /** payment processor either monnify, paystack, flutterwave */
  paymentProcessor: PaymentProcessor;
  /** phone number of the person paying e.g +2349045057268 */
  phone?: InputMaybe<Scalars["String"]["input"]>;
  /** reference from paystack */
  reference: Scalars["String"]["input"];
  /** pending | failed => false or successful => true */
  status?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PayForSprayMoneyRequest = {
  /** the amount paid in kobo/cent depending on the currency */
  amount: Scalars["Float"]["input"];
  /** USD/NGN */
  currency: Currency;
  /** email of the person paying e.g hello@inawo.com */
  email: Scalars["Email"]["input"];
  /** id of the event, please oo! this has to be correct */
  event_id: Scalars["Int"]["input"];
  /** first_name [other_name] last_name */
  full_name: Scalars["String"]["input"];
  /** payment processor either monnify, paystack, flutterwave */
  paymentProcessor: PaymentProcessor;
  /** phone number of the person paying e.g +2349045057268 */
  phone?: InputMaybe<Scalars["E164"]["input"]>;
  /** reference from paystack */
  reference: Scalars["String"]["input"];
  /** pending | failed => false or successful => true */
  status: Scalars["Boolean"]["input"];
  /** the units to be sprayed */
  units: Scalars["String"]["input"];
};

export type PayForWishlistItemRequest = {
  /** amount in the base units e.g kobo or cents */
  amount: Scalars["Float"]["input"];
  /** an alias for the creditor, can be any string */
  creditorAlias?: InputMaybe<Scalars["String"]["input"]>;
  /** USD/NGN */
  currency: Currency;
  /** email of the person paying e.g hello@inawo.com */
  email: Scalars["Email"]["input"];
  /** id of the event, please oo! this has to be correct */
  event_id: Scalars["Int"]["input"];
  /** first_name [other_name] last_name */
  full_name: Scalars["String"]["input"];
  /** wish list item id */
  itemId: Scalars["String"]["input"];
  /** name of the wish list item */
  itemName: Scalars["String"]["input"];
  /** payment processor either monnify, paystack, flutterwave */
  paymentProcessor: PaymentProcessor;
  /** phone number of the person paying e.g +2349045057268 */
  phone?: InputMaybe<Scalars["E164"]["input"]>;
  /** reference from paystack */
  reference: Scalars["String"]["input"];
  /** pending | failed => false or successful => true */
  status: Scalars["Boolean"]["input"];
};

export type PaymentPartnerCountry = {
  __typename?: "paymentPartnerCountry";
  country_iso_alpha2: Scalars["String"]["output"];
  country_name: Scalars["String"]["output"];
};

export enum PaymentProcessor {
  Flutterwave = "flutterwave",
  Monnify = "monnify",
  Paystack = "paystack",
  Stripe = "stripe",
}

export type ReservationRequest = {
  arrangements: Array<GuestArrangement>;
};

export type RsvpResp = {
  event_id: Scalars["Int"]["input"];
  field: Scalars["String"]["input"];
  id: Scalars["Int"]["input"];
  invitation_list_id: Scalars["Int"]["input"];
  value?: InputMaybe<Scalars["String"]["input"]>;
};

export type Spray = {
  __typename?: "spray";
  unit_value: Scalars["Float"]["output"];
  units: Scalars["Int"]["output"];
};

export type SprayInput = {
  unit_value: Scalars["Float"]["input"];
  units: Scalars["Int"]["input"];
};

export type SprayMoneyResponse = {
  __typename?: "sprayMoneyResponse";
  amount: Scalars["Float"]["output"];
  created_at: Scalars["Time"]["output"];
  currency: Currency;
  payment_processor: PaymentProcessor;
  reference: Scalars["String"]["output"];
  spray_code: Scalars["String"]["output"];
  units: Scalars["Int"]["output"];
};

export type TransferFromWalletRequest = {
  accountBank: Scalars["String"]["input"];
  accountName?: InputMaybe<Scalars["String"]["input"]>;
  accountNumber: Scalars["String"]["input"];
  amount: Scalars["Float"]["input"];
  bankCode: Scalars["String"]["input"];
  currency: Currency;
  event_id: Scalars["Int"]["input"];
  narration?: InputMaybe<Scalars["String"]["input"]>;
  reference: Scalars["String"]["input"];
  walletId: Scalars["String"]["input"];
  walletPin: Scalars["String"]["input"];
};

export type UpdateBackStoryReq = {
  id: Scalars["Int"]["input"];
  image?: InputMaybe<Scalars["String"]["input"]>;
  role?: InputMaybe<BackStoryRole>;
  story?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateTableRequest = {
  alias?: InputMaybe<Scalars["String"]["input"]>;
  capacity?: InputMaybe<Scalars["Int"]["input"]>;
  category_id?: InputMaybe<Scalars["UUID"]["input"]>;
  position_x?: InputMaybe<Scalars["Float"]["input"]>;
  position_y?: InputMaybe<Scalars["Float"]["input"]>;
  radius_x?: InputMaybe<Scalars["Float"]["input"]>;
  radius_y?: InputMaybe<Scalars["Float"]["input"]>;
  table_id: Scalars["UUID"]["input"];
  type?: InputMaybe<TableType>;
};

export type UpdateWeddingPartyReq = {
  first_name?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  image_url?: InputMaybe<Scalars["String"]["input"]>;
  last_name?: InputMaybe<Scalars["String"]["input"]>;
  nickname?: InputMaybe<Scalars["String"]["input"]>;
  order_index?: InputMaybe<Scalars["Float"]["input"]>;
  role?: InputMaybe<Scalars["String"]["input"]>;
  story?: InputMaybe<Scalars["String"]["input"]>;
};
